(function() {
	angular.module('app').directive('editor', editorController)

	//removed $clipboard!?
	function editorController($routeParams, $sce, orders, user, funeralHomes, $rootScope, $q, assets, $compile, $document, cases, $timeout, themes, flowers, $location, $anchorScroll, quillService, $interval, pages, collections, orderLayouts, funeralHomeLogo, imageService, dom, scroll, domHelpers, helpers, socket, funeralHomeSettings, $animate, guests) {
		return {
			templateUrl: 'pages/editor/editor.html',
			scope: true,
			link: function(scope) {
				var vm = scope

				angular.extend(scope, {
					//Variables and Functions
					// closeLibrary: closeLibrary,
					// getPageWidth: getPageWidth,
					assetsLoading: true,
					enableQuill: enableQuill,
					quillActive: false,
					customFields: null,
					caseCustomFields: null,
					insertToEditor: insertToEditor,
					setUndoState: setUndoState,
					assetDrawer1: false,
					assetDrawer2: false,
					order: null,
					case: null,
					saving: false,
					saved: false,
					changeMade: false,
					navLock: navLock,
					singlePage: false,
					noPages: false,
					casefields: [],
					selectedCasefield: null,
					paperType: null,
					coloroptions: helpers.colorOptions,
					selectedColors: [],
					allColors: [],
					saveColor: saveColor,
					recentFontColor: false,
					recentBackgroundColor: false,
					recentBorderColor: false,
					recentTextShadowColor: false,
					recentBoxShadowColor: false,
					showRecentBackgroundColor: showRecentBackgroundColor,
					showRecentBorderColor: showRecentBorderColor,
					showRecentTextShadowColor: showRecentTextShadowColor,
					showRecentBoxShadowColor: showRecentBoxShadowColor,
					backgroundColorUpdate: backgroundColorUpdate,
					borderColorUpdate: borderColorUpdate,
					textShadowColorUpdate: textShadowColorUpdate,
					boxShadowColorUpdate: boxShadowColorUpdate,
					assetLibraries: [],
					allAssets: [],
					orderid: null,
					loading: false,
					selected: {},
					selectedFont: 'Century Gothic',
					selectedWeight: null,
					showBorderColorPicker: showBorderColorPicker,
					showBackgroundColorPicker: showBackgroundColorPicker,
					showShadowColorPicker: showShadowColorPicker,
					showTextShadowColorPicker: showTextShadowColorPicker,
          showEditImageModal: showEditImageModal,
					cropImage: {},
          editImage: {},
					crop: crop,
					selectElement: selectElement,
					//deselectElements: deselectElements,
					deleteElement: deleteElement,
					toggleBorder: toggleBorder,
					toggleDropShadow: toggleDropShadow,
					toggleTextShadow: toggleTextShadow,
					toggleBackground: toggleBackground,
					activeBackground: true,
					promptExit: promptExit,
					backToOrder: backToOrder,
					featherBox: featherBox,
					featherCircle: featherCircle,
					toggleFeather: toggleFeather,
					toggleShapeFeather: toggleShapeFeather,
					textActions: {
						leftAlignObject: leftAlignObject,
						centerVerticalAlignObject: centerVerticalAlignObject,
						rightAlignObject: rightAlignObject,
						topAlignObject: topAlignObject,
						centerHorizontalAlignObject: centerHorizontalAlignObject,
						bottomAlignObject: bottomAlignObject,
					},
					imageActions: {
						ovalShape: ovalShape,
						squareShape: squareShape
					},
					imageShape: 'square',
					placeCaseImages: placeCaseImages,
					updateSelected: updateSelected,
					canAlterPages: canAlterPages,
					uploadImage: uploadImage,
					addPicture: addPicture,
					addText: addText,
					addShape: addShape,
					addPage: addPage,
					deletePage: deletePage,
					fonts: [],
					themeImage: null,
					themeFont: null,
					save: save,
					alertText: '',
					// multiSelectAlert: multiSelectAlert,
					videoRedirect: videoRedirect,
					uploadPlaceholder: uploadPlaceholder,
					placeholderTarget: null,
					print: print,
					loadingprint: false,
					showSearch: false,
					selectedLibrary: {},
					undoStates: [],
					undoChanges: undoChanges,
          editImageProps: editImageProps,
          imageAdjustment: {},
					saveImageEdits: saveImageEdits,
					defaultImageEdited: defaultImageEdited,
          revertImage: revertImage,
          showBlendColorPicker: showBlendColorPicker,
          showMonoColorPicker: showMonoColorPicker,
          resetImageColor: resetImageColor,
					setImageRotation: setImageRotation,
					setImageFlip: setImageFlip,
          undoImageEditStates: [],
          undoImageEdits: undoImageEdits,
					funeralHomes: {},
					user: {},
					showEditBackground: showEditBackground,
					adjustBackgroundSize: adjustBackgroundSize,
					editBackgroundProps: editBackgroundProps,
					backgroundProps: {},
					watermark: null,
					secondWatermark: null,
					deleteWatermark: deleteWatermark,
					uploadWatermarkOne: uploadWatermarkOne,
					uploadWatermarkTwo: uploadWatermarkTwo,
					changeWatermarkOpacity: changeWatermarkOpacity,
					revertBackgroundImage: revertBackgroundImage,
					resetBackgroundImageColor: resetBackgroundImageColor,
					setBackgroundImageRotation: setBackgroundImageRotation,
					imageSizeAlertDismiss: imageSizeAlertDismiss,
					scrollWidth: 0,
					home: {},
					openTemplateModal: openTemplateModal,
					getWatermarkLayer: getWatermarkLayer,
					getTopLayer: getTopLayer,
					getBackgroundLayer: getBackgroundLayer,
					selectWatermark: selectWatermark,
					showBackground: false,
					themeEdits: {},
					collection: null,
					backgroundApply: false,
					applyBackground: applyBackground,
					layersAccessed: false,
					theme: {},
					setBackgroundImageFlip: setBackgroundImageFlip,
					imageSizeAlertDismiss: imageSizeAlertDismiss,
					scrollWidth: 0,
					overlayOpacity: null,
					updateOverlay: updateOverlay,
					hideOverlay: null,
					defaultTemp: null,
					tempSwitch: false,
					applyPageStyling: applyPageStyling,
					setBackgroundLayer: setBackgroundLayer,
					registerPageTitles: [],
					selectPage: selectPage,
					sortablePages: sortablePages,
					pageTitle: "",
					pageDimensions: {},
					getCurrentPage: getCurrentPage,
					pagesScrollWidth: 0,
					undoIndex: 0,
					redo: redo,
					redoState: false,
					startUndo: true,
					spaceCount: 0,
					undoAble: false,
					redoAble: false,
					getPageLocation: getPageLocation,
					compiledVerses: [],
					updatePageLocation: updatePageLocation,
					forwardPage: forwardPage,
					backPage: backPage,
					quillToolBar: [],
					quillOptions: {},
					lastPage: false,
					firstPage: true,
					showBorder: {
						object: false,
						image: true
					},
					themeObject: {},
					bgImgWidth: null,
					bgImgHeight: null,
					newQuill: newQuill,
					quill: '',
					bgImgHeight: null,
					quillWeights: {
						weights: false,
						bold: false,
						bi: false,
						ital: false,
						normal: false
					},
					quillImgUpload: false,
					quillEl: {},
					topLayer: true,
					autosave: true,
					isChrome: null,
					collection: {},
					product: {},
					layout: {},
					page_set: {},
					productPages: {},
					theme_layout: {},
					watermarks: [],
					advancedOptions: {
						basic: true,
						advanced: false
					},
					switchEditViews: switchEditViews,
					updateModal: updateModal,
					socketData: {},
					refreshSocket: refreshSocket,
					lockedCase: '',
					lockedConfirm: lockedConfirm,
					regStyle: regStyle,
					regClass: null,
					saveSuccess: {},
					newPage: null,
					pagePix: null,
					addPixPages: addPixPages,
					floralAdd: false,
					addLine: addLine,
					duplicateElement: duplicateElement,
					duplicatesOnPage: 1,
					duplicateStack: 0,
					overallDuplicates: 1,
					duplicateChain: true,
					edgeElements: {},
					snap: true,
					memorials: [],
					memorialsPages: null,
					addMemorialPages: addMemorialPages,
					isBeta: false,
					pageMax: 45,
					zoomIn: zoomIn,
					zoomOut: zoomOut,
					scale: 1,
					guests: [],
					condolencesPages: null,
					addCondolencePages: addCondolencePages,
					friendsRelativesPages: null,
					includeEmail: false,
					addFriendsRelativesPages: addFriendsRelativesPages,
					makeImgDefault: makeImgDefault
				})

				init()

				function init() {
					vm.orderid = $routeParams.orderid;
					vm.coloroptions.containerClassName = 'color-stage';
					getOrder().then(function() {
            dom.setMargin()
						$timeout(function(){
							dom.adjustPageHeight()
						},800)
						$timeout(function(){
							setUndoState()
							setPage()
						}, 3000)
					})
					getAssetCategories()
					// dom.multiSelectAlert()
					setEditorHeight()
					setDraggables()
					setMultiSelector()
					setMultiDraggables()
					setCropperDrag()
					setSelectProducts()
					setResizerDrag()
					setRotatorDrag()
					navLock()
					// detectPlaceholderUpload()
					// getUndoable()
					vm.isChrome = isChrome
					vm.isBeta = isBeta
				}

        function selectElement($event) {

					/*
					|--------------------------------------------------------------------------
					| Select Element
					|--------------------------------------------------------------------------
					| This applies the localized icons for manipulating the selected element,
					|	shows the correct editing menu, and sets the values for vm.selected. It
					| is a parent function that relies on a number of functions to execute
					| all of these tasks.
					|
					*/

					//deselectElements()
					vm.selected = {}
					vm.showBorder.object = false
					vm.showBorder.image = false
					selectNewDuplicate()
					vm.editImage = {}
          const obj = $event.target
          const selected = $(obj)
          selected.attr('tabindex', 0);
					vm.headerAllEdit = false

          if (selected.hasClass('draggable') && !selected.hasClass('multi-select')) {

						dom.deselectMultiselect()

            $('.focused .resizer').css({display: 'block'})
            $('.focused .rotator').css({display: 'block'})
            $('.focused .deletor').css({display: 'block'})

						vm.selected = {}
						vm.selected.image = false
						const type = selected.data('type')
						if (type !== 'image') {
							vm.showBorder.object = false
							vm.showBorder.image = false
						}

						getAllComputedStyles(obj)
						changeRegisterBookHeaders(selected)
						handleTypesOfSelected(selected, type, $event)
						showCorrectElementIcons(selected)
						getFeatheredEdges(selected)
						getBoxShadow(selected)
						getTextShadow(selected)
						getRotationAngle(selected)
						getBorder(selected)
						dom.positionResizer()
						dom.positionRotator()
						dom.positionDelete()
            vm.selected.opacity = parseFloat(selected.css('opacity'))
            vm.selected.opacity = (vm.selected.opacity * 100)
            vm.selected.borderradius = parseInt(selected.css('border-radius'))

            const font = selected.css('font-family').replace(/"/g, '')
            for(var i in helpers.fonts){
              if(helpers.fonts[i].name == font){
                vm.selectedFont = i
              }
            }

            vm.selected.element = obj
            vm.selected.selector = selected
            $('.element').removeClass('selected')
            selected.addClass('selected')
          }
					const font = selected.css('font-family').replace(/"/g, '')
					if (!selected.hasClass('oldQuill') && !selected.hasClass('quill')) {
						for (let i in helpers.fonts) {
							if (helpers.fonts[i].name == font) {
									for (let k in helpers.fonts[i].weights) {
										if (selected.css('font-weight') == helpers.fonts[i].weights[k].weight) {
											vm.selectedWeight = k
										}
									}
								// updateFont(i)
							}
						}
					}
					$('.sw.bg').css('background', vm.selected.backgroundColor)
					$('.sw.bdr').css('background', vm.selected.bordercolor)
					$('.sw.font').css('background', vm.selected.color)

					//determines if the element is a circle or not
					$(vm.selected.element).css('border-radius') == '50%' ? vm.imageShape = 'oval' : vm.imageShape = 'square'
        }

				function changeRegisterBookHeaders(selected) {
					vm.tip = {}
					if(selected.hasClass('large-header')) vm.tip.cta = "Apply to all large headers"
					if(selected.hasClass('medium-header')) vm.tip.cta = "Apply to all medium headers"
					if(selected.hasClass('small-header')) vm.tip.cta = "Apply to all small headers"
					if(selected.hasClass('verse-body')) vm.tip.cta = "Apply to all verse text"
					if(selected.hasClass('casefield-body')) vm.tip.cta = "Apply to all deceased person details"
				}

				function showCorrectElementIcons(selected) {
					$('*').removeClass('resizer-target')
					selected.addClass('resizer-target')
					$('*').removeClass('rotator-target')
					selected.addClass('rotator-target')
					$('*').removeClass('deletor-target')
					selected.addClass('deletor-target')
				}

				function handleTypesOfSelected(selected, type, $event) {
					if (type == 'image') {
						vm.action_type = 'image'
						vm.selected.text = 'Image'
					} else if (type == 'text') {
						//Show correct Action bar
						vm.action_type = 'text'
						vm.selected.text = 'Text Box'
						$('*').removeClass('font-target')
						selected.addClass('font-target')
					} else if (type == 'shape') {
						vm.action_type = 'shape'
						vm.selected.text = 'Shape'
					} else {
						$('.focused .resizer').css('display', 'none')
					}
				}

				function getAllComputedStyles(obj) {
					const styles = dom.getAllStyles(obj)
					for (let i in styles) {
						let values = styles[i].split(':')
						values[0] = values[0].replace(/-/g, '')
						if (isNaN(parseInt(values[1]))) {
							vm.selected[values[0]] = values[1]
						} else {
							vm.selected[values[0]] = parseInt(values[1])
						}
					}
				}

				function getFeatheredEdges(selected) {
					if(selected.hasClass('feathered')) {
						vm.selected.feathered = true
					}
					// var hasFeatherParams = selected.css('background-image').split('?')
					// if (hasFeatherParams[1] || selected.css('box-shadow') !== 'none') {
					// 	var shadowColor = selected.css('box-shadow').replace(/^.*(rgba?\([^)]+\)).*$/, '$1')
					// 	if (shadowColor == selected.css('background-color')) {
					// 		vm.selected.feathered = true
					// 	}
					// }
				}

				function getBoxShadow(selected) {
					if (selected.css('box-shadow') !== 'none') {
						let shadowColor = selected.css('box-shadow').replace(/^.*(rgba?\([^)]+\)).*$/, '$1')
						if (shadowColor !== selected.css('background-color')) {
							let boxshadow = selected.css('box-shadow').replace(/, /g, ',').split(' ')
							let opacity = parseInt(parseFloat(boxshadow[0].replace('rgba(', '').replace(')', '').split(',')[3]) * 100)
							vm.selected.dropshadow = true
							vm.selected.boxshadow = {}
							vm.selected.boxshadow.left = parseInt(boxshadow[1])
							vm.selected.boxshadow.top = parseInt(boxshadow[2])
							vm.selected.boxshadow.blur = parseInt(boxshadow[3])
							vm.selected.boxshadow.spread = parseInt(boxshadow[4])
							vm.selected.boxshadow.opacity = opacity
							vm.selected.boxshadow.color = dom.rgb2hex(boxshadow[0])
						}
					}
				}

				function getTextShadow(selected){
					if (selected.css('text-shadow') !== 'none') {
						let textshadow = selected.css('text-shadow').replace(/, /g, ',').split(' ')
						let opacity
						if (parseInt(parseFloat(textshadow[0].replace('rgba(', '').replace('rgb(', '').replace(')', '').split(',')[3]) * 100)) {
							opacity = parseInt(parseFloat(textshadow[0].replace('rgba(', '').replace('rgb(', '').replace(')', '').split(',')[3]) * 100)
						} else {
							opacity = 100
						}
						vm.selected.textshadow = {}
						vm.selected.textshadow.active = true
						vm.selected.textshadow.left = parseInt(textshadow[1])
						vm.selected.textshadow.top = parseInt(textshadow[2])
						vm.selected.textshadow.blur = parseInt(textshadow[3])
						vm.selected.textshadow.opacity = opacity
						vm.selected.textshadow.color = dom.rgb2hex(textshadow[0])
					}
				}

				function getBorder(selected) {
					if (selected.css('border') !== 'none') {
						vm.selected.border = {}
						vm.selected.border.color = selected.css('border-left-color')
						vm.selected.border.type = selected.css('border-left-style')
						vm.selected.border.thickness = parseInt(selected.css('border-left-width'))
					}
				}

				function getRotationAngle(selected) {
					if (selected.css('transform') && selected.css('transform') !== 'none') {
						var values = selected.css('transform').split('(')[1].split(')')[0].split(',')
						var a = values[0];
						var b = values[1];
						var c = values[2];
						var d = values[3];
						var scale = Math.sqrt(a * a + b * b);
						var sin = b / scale;
						var angle = Math.round(Math.atan2(b, a) * (180 / Math.PI))
						vm.selected.rotate = angle
					}
				}

        function updateSelected(change) {
          setUndoState()
					recentColorGenerator()
					let selected = $('.multi-select')

					if (!selected.length) {
						if($(vm.selected.element).hasClass('large-header') && vm.headerAllEdit == true){
							selected = $('.large-header')
						} else if($(vm.selected.element).hasClass('medium-header') && vm.headerAllEdit == true){
							selected = $('.medium-header')
						} else if($(vm.selected.element).hasClass('small-header') && vm.headerAllEdit == true){
							selected = $('.small-header')
						} else if($(vm.selected.element).hasClass('verse-body') && vm.headerAllEdit == true){
							selected = $('.verse-body')
						} else if($(vm.selected.element).hasClass('casefield-body') && vm.headerAllEdit == true){
							selected = $('.casefield-body')
						}else if ($(vm.selected.element).hasClass('oldQuill')) {
								selected = $(vm.selected.element);
								$(this).data('type', 'text')
						}else {
							selected = $(vm.selected.element);
						}
					}
          const type = selected.data('type')
          vm.saved = false

          //Global
					if(vm.headerAllEdit){
						selected.css({
							'border-radius': vm.selected.borderradius + 'px',
							opacity: vm.selected.opacity / 100,
							webkitTransform: 'rotate(' + vm.selected.rotate + 'deg)',
							'background-color': vm.selected.backgroundcolor,
							'color': vm.selected.color,
							'font-family': vm.selected.fontfamily,
							'font-weight': vm.selected.fontweight
						})
					} else if (selected.length <= 1){
						selected.css({
							zIndex: vm.selected.zindex,
							// 'border-radius': vm.selected.borderradius + 'px',
							opacity: vm.selected.opacity / 100,
							webkitTransform: 'rotate(' + vm.selected.rotate + 'deg)',
							'background-color': vm.selected.backgroundcolor,
						})
						if($(this).data('oval') == true || $(this).hasClass('oval')) {
							$(this).css({'border-radius': '50%'})
						} else {
							$(this).css({'border-radius': vm.selected.borderradius + 'px'})
						}
					}


          if (vm.selected.dropshadow) {
            let shadow = vm.selected.boxshadow.left + 'px ' + vm.selected.boxshadow.top + 'px ' + vm.selected.boxshadow.blur + 'px ' + vm.selected.boxshadow.spread + 'px ' + dom.convertHex(vm.selected.boxshadow.color, vm.selected.boxshadow.opacity)
            selected.css({
              'box-shadow': shadow
            })
          }
          if (vm.selected.textshadow) {
						if(vm.selected.textshadow.active) {
	            var shadow = vm.selected.textshadow.left + 'px ' + vm.selected.textshadow.top + 'px ' + vm.selected.textshadow.blur + 'px ' + dom.convertHex(vm.selected.textshadow.color, vm.selected.textshadow.opacity)
	            selected.css({
	              'text-shadow': shadow
	            })
						}
          } else {
						selected.css({
							'text-shadow': 'none'
						})
					}
          if (vm.selected.border && vm.selected.border.type && vm.selected.border.thickness && vm.selected.border.color) {
						const urlBase = vm.selected.selector
							.css("background-image")
              .replace("url(", "")
              .replace(")", "")
              .replace(/\"/gi, "")
              .split('.net/')

						const urlPath = urlBase.shift() + '.net'
						const urlFile = urlBase.join('.net/')

						if(selected.hasClass('caseImage, image, logoImage')) {
							let backgroundFileName = vm.selected.selector.css('background-image').replace('url(', '').replace(')', '').replace(helpers.imgixBase, '').replace(helpers.awsUploads, '').replace(/"/g, '')

		          if(vm.selected.selector.hasClass('feathered')) {
		            backgroundFileName = vm.selected.selector.css('background-image').replace('url(', '').replace(')', '').replace(helpers.imgixBase, '').replace(helpers.awsUploads, '').replace(/"/g, '')
		          }
							var url = backgroundFileName
						}
						selected.css({
							'border': vm.selected.border.type + ' ' + vm.selected.border.thickness + 'px ' + vm.selected.border.color
						})

						if(selected.hasClass('oldQuill')) {
							let height = parseInt(selected.css('height')) + (vm.selected.border.thickness) + 'px'
							// adjustHeight()
							// selected.css({
							// 	'height': 'auto',
							// })
						}
          } else {
						selected.css('border', 'none')
          }

					//Type Specific
					if (type == 'image') {
						vm.selected.height = parseInt(selected.css('height'))
					} else if (type == 'text' || selected.length) {
						// var font = $('.multi-select')
	          // if (!font.length) {
	          //   font = $(vm.selected.element);
	          // }
						// selected.css('height', vm.selected.height + 'px') // Commented out by PB on 2/3/18
						selected.css('font-size', vm.selected.fontsize + 'px')
						if(vm.selected.fontsize) {
							// adjustHeight()
						}
						if (change == 'rgb') {
							vm.selected.fontcolor = dom.rgbToHex(vm.selected.fontrgbcolor.r, vm.selected.fontrgbcolor.g, vm.selected.fontrgbcolor.b)
						}
						selected.removeClass('default-font-color')
						selected.css('color', vm.selected.fontcolor)
						selected.css('font-family', vm.selectedFont)
						vm.selected.fontrgbcolor = dom.hex2rgb(vm.selected.fontcolor)
						vm.selected.textdecoration && vm.selected.textdecoration.indexOf('none') < 0 ? selected.css('text-decoration', 'underline') : selected.css('text-decoration', 'none')
						if (vm.selectedCasefield) {
							var newText = $compile(`<p placeholder="New Text Field" class="draggable element" ng-click="selectElement($event)" data-type="text" data-caseinfo="${vm.selectedCasefield}" style="position:absolute; background:rgba(0,0,0,0); border:none; width: ${selected.css('width')}; height:${selected.css('height')}; top:${selected.css('top')}; left: ${selected.css('left')}; color:${selected.css('color')}; font-family:${selected.css('font-family')}; font-size: ${selected.css('font-size')}; text-align:${selected.css('text-align')};">{{${vm.selectedCasefield}}}</p>`)(vm)

							selected.remove()
							$('.product .focused .outlines').append(newText)
							vm.selectedCasefield = undefined
						}
					} else if (type == 'shape') {
						selected.css('height', vm.selected.height + 'px')
					}
					dom.positionResizer()
					dom.positionDelete()
					dom.positionRotator()
				}

				function canAlterPages() {
					if (
						vm.product.name === "Register Book"
					) {
						return true;
					} else if (
						vm.product.name === "Deluxe Register Book"
					) {
						return true;
					} else if (
						vm.product.name === "Register Book: Extra Pages"
					) {
						return true;
					} else if (
						vm.product.name === "Service Records"
					) {
						return true;
					} else if (
						vm.collection.name === "Precious Memories" &&
						vm.product.name === "Church Bulletins"
					) {
						return true;
					} else if (
						vm.collection.name === "Precious Memories" &&
						vm.product.name === "Directory Signs" &&
						vm.layout.name === "Full Sheet"
					) {
						return true;
					} else {
						return false;
					}
				}

				// Page Actions
				
        function uploadPlaceholder($event) {
          vm.placeholderTarget = $event.target
          if ($(vm.placeholderTarget).css('background-image') == 'none') {
            $timeout(function() {
              document.getElementById('upload_placeholder').click()
            }, 10)
          }
				}
				
				function totalPages() {
					return $('#editor .product .printedarea').length - 1
				}

        function removePage(elm) {
          vm.editingPage.parent().next().remove()
          vm.editingPage.parent().remove()
          $('#editModal').modal('hide')
        }

        function deletePage(page, addPage, multiple) {
					return $q(function(resolve, reject) {
						if(page === 0 || page === 1) setBGPattern()
						if(!vm.deletingPage || multiple) {
							vm.deletingPage = true
							$.each($('.printedarea'), function(index) {
		
								if(index == page) {
									if($(this).hasClass('focused')) {
										$(this).removeClass('focused')
									}
									pages.archiveOrderPage($(this).attr('data-page-id')).then(response => {
										if(response.status != 200) {
											//do nothing - they will try again
										} else {
											$(this).remove()
											adjustRBBackgrounds(page, 0, 'delete')
											let newpages = vm.pages.filter(item => item.id != $(this).attr('data-page-id'))
											vm.pages = newpages
											if(!addPage) {
												$('#editor .product .printedarea').first().addClass('focused')
											}
											vm.singlePage = totalPages() <= 0
										}
									$timeout(function(){
										vm.registerPageTitles = []
										scope.$apply()
										pageTitle()
										scope.$apply()
										if(vm.product.name.includes("Register Book")) {
											getPageLocation()
										}
										if(vm.pages.length === 0) {
											vm.noPages = true
											preventNav(true)
											noPageNavLock()
											getPageLocation()
										} else {
											preventNav(false)
										}
										!multiple && save()
										vm.deletingPage = false
									}, 200)
									resolve(true)
								})
								}
							})
						}
						
					})
        }

				function shufflePage(element, currentIndex, newIndex) {
					if (newIndex === 0 || newIndex === 1 || currentIndex === 0 || currentIndex === 1) setBGPattern()
					let nextSib = $('.printedarea')[newIndex]
					let lastPage = $('.printedarea')[$('#editor .product .printedarea').length - 1]

					// determine if page is being dragged to the end or not
					newIndex === undefined ? $(element).insertAfter(lastPage) : $(element).insertBefore(nextSib)

					// update the page number
					newIndex > currentIndex ? newIndex = newIndex -1 : newIndex = newIndex
					adjustRBBackgrounds(newIndex, currentIndex, 'shuffle')
				}

				// Action Bar
				
        function toggleBorder() {
					// prevents border adjustment for feathered circle
					if(vm.selected.selector.hasClass('feathered') && vm.selected.selector.css('border-radius') == '50%') {return}

					if(vm.selected.selector.data('type') !== 'image') {
						if(vm.showBorder.object) {
							vm.showBorder.object = false
							if (vm.selected.border && vm.selected.border.type) {
		            vm.selected.border.type = null
		            vm.selected.border.thickness = null
		            vm.selected.border.color = null
		          }
						} else {
							vm.showBorder.object = true
							vm.showBorder.image = false

							let borderWidth = vm.selected.selector[0].style.borderWidth
							let borderColor = vm.selected.selector[0].style.borderColor
							let borderStyle = vm.selected.selector[0].style.borderStyle
							if(borderStyle === 'none') {
								borderStyle = 'solid'
								borderWidth = '1px'
								borderColor = '#000000'
							}
	            vm.selected.border = {}
	            vm.selected.border.type = borderStyle
	            vm.selected.border.thickness = parseInt(borderWidth)
	            vm.selected.border.color = borderColor

		          updateSelected()
						}
					} else {
						vm.showBorder.object = false;
						vm.showBorder.image = true
						showEditImageModal(false)
					}
        }

        function toggleFeather() {
					localStorage.removeItem('defaultImgUpdated')
          if (vm.selected.feathered || $(vm.selected.element).attr('data-feathered')) {

            removeFeather()
            $(vm.selected.element).removeClass('feathered')
            $(vm.selected.element).removeAttr('data-feathered')
            vm.selected.feathered = false
          } else {
						if($(vm.selected.selector).hasClass('oval') || $(vm.selected.selector).attr('data-oval')) {
							featherCircle()
						} else {
							featherBox()
						}
            $(vm.selected.element).addClass('feathered')
            $(vm.selected.element).attr('data-feathered', 'true')
            vm.selected.feathered = true
          }
        }

        function toggleShapeFeather() {
          if (vm.selected.feathered) {
            $(vm.selected.element).css('box-shadow', 'none')
            vm.selected.feathered = false
          } else {
            let color = dom.rgb2hex($(vm.selected.element).css('background-color'))
            $(vm.selected.element).css('box-shadow', '0px 0px 10px 6px' + color)
            vm.selected.feathered = true
          }
        }

        function toggleDropShadow() {
					var selected = $('.multi-select')
					if (!selected.length) {
						selected = $(vm.selected.element);
					}
          if (vm.selected.dropshadow) {
            $(selected).css('box-shadow', 'none')
            vm.selected.dropshadow = false
          } else {
            vm.selected.boxshadow = {}
            vm.selected.boxshadow.left = 0
            vm.selected.boxshadow.top = 0
            vm.selected.boxshadow.blur = 3
            vm.selected.boxshadow.spread = 0
            vm.selected.boxshadow.opacity = 30
            vm.selected.boxshadow.color = '#000000'
            $(selected).css('box-shadow', '' + vm.selected.boxshadow.left + 'px ' + vm.selected.boxshadow.top + 'px ' + vm.selected.boxshadow.blur + 'px ' + vm.selected.boxshadow.spread + 'px ' + dom.convertHex(vm.selected.boxshadow.color, vm.selected.boxshadow.opacity))
            vm.selected.dropshadow = true
          }
        }

        function toggleTextShadow() {
					if(vm.selected.textshadow === undefined) {
						vm.selected.textshadow = {}
						vm.selected.textshadow.active = false
					}
					let selected = $('.multi-select')
					if (!selected.length) {
						selected = $(vm.selected.element);
					}
          if (vm.selected.textshadow.active) {
            $(selected).css('text-shadow', 'none')
            vm.selected.textshadow.active = false
          } else {
            vm.selected.textshadow = {}
            vm.selected.textshadow.left = 1
            vm.selected.textshadow.top = 1
            vm.selected.textshadow.blur = 1
            vm.selected.textshadow.opacity = 30
            vm.selected.textshadow.color = '#000000'
            $(selected).css('text-shadow', '' + vm.selected.textshadow.left + 'px ' + vm.selected.textshadow.top + 'px ' + vm.selected.textshadow.blur + 'px ' + dom.convertHex(vm.selected.textshadow.color, vm.selected.textshadow.opacity))
            vm.selected.textshadow.active = true
          }
        }

        function deleteElement() {
					domHelpers.deleteElement(vm.selected.element)
					setUndoState();
				}

				function selectNewDuplicate() {
					// removes any duplicate classes
					if(vm.duplicateChain) {
						$.each($('#editor .product .printedarea .outlines > *'), function(index) {
							// destroy all previous duplicate tags
							if($(this).hasClass('duplicate')) {
								$(this).removeClass('duplicate')
								$(this).removeAttr('duplicate')
								$(this).removeAttr('stack')
								$(this).removeAttr('duplicateId')
							}
						})

						// capture the outline dimensions
						if(!vm.outlineWidth) vm.outlineWidth = $('#editor .product .printedarea .outlines').width()
						if(!vm.outlineHeight) vm.outlineHeight = $('#editor .product .printedarea .outlines').height()

						// resets duplicate variables when a new element is selected
						vm.selectedElementPage = getCurrentPage()
						vm.duplicateOriginPage = getCurrentPage()
						vm.duplicateChain      = false
						vm.overallDuplicates   = 1
						vm.duplicatesOnPage    = 1
						vm.duplicateStack      = 0
						vm.edgeElements        = {}
					}
				}

				function duplicateElement() {
					// Need to account for if element to duplicate is WITHIN a Quill textbox
					const elemParent = $(vm.selected.element).parent()
					vm.duplicatingPage = getCurrentPage()

					// captures the original element's position
					if(!vm.duplicateChain) {
						vm.duplicatesOnPage = 1
						vm.duplicateOrigin  = {
							top     : parseInt($(vm.selected.element).css('top')),
							left    : parseInt($(vm.selected.element).css('left')),
							width   : parseInt($(vm.selected.element).css('width')),
							height  : parseInt($(vm.selected.element).css('height')),
							zindex  : parseInt($(vm.selected.element).css('z-index'))
						}
					}

					// detect if shape is already in the top left corner, so it does not stack over itself
					if (vm.duplicateOrigin.left == 0 && vm.duplicateStack < 1) vm.duplicateStack = 1

					// detect when pages are switched, and reset positioning
					if(vm.duplicatingPage != vm.selectedElementPage) {
						vm.duplicatesOnPage = 0
						vm.duplicateStack   = 0
					}

					if(elemParent.hasClass('ql-editor')) {
						// clones elements within quill textbox
						$(vm.selected.element)
							.clone(true)
							.addClass(`duplicate`)
							.attr('duplicate', vm.duplicatesOnPage)
							.attr(`stack`, vm.duplicateStack)
							.attr(`duplicateId`, vm.overallDuplicates)
							.appendTo($(vm.selected.element)
							.parent()
						)
					} else {
						// clones general elements
						$(vm.selected.element)
							.clone(true)
							.addClass(`duplicate`)
							.attr('duplicate', vm.duplicatesOnPage)
							.attr(`stack`, vm.duplicateStack)
							.attr(`duplicateId`, vm.overallDuplicates)
							.appendTo('#editor .product .focused .outlines')
					}

					// apply the offest to all duplications
					$.each($('#editor .product .printedarea .outlines > *'), function(index) {
						if($(this).hasClass('duplicate')) {
							const duplicate = parseInt($(this).attr('duplicate'))
							const stack = parseInt($(this).attr('stack'))
							const id = parseInt($(this).attr('duplicateId'))
							$(this).css(positionDuplicate(duplicate, stack, id))
						}
					})

					// set variables for next cycle
					vm.selectedElementPage = vm.duplicatingPage
					vm.duplicatesOnPage   += 1
					vm.overallDuplicates  += 1
					vm.duplicateChain      = true

					setUndoState()
				}

				function positionDuplicate(duplicate, stack, id) {
					const offsetAmount = 10

					// outline dimensions
					const outlineWidth  = vm.outlineWidth,
								outlineHeight = vm.outlineHeight

					// most recent duplicate positions
					const topEdge    = stack == 0 ? vm.duplicateOrigin.top    + (duplicate * offsetAmount) : (duplicate * offsetAmount),
								leftEdge   = stack == 0 ? vm.duplicateOrigin.left   + (duplicate * offsetAmount) : ((stack - 1) * offsetAmount) + (duplicate * offsetAmount),
								rightEdge  = stack == 0 ? vm.duplicateOrigin.width  + vm.duplicateOrigin.left + (duplicate * offsetAmount) : vm.duplicateOrigin.width  + (duplicate * offsetAmount),
								bottomEdge = stack == 0 ? vm.duplicateOrigin.height + vm.duplicateOrigin.top  + (duplicate * offsetAmount) : vm.duplicateOrigin.height + (duplicate * offsetAmount)

					// conditions for starting a new stack
					const edgeElement   = vm.edgeElements[id],
								exceedsBounds = (bottomEdge > outlineHeight || rightEdge > outlineWidth)

					// starts a new stack if element exceeds the bounds
					if(exceedsBounds && !edgeElement) {
						vm.edgeElements[id] = true
						vm.duplicatesOnPage = -1
						vm.duplicateStack += 1
					}

					// apply the element's position
					return {
						'top'     : `${topEdge}px`,
						'left'    : `${leftEdge}px`,
						'z-index' : `${vm.duplicateOrigin.zindex + duplicate}`
					}
				}

        function crop() {
          //determine which crop area to use
          let backgroundFileName, crop, query
          if(vm.cropImage.modal === 'editImage') {
            crop = $('.crop-area-edit')
          } else {
            crop = $('.crop-area')
          }
          let wrapper = $('.crop-wrapper')
          if(vm.cropImage.modal === 'editImage') {
            backgroundFileName = vm.editImage.url
          } else {
            backgroundFileName = vm.selected.selector.css('background-image').replace('url(', '').replace(')', '').split('.net/').pop().replace('"', '')
          }
          if(vm.cropImage.modal === 'editImage') {
            vm.undoImageEditStates.push(backgroundFileName)
          }
          //seperate file url from current query params
          let fileQuery = backgroundFileName.split('?')
          backgroundFileName = fileQuery[0]

          //remove current crop from query params
					if(fileQuery.length > 1) {
	          if(fileQuery[1].indexOf('rect') != -1) {
	            query = fileQuery[1].split('?').pop().split('&')
	            for(let i in query) {
	              if(query[i].indexOf('rect') != -1){
	                query.splice(i, 1)
	              }
	            }
	            query = query.join('&')
	            if(query.charAt(0) != '&') {
	              query = '&' + query
	            }
	            backgroundFileName = backgroundFileName.split('?').shift()
	          } else {
	            query = "&" + fileQuery[1]
	          }
					} else {
						query = ""
					}

          const newImage = new Image();
          newImage.src = backgroundFileName;

          //Need to get width and height of original imageg to get ratio for imgix rect function
          $(newImage).load(function() {
            let ratio = (newImage.width / parseInt(wrapper.css('width')))
            //Imgix rect funtion needs values that have no decimals
            let x = (parseInt(crop.css('left')) * ratio).toFixed(0)
            let y = (parseInt(crop.css('top')) * ratio).toFixed(0)
            let width = (parseInt(crop.css('width')) * ratio).toFixed(0)
            let height = (parseInt(crop.css('height')) * ratio).toFixed(0)
						vm.imageAdjustment.rect =  x + ',' + y + ',' + width + ',' + height
            let cropQuery = "rect=" + x + ',' + y + ',' + width + ',' + height + "&"

            let croppedBackground =  backgroundFileName + '?'+ cropQuery  + query
            if(vm.cropImage.modal != 'editImage') {
              vm.selected.selector.css({
                width: crop.css('width'),
                height: crop.css('height'),
                background: 'url(' + croppedBackground + ')',
                'background-size': 'cover'
              })
            }
            vm.selected.selector.addClass('cropped')
            dom.positionResizer()
            dom.positionRotator()
            dom.positionDelete()

            if(vm.cropImage.modal != 'editImage') {
              $('#cropImageModal').modal('hide')
            } else {
              // showEditImageModal()
              if (crop.css('width') > 450) {
                width = '450px'
                height = 450 * (crop.css('height') / crop.css('width'))
              } else {
                width = crop.css('width')
                height = crop.css('height')
              }

              $timeout(function() {
                vm.editImage = {
                  url: backgroundFileName + '?' + cropQuery + query,
                  width: width,
                  height: height,
                  modalHeight: Math.max((parseInt(height) + 100), (parseInt(width)+ 100)),
                  modalWidth: Math.max((parseInt(height) + 400), (parseInt(width)+ 400)),
                  wrapperWidth: (Math.max((parseInt(height) + 400), (parseInt(width)+ 400)) - 250)
                }
                $('#edit_image').load()
								setUndoState()
              }, 100)
            }
          })
        }

        function toggleBackground() {
          if (vm.activeBackground) {
            $('.theme').css('display', 'none')
            vm.activeBackground = false
          } else {
            $('.theme').css('display', 'block')
            vm.activeBackground = true
          }
					setUndoState()
        }

				// Colors
				
				function showRecentFontColor() {
					vm.recentFontColor = true
				}

				function showRecentBackgroundColor() {
					vm.recentBackgroundColor = true
				}

				function showRecentBorderColor() {
					vm.recentBorderColor = true
				}

				function showRecentTextShadowColor() {
					vm.recentTextShadowColor = true
				}

				function showRecentBoxShadowColor() {
					vm.recentBoxShadowColor = true
				}

				function saveColor(color) {
					vm.recentFontColor = false
					vm.recentBackgroundColor = false
					vm.recentBorderColor = false
					vm.recentTextShadowColor = false
					vm.recentBoxShadowColor = false
					let selectColor = vm.allColors.pop()
					vm.selectedColors.push(selectColor)
					vm.selectedColors = _.uniq(vm.selectedColors)
					vm.selectedColors = vm.selectedColors.filter(function(c){
						return c !== ''
					})
				}

				function backgroundColorUpdate(color){
					const selected = $(vm.selected.element)
					selected.css({backgroundColor: color})
				}

				function borderColorUpdate(color){
					let selected = $(vm.selected.element)
					if (vm.selected.border && vm.selected.border.type && vm.selected.border.thickness && color) {
						selected.css('border', vm.selected.border.type + ' ' + vm.selected.border.thickness + 'px ' + color)
					} else {
						selected.css('border', 'none')
					}
				}

				function textShadowColorUpdate(color){
					let selected = $(vm.selected.element)
					if (vm.selected.textshadow.active) {
						let shadow = vm.selected.textshadow.left + 'px ' + vm.selected.textshadow.top + 'px ' + vm.selected.textshadow.blur + 'px ' + dom.convertHex(color, vm.selected.textshadow.opacity)
						selected.css({
							'text-shadow': shadow
						})
					}
				}

				function boxShadowColorUpdate(color){
					var selected = $(vm.selected.element)
					if (vm.selected.dropshadow) {
						var shadow = vm.selected.boxshadow.left + 'px ' + vm.selected.boxshadow.top + 'px ' + vm.selected.boxshadow.blur + 'px ' + vm.selected.boxshadow.spread + 'px ' + dom.convertHex(color, vm.selected.boxshadow.opacity)
						selected.css({
							'box-shadow': shadow
						})
					}
				}

				function recentColorGenerator(){
					let c = ''
					if(vm.selected.backgroundcolor) c = vm.selected.backgroundcolor
					else if(vm.selected.fontcolor) c = vm.selected.fontcolor
					else if(vm.selected.border && vm.selected.border.type && vm.selected.border.thickness && vm.selected.border.color) {
						c = vm.selected.border.color
					}
					else if(vm.selected.textshadow) c = vm.selected.textshadow.color
					else if (vm.selected.dropshadow) c = vm.selected.boxshadow.color
					vm.allColors.push(c)
				}

        function showBorderColorPicker(e) {
          e.stopPropagation()
          vm.showBorderColor = !vm.showBorderColor
        }

        function showShadowColorPicker(e) {
          e.stopPropagation()
          vm.showShadowColor = !vm.showShadowColor
        }

        function showBackgroundColorPicker(e) {
          e.stopPropagation()
          vm.showBackgroundColor = !vm.showBackgroundColor
        }

        function showTextShadowColorPicker(e) {
          e.stopPropagation()
          vm.showTextShadowColor = !vm.showTextShadowColor
        }

        function showBlendColorPicker(e) {
          e.stopPropagation()
          vm.showBlendColor = !vm.showBlendColor
        }

        function showMonoColorPicker(e) {
          e.stopPropagation()
          vm.showMonoColor = !vm.showMonoColor
        }

				// Images
				
        function uploadImage() {
          $timeout(function() {
            document.getElementById('editor_image_file').click()
          }, 10)
        }

				const editorUpload = $rootScope.$on('editorCaseUpload', function(event, payload){
					if(vm.case.personal_images) {
						vm.case.personal_images.push(payload)
					} else {
						vm.case.personal_images = [ payload ]
					}
					let imgWidth
					let imgHeight
					var img = new Image()
					img.src = "https://bassmollett-case.imgix.net/" + payload
					img.onload = function () {
						imgWidth = this.width/2
						imgHeight = this.height/2
						var image = $compile(`<div style="background-image: url(${helpers.imgixCase}${payload}?or=0); width:${imgWidth}px; height:${imgHeight}px;background-size:100% 100%; border-radius:2px; z-index:10; position: absolute; cursor: pointer; opacity: 1; top: 0px; left: 0px;" data-type="image" ng-click="selectElement($event)" class="draggable element ng-scope image"></div>`)(vm)
						$('#editor .product .focused .outlines').append(image)
						dom.sizeImage(image)
					}

				})

				vm.$on('$destroy', () => {
          editorUpload()
        })

				// Asset Menu

				function addPicture(file, loading, upload) {
					vm.showAssets = false
					let img = new Image()
					img.src = helpers.imgixCase + file
					img.onload = function () {
					}
					let image = $compile(`<div style="background-image: url(${helpers.imgixCase}${file}?or=0); background-size:100% 100%; border-radius:2px; z-index:10; position: absolute; cursor: pointer; opacity: 1; top: 0px; left: 0px;" data-type="image" ng-click="selectElement($event)" class="draggable element ng-scope image"></div>`)(vm)
          $('#editor .product .focused .outlines').append(image)
          if (loading) {
            vm.loading = true
          }
          dom.sizeImage(image, loading,  upload)
					vm.quillImgUpload = false
					setUndoState();
        }

				function setPage() {
					vm.newPage = $('#editor .product .printedarea:last-child').prop('outerHTML')
					!vm.pageSettings && (vm.pageSettings = Object.assign({}, vm.pages[0]))
				}

				function addPage() {
					if($('#editor .product .printedarea').length < 3) setBGPattern()
					if($('#editor .product .printedarea').length < vm.pageMax) {

						// determine whether new page template is available. if not create one
						!vm.newPage && setPage()

						// create the elements to be inserted
						const el      = $compile(vm.newPage)(vm)
						const rotator = $compile('<i class="glyphicon glyphicon-repeat rotator"></i>')(vm)
						const resizer = $compile('<i class="glyphicon glyphicon-fullscreen resizer"></i>')(vm)
						const deletor = $compile('<i class="icon-delete-circle deletor" ng-click="deleteElement()"></i>')(vm)
						const outline = $compile(`<div class="middle"></div>`)(vm)

						// determines if any pages exist, then append/insert the new page to the appropriate element
						$('#editor .product .printedarea:last-child').length
							? $(el).insertAfter($('#editor .product .printedarea:last-child')[0])
							: $('#editor .product').append($(el))

						// remove all elements from the newly created page
						canAlterPages() && $('#editor .product .printedarea:last-child .outlines').children().remove()

						// add the divider to new church bulletin pages
						vm.product.name.includes('Church Bulletins') && (vm.layout.name.includes('Full Bleed') || vm.layout.name.includes('White Border'))
							&& $('#editor .product .printedarea:last-child .outlines')[0].append(outline[0])

						// adjust the backgrounds for full bleed register books
						adjustRBBackgrounds(totalPages(), 0, 'add')

						// append the rotator, resizer, and deletor to the new page's outlines
						$('#editor .product .printedarea .outlines').last().append(rotator)
						$('#editor .product .printedarea .outlines').last().append(resizer)
						$('#editor .product .printedarea .outlines').last().append(deletor)

						const payloadPage = $('#editor .product .printedarea:last-child').prop('outerHTML')

						$timeout(function(){
							vm.registerPageTitles = []
							scope.$apply()
							pageTitle()
							scope.$apply()
							getPageLocation()
							updatePageLocation()
						}, 200)
						let payload = Object.assign({}, vm.pageSettings)
						payload.template = payloadPage
						payload.page_number = vm.pages.length + 1
						delete payload.id
						delete payload.archived
						pages.createOrderPageDetails(payload).then(response => {
							adjustRBBackgrounds(0, 0, false)
							vm.pages.push(response.data)
							$('#editor .product .printedarea:last-child').attr('data-page-id', response.data.id)
							$('#editor .product .printedarea').removeClass('focused')
							$('#editor .product .printedarea:last-child').addClass('focused')
							save()
							vm.noPages = false
							preventNav(false)
							noPageNavLock()
							getPageLocation()
							updatePageLocation()
						})
					} else {
						if(vm.pages.length === 0) {
							vm.noPages = true
							preventNav(true)
							noPageNavLock()
						}
					}
				}

        function adjustRBBackgrounds(changeIndex, startIndex, scenario) {
					if (vm.product.name.includes("Register Book") && vm.collection.name.includes('Precious Memories')) {
						const sidePad = 39.6,
									topPad = 45.36,
									isFullBleed = vm.product.name.includes("Register Book") && vm.layout.name.includes('Full Bleed')
						let pad = sidePad
	
						// If changeIndex is undefined, set it to the last page
						if (changeIndex === undefined) changeIndex = totalPages()
						
						$('#editor .product .printedarea').each(function(i) {         

							if (scenario === 'shuffle') {

								// If the white space needs to be flipped when pages are shuffled
								if(startIndex % 2 === (changeIndex) % 2) {
									((i >= startIndex && i < changeIndex) || (i > changeIndex && i <= startIndex)) && arrangeRBElements($(this), i, pad, sidePad)

								// If the white space does not need to be flipped when pages are shuffled
								} else {
									((i >= startIndex && i <= changeIndex) || (i >= changeIndex && i <= startIndex)) && arrangeRBElements($(this), i, pad, sidePad)
								}

							} else if (scenario === 'delete') {
								(i >= changeIndex) && arrangeRBElements($(this), i, pad, sidePad)
							}

							isFullBleed && setRBWhiteSpace($(this), i, pad, topPad, sidePad)
							styleRBBackgrounds(i, startIndex, changeIndex, scenario)
						})
					}
				}

				function setRBWhiteSpace(element, i, pad, topPad, sidePad) {
					// sets white space for all even pages
					if (!dom.isEven(i)) {
						pad = `-${pad}` * 1
						element.css('padding', '72px 0px 72px 72px')
						element.find('.theme').css({
							top: `${topPad}px`,
							right: `${sidePad}px`,
							left: `auto`
						})

					// sets white space for all odd pages
					} else {
						element.css('padding', '72px 72px 72px 0px')
						element.find('.theme').css({
							top: `${topPad}px`,
							left: `${sidePad}px`,
							right: `auto`
						})
					}
				}

				function arrangeRBElements(element, i, pad, sidePad) {
					if (vm.product.name.includes("Register Book") && vm.layout.name.includes('Full Bleed')) {
						// shifts and mirrors elements once pages are shuffled
						element.addClass('shuffle')
						element.find('.outlines').find('*').each(function() {
							shiftRBElements($(this), i, sidePad)
							mirrorRBElements($(this), pad)
						})
						element.removeClass('shuffle')
					}
				}

				function determineMirrorElements(element) {
					// determines the rules for which elements will be mirrored
					if(
						!element.hasClass('ql') &&
						!element.hasClass('icon') &&
						!element.hasClass('glyphicon') &&
						element.inlineStyle('left') !== 'auto' &&
						element.inlineStyle('left') !== undefined
					) {
						return true
					} else {
						return false
					}
				}

				function mirrorRBElements(element, pad) {
					// mirrors elements to the opposite side of the page
					if(determineMirrorElements(element)) {
						var parent = parseInt(element.closest('.outlines').css('width'))
						var right = parent - (parseInt(element.css('left')) + parseInt(element.css('width') + pad))
						element.css({
							left: right + 'px'
						})
					}
				}

				function determineShiftingElements(element) {
					/*
					|--------------------------------------------------------------------------
					| ShiftRBElements
					|--------------------------------------------------------------------------
					| AdjustRBBackgrounds causes the white space on the pages of the full bleed
					| register book to sit on the left if it is an odd page, and the right if
					| it is an even page. Because of this the elements need to be moved
					| left or right according to the whitespace. This is done two ways. The
					| first is by mirroring elements from one side of the page to the other.
					| AdjustRBBackgrounds already implements this method. The below function
					| provides implementation for the second method - which shifts elements
					| 39.6 pixels to the left or right. Any element specified in the if statement
					| will be shifted instead of mirrored.
					*/

					// // determines the rules for which elements will be shifted
					// if (
					// 	!element.hasClass('icon') &&
					// 	!element.hasClass('glyphicon') &&
					// 	element.inlineStyle('left') !== 'auto' &&
					// 	element.inlineStyle('left') !== undefined
					// ) {
					// 	return true
					// } else {
					// 	return false
					// }
				}

				function shiftRBElements(element, i, sidePad) {
					// // shifts all elements relative to the whitespace
					// if (determineShiftingElements(element) && !determineMirrorElements(element)) {
					// 	if(i % 2 === 0) {
					// 		element.css('left', `${parseInt(element.css('left')) + sidePad}px`)
					// 	} else {
					// 		element.css('left', `${parseInt(element.css('left')) - sidePad}px`)
					// 	}
					// }
				}

				function styleRBBackgrounds(i, startIndex, changeIndex, scenario) {
					const background = page => $(`#editor .product .printedarea:eq(${page}) .theme`).css('background')
					const applyBGPattern = page => {
						if (totalPages() === 0) {

							// apply the page one background to all pages if it's the only page
							const pageOneBG = $(`#editor .product .printedarea:eq(1) .theme`).css('background')
							$(`#editor .product .printedarea:odd .theme`).css('background', pageOneBG)
							$(`#editor .product .printedarea:even .theme`).css('background', pageOneBG)
							
						}	else if (page === 0 || page === 1) {

							// if dealing with the first two pages, apply the first two pages background across all pages
							$(`#editor .product .printedarea:odd .theme`).css('background', vm.bgPattern.even)
							$(`#editor .product .printedarea:even .theme`).css('background', vm.bgPattern.odd)

						} else {
							
							// gather the previous pages to template from
							vm.bgPattern = {
								odd  : background(page - (!dom.isEven(page - 1) ? 1 : 2)),
								even : background(page - (dom.isEven(page - 1) ? 1 : 2))
							}

							// apply the background styling
							$(`#editor .product .printedarea:eq(${i}) .theme`).css({
								'background': dom.isEven(i) ? vm.bgPattern.even : vm.bgPattern.odd
							})

						}
					}

					if (scenario === 'shuffle') {
						
						// finds the range of the pages being shuffled
						const shuffleRange = [startIndex, changeIndex].sort((a, b) => a - b)

						// finds whether the current page is within the range of the shuffled pages
						const withinShuffle = i >= shuffleRange[0] && i <= shuffleRange[1]

						// determines whether the current page is being shuffled forwards or backwards,
						// then returns the first page of the set being shuffled
						const firstPageShuffled = shuffleRange[0] === startIndex ? startIndex : changeIndex

						// applies the background styling to all pages being shuffled
						withinShuffle && applyBGPattern(firstPageShuffled)
						
					} else if (scenario === 'add') {

						// applies the background styling to the new page
						applyBGPattern(totalPages())

					} else if (scenario === 'delete') {

						// determines which pages are after the deleted page
						const afterDeletedPage = i >= changeIndex && i <= totalPages()

						// applies the background styling to all pages after the deleted page
						afterDeletedPage && applyBGPattern(changeIndex)
					
					}

				}

				function setBGPattern () {
					// capture the background of the first and second page
					vm.bgPattern = {
						odd  : $(`#editor .product .printedarea:eq(0) .theme`).css('background'),
						even : $(`#editor .product .printedarea:eq(1) .theme`).css('background')
					}
				}
				
				function addPixPages() {
					const items   = (css, currentItem) => $compile(`<div style="background-image: url('${helpers.imgixFlower}${currentItem}'); background-size: 100% 100%; border-radius: 0px; z-index: 10; position: absolute; cursor: pointer; opacity: 1; top: ${css.imageTop}px; left: ${css.imageLeft}px; width: ${css.imageWidth}px; height: ${css.imageHeight}px; border: none;" data-type="image" ng-click="selectElement($event)" class="draggable element ng-scope image" tabindex="0"></div>`)(vm)
					const overlay = (css) => $compile(`${vm.collection.name === "Precious Memories" ? `<div ng-click="selectElement($event)" data-type="shape" style="position: absolute; top: ${css.overlayTop}px; left: ${css.overlayLeft}px; z-index: 1; border: none; width: ${css.overlayWidth}px; height: ${css.overlayHeight}px; cursor: pointer; border-radius: 0px; opacity: 0.65; background-color: rgb(249, 252, 252); box-shadow: rgb(249, 252, 252) 0px 0px 10px 6px;" class="draggable element ng-scope"></div>` : ``}<p ng-click="selectElement($event)" data-type="text" style="position: absolute; color: black; font-family: &quot;Century Gothic&quot;; z-index: 1; top: ${css.titleTop}px; left: ${css.titleLeft}px; border: none; text-align: center; resize: none; background: none; cursor: pointer; width: ${css.titleWidth}px; height: ${css.titleHeight}; border-radius: 3px; opacity: 1; line-height: 1.5em; font-size: 36px; ;" class="draggable element large-header ng-scope" placeholder="New Text Field" contenteditable="false" uib-tooltip="Double-Click to Edit" tooltip-placement="top" tooltip-trigger="outsideClick" tooltip-enable="true">Floral Tributes</p>`)(vm)
					pageBuilder ('floralPage', vm.floralPix, vm.pagePix, items, overlay)
				}

				function addMemorialPages() {
					let items   = (css, currentItem) => $compile(`<p ng-click="selectElement($event)" ondblclick="document.execCommand(\'selectAll\',false,null)" data-type="text" style="font-family:${css.textFont}; font-size: 13px; line-height: 1em; position:absolute; color:${css.textColor}; top:${css.paddingTop}px; left: ${css.titleLeft}px; width: ${css.titleWidth}px; height: ${css.textHeight}px; border:none; text-align: center; resize:none; background:none; z-index:10;" class="draggable element" contenteditable="true">${currentItem.memorial}<br /> - ${currentItem.submitter_name}</p>`)(vm)
					let overlay = (css) => $compile(`${vm.collection.name === "Precious Memories" ? `<div ng-click="selectElement($event)" data-type="shape" style="position: absolute; top: ${css.overlayTop}px; left: ${css.overlayLeft}px; z-index: 1; border: none; width: ${css.overlayWidth}px; height: ${css.overlayHeight}px; cursor: pointer; border-radius: 0px; opacity: 0.65; background-color: rgb(249, 252, 252); box-shadow: rgb(249, 252, 252) 0px 0px 10px 6px;" class="draggable element ng-scope"></div>` : ``}<p ng-click="selectElement($event)" data-type="text" style="position: absolute; color: black; font-family: &quot;Century Gothic&quot;; z-index: 1; top: ${css.titleTop}px; left: ${css.titleLeft}px; border: none; text-align: center; resize: none; background: none; cursor: pointer; width: ${css.titleWidth}px; height: ${css.titleHeight}; border-radius: 3px; opacity: 1; line-height: 1.5em; font-size: 36px; ;" class="draggable element large-header ng-scope" placeholder="New Text Field" contenteditable="false" uib-tooltip="Double-Click to Edit" tooltip-placement="top" tooltip-trigger="outsideClick" tooltip-enable="true">Memorials</p>`)(vm)
					pageBuilder ('memorialPage', vm.memorials, vm.memorialsPages, items, overlay)
				}

				function addCondolencePages() {
					let items   = (css, currentItem) => $compile(`<p ng-click="selectElement($event)" ondblclick="document.execCommand(\'selectAll\',false,null)" data-type="text" style="font-family:${css.textFont}; font-size: 14px; line-height: 1.6; position:absolute; color:${css.textColor}; top:${css.paddingTop}px; left:${css.titleLeft}px; width: ${css.titleWidth}px; height: ${css.textHeight}px; border:none; text-align:left; resize:none; background:none; z-index:10;" class="draggable element" contenteditable="true">${currentItem.message && `${currentItem.message} <br />`} - ${currentItem.name}</p>`)(vm)
					let overlay = (css) => $compile(`${vm.collection.name === "Precious Memories" ? `<div ng-click="selectElement($event)" data-type="shape" style="position: absolute; top: ${css.overlayTop}px; left: ${css.overlayLeft}px; z-index: 1; border: none; width: ${css.overlayWidth}px; height: ${css.overlayHeight}px; cursor: pointer; border-radius: 0px; opacity: 0.65; background-color: rgb(249, 252, 252); box-shadow: rgb(249, 252, 252) 0px 0px 10px 6px;" class="draggable element ng-scope"></div>` : ``}<p ng-click="selectElement($event)" data-type="text" style="position: absolute; color: black; font-family: &quot;Century Gothic&quot;; z-index: 1; top: ${css.titleTop}px; left: ${css.titleLeft}px; border: none; text-align: center; resize: none; background: none; cursor: pointer; width: ${css.titleWidth}px; height: ${css.titleHeight}; border-radius: 3px; opacity: 1; line-height: 1.5em; font-size: 36px; ;" class="draggable element large-header ng-scope" placeholder="New Text Field" contenteditable="false" uib-tooltip="Double-Click to Edit" tooltip-placement="top" tooltip-trigger="outsideClick" tooltip-enable="true">Condolences</p><div style="background-image: url('https://s3-us-west-2.amazonaws.com/bassmollett-uploads/xy9kuqkqi9ho9u23xrimage.png'); background-size: 100% 100%; border-radius: 2px; z-index: 1; position: absolute; cursor: pointer; opacity: 1; top: ${css.linesTop}px; left: ${css.linesLeft}px; width: ${css.linesWidth}px; height: ${css.linesHeight}px; border: none;" data-type="image" ng-click="selectElement($event)" class="draggable element ng-scope image"></div>`)(vm)
					pageBuilder('condolencePage', vm.guests, vm.condolencePages, items, overlay)
				}

				function addFriendsRelativesPages() {
					let items   = (css, currentItem) => $compile(`<p ng-click="selectElement($event)" ondblclick="document.execCommand(\'selectAll\',false,null)" data-type="text" style="font-family:${css.textFont}; font-size: 14px; line-height: 1.6; position:absolute; color:${css.textColor}; top:${css.paddingTop}px; left:${css.titleLeft}px; width: ${css.titleWidth}px; height: ${css.textHeight}px; border:none; text-align:left; resize:none; background:none; z-index:10;" class="draggable element" contenteditable="true">${currentItem.name}<br />${!vm.includeEmail ?  '' : currentItem.email ? `${currentItem.email}<br/>` : ''}${currentItem.address ? `${currentItem.address}<br />` : ''}${currentItem.city ? currentItem.city : ''} &nbsp ${currentItem.state ? currentItem.state : ''}&nbsp${currentItem.zip_code ? currentItem.zip_code : ''}</p>`)(vm)
    			let overlay = (css, i) => $compile(`${vm.collection.name === "Precious Memories" ? `<div ng-click="selectElement($event)" data-type="shape" style="position: absolute; top: ${css.overlayTop}px; left: ${css.overlayLeft}px; z-index: 1; border: none; width: ${css.overlayWidth}px; height: ${css.overlayHeight}px; cursor: pointer; border-radius: 0px; opacity: 0.65; background-color: rgb(249, 252, 252); box-shadow: rgb(249, 252, 252) 0px 0px 10px 6px;" class="draggable element ng-scope"></div>` : ``}<p ng-click="selectElement($event)" data-type="text" style="position: absolute; color: black; font-family: &quot;Century Gothic&quot;; z-index: 1; top: ${css.titleTop}px; left: ${css.linesLeft}px; border: none; text-align: center; resize: none; background: none; cursor: pointer; width: ${css.linesWidth}px; height: ${css.titleHeight}; border-radius: 3px; opacity: 1; line-height: 1.5em; font-size: 33px;" class="draggable element large-header ng-scope" placeholder="New Text Field" contenteditable="false" uib-tooltip="Double-Click to Edit" tooltip-placement="top" tooltip-trigger="outsideClick" tooltip-enable="true">Relatives & Friends</p><div data-type="image" data-caseimage="${i}" style="background-color: rgb(249, 252, 252); position: absolute; top: ${css.imageTop}px; left: ${css.imageLeft}px; width: ${css.imageWidth}px; height: 97.1879px; ${vm.case.personal_images && `background: url('https://bassmollett-case.imgix.net/${vm.case.personal_images[i]}') 0% 0% / cover rgb(221, 221, 221);`} cursor: pointer; z-index: 2; border-radius: 0px; opacity: 1; border: none; box-shadow: rgba(0, 0, 0, 0.298) 0px 0px 3px 0px;" class="caseImage draggable element ng-scope"></div><div style="${css.background ? css.background : `background: url('https://s3-us-west-2.amazonaws.com/bassmollett-uploads/xy9kuqkqi9ho9u23xrimage.png') top/100% 100%`}; border-radius: 2px; z-index: 1; position: absolute; cursor: pointer; opacity: 1; top: ${css.linesTop}px; left: ${css.linesLeft}px; width: ${css.linesWidth}px; height: ${css.linesHeight}px; border: none;" data-type="image" ng-click="selectElement($event)" class="draggable element ng-scope image"></div><div class="element ng-scope casefield-body ql-container ql-snow ql-disabled oldQuill draggable" data-type="text" style="position: absolute; z-index: 10; width: ${css.linesWidth}px; left: ${css.linesLeft}px; top: ${css.subtitleTop}px; font-family: Antiqua; color: rgb(0, 0, 0); font-size: 1em; height: ${css.subtitleHeight};" uib-tooltip="Double-Click to Edit" tooltip-placement="top" tooltip-trigger="outsideClick"><div class="ql-editor" data-gramm="false" contenteditable="false" style="font-family: Antiqua; font-size: 18px; color: rgb(0, 0, 0); background-color: rgba(0, 0, 0, 0);"><p style="text-align: center; line-height: 1.2em; color: inherit; font-family: inherit; font-size: 18px;" class="ql"><cite class="ql-data-content" data-id="case.name_of_deceased" data-label="case.name_of_deceased" data-caseinfo="undefined" spellcheck="false">&#65279;<span contenteditable="false"><span contenteditable="false" class="ng-binding">[{{case.name_of_deceased}}]</span></span>&#65279;</cite></p></div></div>`)(vm);
					pageBuilder('relativesPage', vm.guests, vm.friendsRelativesPages, items, overlay)
				}

				async function pageBuilder(pageClass, pageData, pageType, items, overlay) {
					
					// delete any already existing pages
					await Promise.all(
						$('#editor .product .printedarea').toArray().map(async (page, index) => {
							$(page).hasClass(pageClass) && await deletePage(index, false, true)
						})
					)
				
					// organize the pageData into groups
					let pageChunks        = createPageChunks(pageData, pageClass, pageType),
							appendElement     = (element) => $('#editor .product .printedarea .outlines').last().append(element),
							addClassToElement = (element) => $('#editor .product .printedarea').last().addClass(element)
							
					for (let i in pageChunks) {
						// if there is no new page, make one
						if(!vm.newPage) setPage()
				
						// general logic, and calculations
						const el            = $compile(vm.newPage)(vm),
									rotator       = $compile('<i class="glyphicon glyphicon-repeat rotator"></i>')(vm),
									resizer       = $compile('<i class="glyphicon glyphicon-fullscreen resizer"></i>')(vm),
									deletor       = $compile('<i class="icon-delete-circle deletor" ng-click="deleteElement()"></i>')(vm),
									lastPage      = $('#editor .product .printedarea:last-child'),
									outlines      = $('#editor .product .printedarea .outlines'),
									payloadPage   = lastPage.prop('outerHTML'),
									evenPage      = outlines.length % 2 == 0 ? true : false,
									outlineWidth  = parseInt($('#editor .product .printedarea:last-child').width()),
									outlineHeight = parseInt($('#editor .product .printedarea:last-child').height()),
									flapPadding   = parseInt($('#editor .product .printedarea').css('padding-left')),
									foldPosition  = parseInt($('#editor .product .printedarea .fold').css('left'))
				
						// create the initial page
						lastPage.length ? $(el).insertAfter(lastPage[0]) : $('#editor .product').append($(el))
				
						// if it is a register book, remove all elements of the current page
						if (vm.product.name === 'Register Book' || vm.product.name === "Deluxe Register Book") $('#editor .product .printedarea:last-child .outlines').children().remove()
				
						// add the rotator, resizer, and deletor to the current element
						appendElement(rotator)
						appendElement(resizer)
						appendElement(deletor)
				
						// create the initial CSS attributes
						let css = {
							overlayTop     : 0,
							overlayLeft    : 0,
							overlayWidth   : 0,
							overlayHeight  : 0,
							overlayPadding : 0,
							titleTop       : 0,
							titleLeft      : 0,
							titleWidth     : 0,
							titleHeight    : 54,
							subtitleTop    : 0,
							subtitleHeight : 22,
							textLeft       : 0,
							textWidth      : 0,
							textHeight     : 0,
							textAlign      : 'left',
							textColor      : vm.themeFontColor ? vm.themeFontColor : 'rgb(0,0,0)',
							textFont       : vm.themeFont ? vm.themeFont : 'Century Gothic',
							linesLeft      : 0,
							linesTop       : 0,
							linesWidth     : 360,
							linesHeight    : 430,
							imageTop       : 0,
							imageLeft      : 0,
							imageHeight    : 110,
							imageWidth     : 110,
							paddingTop     : 0,
							itemSpacing    : 0,
							outlineWidth   : outlineWidth,
							outlineHeight  : outlineHeight,
							flapPadding    : flapPadding,
							foldPosition   : foldPosition,
						}

						// calculate the positioning and add the page class
						setBuildSizing(css, pageClass)
						addClassToElement(pageClass)

						// build the overlay
						calculateOverlayPosition(css, pageClass, evenPage)
						calculateFriendsRelativesImages(css, pageClass, evenPage)
						appendElement(overlay(css, i))

						// build the text and images
						buildPageItems(pageChunks, i, items, css, pageClass, evenPage)
						positionFriendsRelativesText(css, pageClass, evenPage)

						// write pages to the database
						let payload = Object.assign({}, vm.pages[0])
						payload.template = payloadPage
						payload.page_number = vm.pages.length + 1
						delete payload.id
						delete payload.archived
						pages.createOrderPageDetails(payload).then(response => {
							vm.pages.push(response.data)
							$('#editor .product .printedarea').removeClass('focused')
							$('#editor .product .printedarea:last-child').addClass('focused')
						})
					}
					$timeout(function(){
						let change = $('#editor .product .printedarea .outlines').length - pageChunks.length
						adjustRBBackgrounds(change, 0, 'add')
						vm.registerPageTitles = []
						scope.$apply()
						$.each($('#editor .product .printedarea'), function(index) {
							$(this).attr('data-page-id', vm.pages[index].id)
						})
						pageTitle()
						scope.$apply()
						focusOnLastPage()
						getPageLocation()
						updatePageLocation()
						save()
					}, 2000)
				}

				function createPageChunks(pageData, pageClass, pageType) {
					let pageChunks = []

					// remove entry if guest has no message for condolence pages
					pageClass.includes('condolencePage') &&	(pageData = pageData.filter(item => item.message))
					let arrangementChunks = _.chunk(pageData, pageType)

					// break floralPix into arrangement groups
					for (let c in arrangementChunks) {
						if(pageClass === 'floralPage') {
							let imageChunk = []
							for(let i in arrangementChunks[c]){
								arrangementChunks[c][i].images.forEach(image => {
									imageChunk.push(image)
								})
							}
							pageChunks.push(imageChunk)
						} else {
							pageChunks = arrangementChunks
						}
					}
					return pageChunks
				}

				function setBuildSizing(css, pageClass) {
					
					// REFLECTIONS OF LIFE SIZING
					if (vm.collection.name.includes('Reflections of Life')) {

						const layoutSizingRoL = (overlayPadding, textHeight, itemSpacing, paddingTop, linesHeightRP, linesWidthRP, textHeightRP, itemSpacingRP) => {
							// shrink space between content and edge, text box height, space between items and the top padding
							css.overlayPadding = overlayPadding
							css.textHeight     = textHeight
							css.itemSpacing    = itemSpacing
							css.paddingTop     = paddingTop
							if (pageClass.includes('relativesPage')) {
								// shrink space between content and edge, text box height, and lines for relatives pages
								css.linesHeight = linesHeightRP
								css.linesWidth  = linesWidthRP
								css.textHeight  = textHeightRP
								css.itemSpacing = itemSpacingRP
							}
						}

						// apply sizing for RoL layouts
						vm.layout.name.includes('Small')  && layoutSizingRoL(40, 70, 80,  130, 360, 310, 65, 75)
						vm.layout.name.includes('Medium') && layoutSizingRoL(40, 70, 80,  130, 360, 310, 65, 75)
						vm.layout.name.includes('Large')  && layoutSizingRoL(40, 90, 100, 130, 400, 330, 65, 75)

						// shrink the images and padding between the content and edges for the floralPix images on all RoL layouts
						if(pageClass.includes('floralPage')) {
							css.itemSpacing    = 140
							css.imageWidth     = 100
							css.imageHeight    = 100
							css.overlayPadding = 30
						}

					} 
					
					// LIFETIME EXPRESSION SIZING
					if (vm.collection.name.includes('Lifetime Expressions')) {

						const layoutSizingLE = (textHeight, itemSpacing) => {
							// shrink the textboxes and item spacing
							css.textHeight  = textHeight
							css.itemSpacing = itemSpacing
						}

						// shrink the padding between the content and edges for all Lifetime Expression's layouts
						css.paddingTop     = 130
						css.overlayPadding = 65

						// apply sizing to LE layouts
						vm.layout.name.includes('Small')  && layoutSizingLE(80, 90 )
						vm.layout.name.includes('Medium') && layoutSizingLE(80, 90 )
						vm.layout.name.includes('Large')  && layoutSizingLE(90, 100)

						// shrink the floralPix images for all Lifetime Expression's layouts
						if(pageClass.includes('floralPage')) {
							css.itemSpacing    = 160
							css.overlayPadding = 30
						}

						// shrink the lines, textboxes, and item spacing for all Lifetime Expression's layouts
						if (pageClass === 'relativesPage') {
							css.linesHeight = 400
							css.linesWidth  = 330
							css.textHeight  = 65
							css.itemSpacing = 75
						}

					}

					// PRECIOUS MEMORIES SIZING
					if (vm.collection.name.includes('Precious Memories')) {

						const layoutSizingPM = (overlayPadding, paddingTop, textHeight, itemSpacing, itemSpacingFP) => {
							// shrink the padding between the content and edges, top padding, text height, and item spacing
							css.overlayPadding = overlayPadding
							css.paddingTop     = paddingTop
							css.textHeight     = textHeight
							css.itemSpacing    = itemSpacing
							pageClass.includes('floralPage') && (css.itemSpacing = itemSpacingFP)
						}

						// apply sizing to PM layouts
						vm.layout.name.includes('Full Bleed')   && layoutSizingPM(108, 160, 87, 88, 140)
						vm.layout.name.includes('White Border') && layoutSizingPM(65,  130, 70, 80, 140)

						// shrink the lines, text, and space between textboxes for the relatives page on the white border layout
						if (vm.layout.name.includes('White Border') && pageClass === 'relativesPage') {
							layoutSizingPM(65,  160, 87, 88, 140)
							css.background = `background: url('https://s3-us-west-2.amazonaws.com/bassmollett-uploads/xy9kuqkqi9ho9u23xrimage.png') top/360px 430px no-repeat`
						}

						if (vm.layout.name.includes('White Border') && pageClass === 'condolencePage') {
							layoutSizingPM(65,  110, 87, 88, 140)
						}

					}

				}

				function calculateOverlayPosition(css, pageClass, evenPage) {

					// calculate the overlay's height and width
					css.overlayHeight = css.outlineHeight - css.overlayPadding
					css.overlayWidth  = css.outlineWidth  - css.overlayPadding

					// adjust the overlay's width on Reflections of Life flap layouts
					vm.layout.name.includes('Flap') && (css.overlayWidth = css.foldPosition - css.flapPadding - css.overlayPadding)

					// calculate the overlay's position
					css.overlayTop  = css.overlayPadding / 2
					css.overlayLeft = css.overlayPadding / 2

					// adjust the overlay position for the Full Bleed Register Book's white space
					if (vm.layout.name.includes('Full Bleed')) {
						css.overlayWidth = (css.outlineWidth - css.overlayPadding - 39.6)
						evenPage && (css.overlayLeft = (css.overlayPadding / 2) + 39.6)
					}

					// calculate the title's width and position
					css.titleWidth = css.overlayWidth - ( css.overlayPadding / 2 )
					css.titleTop   = css.overlayTop   + ( css.overlayPadding / 8 )
					css.titleLeft  = css.overlayLeft  + ( css.overlayPadding / 4 )

					// calculate the line's positioning
					css.linesTop   = css.overlayTop + ( css.overlayPadding / 4 ) + css.titleHeight
					css.linesLeft  = (css.overlayPadding / 2) + (css.overlayWidth / 2) - (css.linesWidth / 2)

					if (pageClass === 'condolencePage') {
						css.titleTop = css.overlayTop + 10

						if (vm.layout.name.includes('Full Bleed')) {
							css.paddingTop = css.paddingTop - 18
							css.titleWidth = css.titleWidth + 10
							css.titleLeft  = css.titleLeft  - 5
						}

						if (vm.layout.name.includes('White Border')) {
							css.linesWidth = css.linesWidth + 10
							css.linesLeft  = css.linesLeft  - 5
							css.titleWidth = css.titleWidth - 18
							css.titleLeft  = css.titleLeft  + 9
							css.background = `background: url('https://s3-us-west-2.amazonaws.com/bassmollett-uploads/xy9kuqkqi9ho9u23xrimage.png') top/370px 430px no-repeat`
						}
					}

					// position the title, subtitle, lines, and top padding for the Friends and Relatives page
					if (pageClass === 'relativesPage') {
						css.titleTop    = css.overlayTop
						css.subtitleTop = css.titleTop    + css.titleHeight
						css.linesTop    = css.subtitleTop + css.subtitleHeight + (css.overlayPadding / 8)
						css.paddingTop  = css.titleHeight + css.subtitleHeight + (css.overlayPadding / 8) + (css.overlayPadding / 2)

						if (vm.layout.name.includes('Full Bleed') || vm.layout.name.includes('White Border')) {
							css.paddingTop = css.paddingTop + 8
						}

						if (vm.layout.name.includes('White Border')) {
							css.titleWidth = css.titleWidth - 18
							css.titleLeft  = css.titleLeft  + 9
						}

						if (vm.layout.name.includes('Full Bleed')) {
							css.titleWidth = css.titleWidth + 10
							css.titleLeft  = css.titleLeft  - 5
						}

					}

					// adjust the image and lines for the Full Bleed Register Book's white space
					if (evenPage && vm.layout.name.includes('Full Bleed')) {
						css.imageLeft = css.imageLeft + 39.6
						css.linesLeft = css.linesLeft + 39.6
					}
				}

				function calculateFriendsRelativesImages(css, pageClass, evenPage) {
					if (pageClass === 'relativesPage') {

						// position the friends and relatives case image
						css.imageWidth = 72
						css.imageTop   = css.linesTop

						// place the case image on the correct side of the page for the Full Bleed Register Book
						evenPage ? css.imageLeft = css.linesLeft : css.imageLeft = css.linesLeft + css.linesWidth - css.imageWidth

					}
				}

				function positionFriendsRelativesText(css, pageClass, evenPage) {
					if (pageClass === 'relativesPage') {

						// adjust the width and position of the first Friends and Family text box to avoid colliding with the case image
						const offsetText = $(`#editor .product .printedarea:last-child .outlines > *:nth-child(${vm.collection.name === "Precious Memories" ? '9' : '8'})`),
									offsetLeft  = evenPage ? css.titleLeft + css.imageWidth + (css.overlayPadding / 4) : css.titleLeft,
									offsetWidth = css.titleWidth - css.imageWidth - (css.overlayPadding / 4)

						// apply the offset to the text box
						offsetText.css({
							'left'   : `${offsetLeft}px`,
							'width'  : `${offsetWidth}px`,
							'height' : `87px`
						})

					}
				}

				function buildPageItems(pageChunks, i, items, css, pageClass, evenPage) {
					const appendElement = (element) => $('#editor .product .printedarea .outlines').last().append(element)

					// loop through each item on the current page
					for (let item in pageChunks[i]) {

						if(pageClass === 'condolencePage' && !pageChunks[i][item].message) pageChunks[i][item].message = ''

						// position the floralPix images
						calculateFloralPixImages(css, pageClass, evenPage, item)

						// place the item onto the current page
						appendElement(items(css, pageChunks[i][item]))
			
						// add more spacing for each row of images
						css.paddingTop += css.itemSpacing

						// add extra space after the first text box on the Friends and Relatives page
						pageClass === 'relativesPage' && item == 0 && (css.paddingTop = css.paddingTop - css.textHeight + 87)
					}
				}

				function calculateFloralPixImages(css, pageClass, evenPage, index) {
					if (pageClass === 'floralPage') {
	
						// determine where the floralPix images will be placed
						if(index % 2 == 0) {
							css.imageLeft = (css.overlayWidth/4) - (css.imageWidth / 2) + (css.overlayPadding / 2) + (css.overlayPadding / 8)
							css.imageTop >= (css.titleHeight + css.overlayPadding) ? css.imageTop += css.itemSpacing : css.imageTop += (css.titleHeight + css.overlayPadding)
						} else {
							css.imageLeft = ((css.overlayWidth/4) * 3) - (css.imageWidth / 2) + (css.overlayPadding / 2) - (css.overlayPadding / 8)
						}
	
						// adjust for the Full Bleed Register Book's white space
						(evenPage && vm.layout.name.includes('Full Bleed')) && (css.imageLeft = css.imageLeft + 39.6)
					}
				}

				function focusOnLastPage() {
					$.each($('#editor .product .printedarea'), function() {
						if($(this).hasClass('focused')) {
							$(this).removeClass('focused')
						}
					})
					$('#editor .product .printedarea:last-child').addClass('focused')
				}

			 // Image editor
			 
        function saveImageEdits(update) {
	        //get updated url
	        let width, height, newWidth, newHeight, path, newImage
					if(vm.action_type == 'image') {
		        $timeout(function(){
		          path = vm.editImage.url
							path = path.split('&&').join('&')
			        // get crop's width and height
			        newWidth = parseInt($('#edit_image').css('width'))
			        newHeight = parseInt($('#edit_image').css('height'))
			        //if too large for page, make smaller
			        if(newWidth > 250) {
			          width = '250px'
			          height = 250 * (newHeight/newWidth) + 'px'
			        } else {
			          width = newWidth,
			          height = newHeight
			        }
			        //set selected element's url to the edited query
							newImage = new Image();
							newImage.src =  path
							newImage.onload = function() {
								if($(vm.selected.selector).is('div')){
									vm.selected.selector.css({
					          background: `url(${path})`,
										'background-size': 'cover',
										'background-color': vm.selected.backgroundcolor,
										'width': parseInt(vm.selected.selector.css('width')),
										'height': parseInt(vm.selected.selector.css('width')) * (newImage.height/newImage.width) + 'px'
					        })
									if(vm.selected.selector.hasClass('cropped') && !vm.selected.selector.hasClass('edited')) {
										 vm.selected.selector.css({
											 width: width,
											 height: height,
										 })
									}
								} else if ($(vm.selected.selector).is('img')) {
									$(vm.selected.selector).attr('src', path)
									// if(vm.selected.selector.hasClass('cropped') && !vm.selected.selector.hasClass('edited')) {
									// 	 vm.selected.selector.css({
									// 		 width: width,
									// 		 height: height
									// 	 })
									// }
									var isEdited = Object.getOwnPropertyNames(vm.imageAdjustment).length > 0
									if(!vm.selected.selector.attr('data-edited', 'true') && isEdited) {
					           vm.selected.selector.attr('data-edited', 'true')
					         }
								}
				        //add class edited
				        var isEdited = Object.getOwnPropertyNames(vm.imageAdjustment).length > 0
				        if(!vm.selected.selector.hasClass('edited') && isEdited) {
				           vm.selected.selector.addClass('edited')
				         }
								vm.advancedOptions.basic = true
			 					vm.advancedOptions.advanced = false
				        dom.positionResizer()
				        dom.positionRotator()
				        dom.positionDelete()
								vm.advancedOptions.basic = true
								vm.advancedOptions.advanced = false
				        if(!update) $('#editImageModal').modal('hide')
							}
						}, 100)
					}
				}
				
				function setCaseImageHeight(image) {

					//get updated url
					let width, height, newWidth, newHeight, path, newImage
				
					const caseImageBackground = image.css('background-image')

					if (caseImageBackground.includes('url')) {

						path = caseImageBackground.split('"')[1]
						path = path.split('&&').join('&')
					
						// get crop's width and height
						newWidth  = parseInt($('#edit_image').css('width'))
						newHeight = parseInt($('#edit_image').css('height'))
					
						//if too large for page, make smaller
						if(newWidth > 250) {
							width  = '250px'
							height = 250 * (newHeight/newWidth) + 'px'
						} else {
							width  = newWidth,
							height = newHeight
						}
					
						//set selected element's url to the edited query
						newImage = new Image();
						newImage.src =  path
						
						newImage.onload = function() {
					
							image.css({
								'width'  : parseInt(image.css('width')),
								'height' : parseInt(image.css('width')) * (newImage.height/newImage.width) + 'px'
							})
					
							if(image.hasClass('cropped') && !image.hasClass('edited')) {
					
								image.css({
									width  : width,
									height : height,
								})
					
							}
					
						}

					}
				
				}

				function defaultImageEdited () {
					if(vm.selected.element.attributes['data-caseimage'].value === '0' ) {
						localStorage.removeItem('defaultImgUpdated')
					}
				}

      	function undoImageEdits() {
	        let backgroundFileName = vm.undoImageEditStates[vm.undoImageEditStates.length-1].url
	        //reset vm.imageAdjustment to 0
	        for (let key in vm.imageAdjustment) {
	          vm.imageAdjustment[key] = 0
	        }
					$('#edit_image').css('opacity', vm.undoImageEditStates[vm.undoImageEditStates.length-1].opacity)
					//find each key in the previous query string and set it on the model
					//determine if there are already settings in the query and set vm.imageAdjustment to those values
					for(let key in vm.imageAdjustment) {
						if(backgroundFileName.indexOf(key) != -1) {
							if(key === 'mono') {
								vm.imageAdjustment[key] = '#' + backgroundFileName.substr(backgroundFileName.indexOf(key) + (key.length + 1), 6)
							}
							if(key === 'blend') {
								var q = backgroundFileName.match(/(&blend).*&/g)[0]
								q = q.substring(q.indexOf('=')).split('&').shift()
								if(q.length === 7) {
									vm.imageAdjustment[key] = '#' + q.substr(1)
								} else {
									vm.imageAdjustment[key] =  q.substr(1)
								}
							} else if(key === 'bm') {
								var q = backgroundFileName.match(/(&bm).*&/g)[0]
								q = q.substring(q.indexOf('=')).split('&').shift()
								vm.imageAdjustment[key] = q.substr(1)
							} else {
								vm.imageAdjustment[key] = parseInt(backgroundFileName.substr(backgroundFileName.indexOf(key) + (key.length + 1), 4))
							}
						}
					}
					vm.editImage.url = backgroundFileName
					vm.undoImageEditStates.pop()
      	}

	      function editImageProps(update) {
					let undo = {
						url: vm.editImage.url,
						opacity: vm.editImage.opacity
					}
          vm.undoImageEditStates.push(undo)
          // get image url so the query can be built
            let imageParams = imageService.getImageParams(vm.editImage.url)
						let imageFile = imageParams.baseImage
            let query, queries

            if(imageFile.indexOf('?') === -1) {
							query = '?'
							imageFile = imageFile.split('?')[0]
						} else {
	            queries = vm.editImage.url.split('?')[1]
							queries = queries.replace(/(&fm=png)/gi, '')
							queries = queries.replace(/(&auto=compres)s/gi, '')
							queries = queries.replace(/(&fit=crop)/gi, '')
							queries = queries.replace(/((&mask=https:\/\/s3-us-west-2\.amazonaws\.com\/bassmollett-uploads\/squarefeatherbox\.png))/gi, '')
							queries = queries.split('&')

							for (let i in queries) {
								if(queries[i].indexOf("rect=") != -1) {
									 query += "&" + queries[i]
								// } else if(queries[i].indexOf("or=") != -1) {
								// 	query += "&" + queries[i]
								} else if(queries[i].indexOf("auto=") != -1) {
									query += "&" + queries[i]
								} else if (queries[i].indexOf('fm=') != -1) {
									query += '&' + queries[i]
								} else if (queries[i].indexOf('mask=') != -1) {
									if(queries[i] != 'mask=corners') query += '&' + queries[i]
									vm.imageAdjustment.border.pad = 0
								}
							}
						}
						if(query.indexOf('fm=') === -1) {
							query += '&fm=png'
						}
            let path = imageFile + query
            // find each key that has a value not 0 and add it to the query string
            for (let key in vm.imageAdjustment) {
							let keystring = ''
              if(vm.imageAdjustment[key] != 0) {
                if( key === 'mono') {
									if(vm.imageAdjustment.mono) {
                  	keystring = "&" + key + "="+ vm.imageAdjustment.mono.substring(1) + '&'
										path += keystring
									}
                } else if(key === 'blend') {
									if(vm.imageAdjustment.blend) {
	                  if(vm.imageAdjustment.blend.indexOf('#') === 0){
	                    keystring = "&blend="+ vm.imageAdjustment.blend.substring(1) + '&'
	                  } else if(vm.imageAdjustment.blend.indexOf('http') != -1){
	                    keystring = "&blend="+ vm.imageAdjustment.blend + "&bm="+vm.imageAdjustment.bm+"&balph="+vm.imageAdjustment.balph+"&bf=crop&bc=top,left&bw=" + vm.imageAdjustment.bw + "&bh=" +vm.imageAdjustment.bh
	                  }
									}
									path += keystring
                } else if(key === 'border-radius') {
									let borderRadius = vm.selected.selector.css('border-radius')
									if(borderRadius == '50%') {
										keystring = '&mask=ellipse'
									} else if((!vm.imageAdjustment.border.width || vm.imageAdjustment.border.width == 0)) {
										if(vm.imageAdjustment[key] != 0) {
											keystring = '&mask=corners&corner-radius=' + (vm.imageAdjustment[key] * 2)
										}
									} else {
										keystring = "&border-radius=" + (vm.imageAdjustment[key] * 2)
									}
									path += keystring
								} else if (key === 'border') {
									keystring = "&border=" + vm.imageAdjustment.border.width + "," + vm.imageAdjustment.border.color.substring(1)
									if(path.indexOf('mask=ellipse') === -1 && vm.selected.selector.css('border-radius') != '50%') {
										keystring += '&pad=' + vm.imageAdjustment.border.width
									}
									path += keystring
								} else if(key != 'bw' && key != "bh" && key != 'bm' && key != 'balph'){
                  keystring = "&" + key + "="+ vm.imageAdjustment[key]
                  path += keystring
                }
              }
						}
						if(vm.selected.selector.hasClass('feathered') && vm.selected.selector.css('border-radius') === '0px' && (path.indexOf(`mask=${helpers.squareFeather}`) == -1)) {
              path = path + `&fit=crop&mask=${helpers.squareFeather}`
            } else if (vm.selected.selector.hasClass('feathered') && vm.selected.selector.css('border-radius') != '0px' && (path.indexOf(`mask=${helpers.circleFeather}`) == -1)) {
							vm.showBorder.image = false
              path = path + `&fit=crop&mask=${helpers.circleFeather}`
            }
						vm.editImage.url = path
						if(!update) update = false
						if(vm.showBorder.image || update) saveImageEdits(update)
	      }

        function revertImage() {
          //reset all query selectors and then run props
          for (let key in vm.imageAdjustment) {
						if (key != 'border' && key!= 'border-radius') vm.imageAdjustment[key] = 0
          }
          editImageProps()
        }

        function resetImageColor(key) {
          // remove hex from color selector
          vm.imageAdjustment[key] = 0
          editImageProps()
        }

        function setImageRotation(value) {
					// get the value for the rotation quer
					vm.imageAdjustment.or = value;
					editImageProps()
					// setUndoState()
          // $('#edit_image').css({
          //   'transform': 'rotate('+ value + 'deg)'
          // })
          // vm.selected.selector.css({
          //   'transform': 'rotate('+ value + 'deg)'
          //})
				}

				function setImageFlip(value) {
					vm.imageAdjustment.flip = value;
					editImageProps()
        }

        function showEditImageModal(modal) {
					let update = false
					let width, height, border, borderRadius, opacity
					vm.editImage = {}
					opacity = vm.selected.selector.css('opacity')
					if(vm.selected.selector.css('border-left-width')) {
						update = true
						border = {
							width: parseInt(vm.selected.selector.css('border-left-width')),
							color: vm.selected.selector.css('border-left-color')
						}
						border.color = dom.rgb2hex(border.color)
						vm.selected.selector.css('border', '')
					}
					if(vm.selected.selector.css('border-radius')) {
						borderRadius = parseInt(vm.selected.selector.css('border-radius'))
						update = true
					}
          //Get original image
          let  backgroundFileName = imageService.getPath(vm.selected)
					let imageParams = imageService.getImageParams(backgroundFileName)
					let newImage = new Image();
          newImage.src = imageParams.baseImage
          //set imageAdjustment to 0
          vm.imageAdjustment = {
            vib: 0,
            hue: 0,
            bri: 0,
            con: 0,
            high:  0,
            sat: 0,
            shad:  0,
            sharp: 0,
            exp: 0,
            gam: 0,
            blur:  0,
            sepia: 0,
            blend: 0,
            mono:  0,
						htn:  0,
            bw: 0,
            bh: 0,
            bm: 'multiply',
            balph: 50,
						border: {
							width: 0,
							color: '#000000',
							pad: 0,
						},
						'border-radius': 0,
						fm: 'png',
						or: 0,
						flip: 0,
						auto: 'compress',
						rect: ''
          }
					if(border) {
						vm.imageAdjustment.border.width = border.width
						vm.imageAdjustment.border.color = border.color
					} else if(borderRadius) {
						vm.imageAdjustment.border.width = 1
					}

					if(imageParams.or) {
						vm.imageAdjustment.or = parseInt(imageParams.or)
					}

					if(borderRadius) {
						vm.imageAdjustment['border-radius'] = borderRadius
					}
					for(let key in vm.imageAdjustment) {
						if(imageParams[key]) {
							if(key === 'mono') {
								if(imageParams.mono) {
									let mono = '#' + imageParams.mono
	                vm.imageAdjustment[key] = mono
								}
              } else
              if(key === 'blend') {
								if(imageParams.blend) {
	                let q = imageParams.blend
	                if(q.length === 6) {
										let blend = '#' + q
	                  vm.imageAdjustment[key] = blend
	                } else {
	                  vm.imageAdjustment[key] =  q
	                }
								}
              } else if(key === 'border'){
								let q = imageParams[key]
								q = q.split(',')
								vm.imageAdjustment.border.width = q[0]
								vm.imageAdjustment.border.color = '#' + q[1]
								vm.imageAdjustment.border.pad = vm.imageAdjustment.border.width
							} else {
              	vm.imageAdjustment[key] = imageParams[key]
            	}
						}
					}

          $(newImage).load(function() {
            //If image is greater than 500 then shrink down
            if (newImage.height > 500) {
              width = 500 * (newImage.width/ newImage.height) + 'px'
              height = "500px"
            } else {
              width = newImage.width + 'px'
              height = newImage.height + 'px'
            }
            vm.imageAdjustment.bw = newImage.width
            vm.imageAdjustment.bh = newImage.height
						if(border.width > 0) {
							vm.imageAdjustment.border.width = Math.round(vm.imageAdjustment.border.width * (newImage.height/parseInt(vm.selected.selector.css('height'))))
							vm.imageAdjustment.border.pad = Math.round(vm.imageAdjustment.border.width * (newImage.height/parseInt(vm.selected.selector.css('height'))))
						}
            vm.editImage = {
              url: imageParams.baseImage,
              width: width,
              height: height,
							opacity: opacity,
              modalHeight: Math.max((parseInt(height) + 100), (parseInt(width)+ 100)),
              modalWidth: Math.max((parseInt(height) + 400), (parseInt(width)+ 400)),
              wrapperWidth: (Math.max((parseInt(height) + 400), (parseInt(width)+ 400)) - 250)
            }
						if(modal) {
							$('#editImageModal').modal('show')
	            $timeout(function() {
	              $('#edit_image').load(function() {
	              })
	            }, 100)
						}
						if (update) editImageProps(update)
          })

					//Get original image
					let cropImageFileName = imageService.getPath(vm.selected)

          let cropNewImage = new Image();
          cropNewImage.src = imageParams.baseImage
          $(cropNewImage).load(function() {
						let cropwidth, cropheight
            //If image is greater than 500 then shrink down

            if (cropNewImage.height > cropNewImage.width && cropNewImage.height > 500 ) {
              cropwidth = 500 * (cropNewImage.width/ cropNewImage.height) + 'px'
              cropheight = '500px'
            } else if(cropNewImage.height < cropNewImage.width && cropNewImage.width > 700) {
							cropheight = 700 * (cropNewImage.height/cropNewImage.width) + 'px'
              cropwidth = '700px'
						} else {
              cropwidth = cropNewImage.width + 'px'
              cropheight = cropNewImage.height + 'px'
            }
            vm.cropImage = {
              url: imageParams.baseImage,
              width: cropwidth,
              height: cropheight,
              modal: 'editImage'
            }
						if(modal) {
							$timeout(function() {
	              $('#edit_crop_image').load(function() {})
	              positionCroptool()
	            }, 800)
						}
					})
        }

				function switchEditViews(selection) {
					if(selection == 'Basic') {
						vm.advancedOptions.basic = true
						vm.advancedOptions.advanced = false
					} else {
						vm.advancedOptions.advanced = true
						vm.advancedOptions.basic = false
					}
				}

				function updateModal() {
					vm.editImage.opacity = $('#edit_image').css('opacity')
					$('#edit_image').css('opacity', parseInt(vm.selected.opacity) /100)
					editImageProps()
				}

				// Text
				
        function addText() {
          let el
					let color
					let font
					vm.themeFontColor ? (color = vm.themeFontColor) : (color = 'rgb(0,0,0)')
					vm.funeralHomeSettings.default_font ? (font = vm.funeralHomeSettings.default_font) : font = 'Century Gothic'
					el = $compile(`<p id="new-text" ng-click="selectElement($event)" ondblclick="document.execCommand(\'selectAll\',false,null)" data-type="text" style="font-family:${font}; width:175px; position:absolute; color:${color}; top:0px; left:0px; border:none; text-align:center; resize:none; background:none; z-index:10;" class="draggable element" contenteditable="true">New Text Field</p>`)(vm)
					// For inserting and highlighting text into product
					var selector = '#new-text'
					dom.insertAndHighlightNewText(el, selector)
        }

        function addShape() {
					let el = $compile(domHelpers.addShape())(vm)
					$('#editor .product .focused .outlines').append(el)
					setUndoState();
        }

				function addLine() {
					let el = $compile(`<div ng-click="selectElement($event)" data-type="shape" style="position:absolute; top: 5px; left:0;  z-index:10; background-color: black; width:250px; height: 2px; box-shadow: none; " class="draggable element line new-shape"></div>`)(vm)
					$('#editor .product .focused .outlines').append(el)
					setUndoState();
				}

        function removeFeather() {
					let path = imageService.getPath(vm.selected)
					var imageParams = imageService.getImageParams(path)

					delete imageParams.fit
					delete imageParams.mask
					imageParams.fm = 'png'

					var filePath = imageParams.baseImage + '?'
					for (var key in imageParams) {
						if(key != 'baseImage') {
							filePath += key + '=' + imageParams[key] + '&'
						}
					}

					if($(vm.selected.element).hasClass('feathered')) $(vm.selected.element).removeClass('feathered')
					if($(vm.selected.selector).attr('data-feathered')) $(vm.selected.selector).removeAttr('data-feathered')
					//FIXME: update file paths!
					if (!vm.selected.image) {
						$(vm.selected.element).css({
							background: 'url(' + filePath + ')', //+ '?' + path +
							'background-size': 'cover',
						})
					} else {
						$(vm.selected.selector).attr('src', filePath)
					}
					setUndoState()
        }

        function featherBox() {
          $(vm.selected.element).css({
            'background-color': 'rgba(0,0,0,0)',
            'border': 'none',
            'border-radius': '0px',
            'box-shadow': 'none'
          })
					let path = imageService.getPath(vm.selected)
					let imageParams = imageService.getImageParams(path)

          let variations
					delete imageParams.border
					delete imageParams.pad
					imageParams.fit = 'crop'
					imageParams.mask = helpers.squareFeather
					imageParams.fm = 'png'

					let filePath = imageParams.baseImage + '?'

					for (let key in imageParams) {
						if(key != 'baseImage') {
							filePath += key + '=' + imageParams[key] + '&'
						}
					}

					if(!$(vm.selected.element).hasClass('feathered'))$(vm.selected.element).addClass('feathered')
					if(!$(vm.selected.selector).attr('data-feathered'))$(vm.selected.selector).attr('data-feathered', 'true')
					if(!$(vm.selected.element).hasClass('edited'))$(vm.selected.element).addClass('edited')

					if(!vm.selected.image) {
						$(vm.selected.element).css({
							background: 'url(' + filePath + ')',
							'background-size': 'cover',
						})
					} else {
						$(vm.selected.selector).attr('src', filePath)
					}
					// if(!vm.selected.image) {
          // 	$(vm.selected.element).css('background-image', 'url(' + background + ')')
					// } else {
					// 	$(vm.selected.selector).attr('src', background)
					// }
					setUndoState()
        }

        function featherCircle() {
          $(vm.selected.element).css({
            'background-color': 'rgba(0,0,0,0)',
            'border': 'none',
            // 'border-radius': '50%',
            'box-shadow': 'none'
          })
					let path = imageService.getPath(vm.selected)
					let imageParams = imageService.getImageParams(path)

				  let variations
					delete imageParams.border
					delete imageParams.pad
					delete imageParams['corner-radius']
					imageParams.fit = 'crop'
					imageParams.mask = helpers.circleFeather
					imageParams.fm = 'png'
					imageParams.or = 0


					let filePath = imageParams.baseImage + '?'
					for (let key in imageParams) {
						if(key != 'baseImage') {
							filePath += key + '=' + imageParams[key] + '&'
						}
					}

					if(!vm.selected.image) {
						$(vm.selected.element).css({
							background: 'url(' + filePath + ')', //+ '?' + path +
							'background-size': 'cover',
						})
					} else {
						$(vm.selected.selector).attr('src', filePath)
					}

					if(!$(vm.selected.element).hasClass('edited'))$(vm.selected.element).addClass('edited')
					if(!$(vm.selected.element).hasClass('feathered'))$(vm.selected.element).addClass('feathered')
					if(!$(vm.selected.selector).hasClass('feathered'))$(vm.selected.selector).addClass('feathered')
					if(!$(vm.selected.selector).attr('data-feathered'))$(vm.selected.selector).attr('data-feathered', 'true')

					// if(!vm.selected.image) {
					// 	$(vm.selected.element).css('background-image', 'url(' + background + ')')
					// } else {
					// 	$(vm.selected.selector).attr('src', background)
					// }
					setUndoState()
				}
				
				// Divider Management

				function getDividerElements() {

					/*--------------------------------------------------------------------

					getDividerElements finds all divider and white border elements, then
					extracts the positions and widths of the elements. It then hands this
					data to calculateAlignmentGrids.

					---------------------------------------------------------------------*/

					const pageFolds           = []
					const refinedDividers     = []
					const refinedWhiteBorders = []
					vm.dividerElements        = []
					vm.whiteBorderElements    = []

					// find the divider elements
					scanForDividers()

					// function to add a page fold to the pageFolds array
					const addFold = ( position, whiteBorder ) => { pageFolds.push({ position, whiteBorder }) }

					// combines the dividers and whiteBorders
					refineDividerElement(vm.dividerElements, refinedDividers)
					refineDividerElement(vm.whiteBorderElements, refinedWhiteBorders, true)

					const noWhiteBordersFound          = refinedWhiteBorders.length === 0
					const unbalancedBordersAndDividers = refinedDividers.length !== refinedWhiteBorders.length

					if (noWhiteBordersFound) {

						// if no borders are found, add the dividers to the folds
						refinedDividers.map( divider => { addFold(divider.position, 0) } )

					} else if (unbalancedBordersAndDividers) {

						// if there are not as many white borders as dividers, match the dividers
						// with the existing white borders
						refinedDividers.map(divider => {
							for (const border of refinedWhiteBorders) {
								const right            = border.position + border.width / 2 
								const left             = border.position - border.width / 2
								const matchesPositions = left < divider.position && right >= divider.position

								matchesPositions ? addFold(divider.position, border.width) : addFold(divider.position, 0)
							}
						})

					} else {

						// if there are as many white borders as dividers, combine the dividers with the white borders
						refinedDividers.map((divider, index) => {
							
							const borderWidth  = refinedWhiteBorders[index].width
							const right        = divider.position + borderWidth / 2 
							const left         = divider.position - borderWidth / 2
							const withinBorder = left < divider.position && right >= divider.position

							withinBorder && addFold(divider.position, borderWidth)

						})

					}

					calculateAlignmentGrids(pageFolds)

				}

				function scanForDividers() {

					/*--------------------------------------------------------------------

					scanForDividers is what determines which elements of the product will
					be queried in order to find where the dividers and white borders are

					---------------------------------------------------------------------*/

					const checkNeightborsFirst  = ['nextElement', 'prevElement', 'scanTheme']
					const scanThemeFirst        = ['scanTheme', 'nextElement', 'prevElement']

					const checks = [
						{ scenario: 'middle',     scanOrder: checkNeightborsFirst },
						{ scenario: 'third',      scanOrder: checkNeightborsFirst },
						{ scenario: 'thirdWhite', scanOrder: scanThemeFirst       },
					]

					checks.map( check => { determineDivider( check.scenario, check.scanOrder ) } )

				}

				function determineDivider(scenario, checks) {

					/*--------------------------------------------------------------------

					determineDivider is responsible for finding and adding the right
					divider and whiteBorder elements to vm.dividerElements

					---------------------------------------------------------------------*/

					let dividerElement = ''

					// determines the divider element based off of the scenario
					switch(scenario) {
						case('middle')     : dividerElement = '.focused div.middle';      break;
						case('third')      : dividerElement = '.focused div.third';       break;
						case('thirdWhite') : dividerElement = '.focused div.third-white'; break;
						case('fold')       : dividerElement = '.focused div.fold';        break;
					}

					// declares any extra elements needed
					let elements        = []
					let scenarioElement = $(dividerElement)
					let twoThird        = $('.focused div.two-third')
					let twoThirdWhite   = $('.focused div.two-third-white')

					elements.push(scenarioElement)

					// adds the twoThirds and twoThirdsWhite if the third or thirdWhite scenario is selected
					scenario === 'third'      && elements.push(twoThird)
					scenario === 'thirdWhite' && elements.push(twoThirdWhite)

					if (scenarioElement.length) {

						// performs checks for white border until found
						for (let i = 0; i < checks.length; i++) {
							const foundBorder = findBorders(checks[i], elements)
							if ( foundBorder ) break
							if ( !foundBorder && i === checks.length - 1) vm.dividerElements.push(...elements)
						}
						
					}

					// scans for any dividers combined with a white border
					elements.map(element => isWhiteBorder(element) && vm.whiteBorderElements.push(element))

				}

				function findBorders(scenario, elements) {
					
					/*--------------------------------------------------------------------

					findBorders loops through various elements in search of a white
					border. If a white border is found, then the divider element will be
					written to vm.dividerElements, and the white border will be written
					to vm.whiteBorderElements. If not it will return false

					---------------------------------------------------------------------*/

					let whiteBorders = []

					if (scenario === 'scanTheme') {
						
						// loops through the theme element's children in search for a white border
						$('.focused .theme').children().each(function() {
							isWhiteBorder($(this)) && whiteBorders.push($(this))
						})

					} else if (scenario === 'nextElement') {

						// looks for the next element and checks if it is a white border
						elements.map(element => {
							isWhiteBorder(element.next()) && whiteBorders.push(element.next())
						})

					} else if (scenario === 'prevElement') {

						// looks for the previous element and checks if it is a white border
						elements.map(element => {
							isWhiteBorder(element.prev()) && whiteBorders.push(element.prev())
						})

					}

					// writes the dividers and the white border to vm if found
					const whiteBorderFound = whiteBorders.length !== 0
					whiteBorderFound && (vm.dividerElements     = [...vm.dividerElements, ...elements])
					whiteBorderFound && (vm.whiteBorderElements = [...vm.whiteBorderElements, ...whiteBorders])
					return whiteBorderFound

				}

				function isWhiteBorder(element) {
					// determines if an element is a white border for a divider
					const hasZeroPx       = element.css('width') === '0px' || '0'
					const hasWhiteOutline = element.css('outline') && element.css('outline').includes('rgb(255, 255, 255)')
					return hasZeroPx && hasWhiteOutline
				}

				function refineDividerElement(rawArray, refinedArray, addWidth) {

					/*--------------------------------------------------------------------

					refineDividerElement extracts the position and width of a divider.
					It will also sort the elements from left to right.

					---------------------------------------------------------------------*/

					const refineElement = element => {
						const dividerObject = {}

						// gathers the element's outline width
						const isROLServiceRecord = vm.product.name.includes('Service Records') && vm.collection.name.includes('Reflections of Life')
						const outlineWidth = isROLServiceRecord ? 1 : parseFloat(element.css('outline-width'))

						// finds the element's position and width
						dividerObject.position = parseFloat(element.css('left'))
						addWidth && (dividerObject.width = outlineWidth || 0)
						refinedArray.push(dividerObject)
					}

					// sorts the elements from left to right based off the position
					rawArray.map(element => refineElement(element))
					refinedArray.sort((a, b) => a.position - b.position)

				}

				function calculateAlignmentGrids(dividers) {

					/*--------------------------------------------------------------------

					calculateAlignmentGrids will measure each section of the product based
					on where the divders are located, and determine where the alignment
					points are for elements being dragged.

					It will then write an array with each section's alignment grid
					measurements to vm.alignmentGrid

					---------------------------------------------------------------------*/

					// master array of all grid points across all the product's sections
					let sections = []

					// product dimensions
					const productWidth  = $('.focused div.outlines')[0].offsetWidth
					const productHeight = $('.focused div.outlines')[0].offsetHeight

					// horizontal positions
					const productLeft   = 0
					const productCenter = productWidth / 2
					const productRight  = productWidth
					const productTop    = 0

					// horizontal offsets
					let leftOffset   = 0
					let centerOffset = 0
					let rightOffset  = 0

					// vertical positions
					const productMiddleTop    = productHeight * .25
					const productMiddle       = productHeight / 2
					const productMiddleBottom = productHeight * .75
					const productBottom       = productHeight

					// function to add a new section
					const addSection = (section, left, center, right) => {
						sections.push({
							section      : section,
							left         : left   + leftOffset,
							center       : center + centerOffset,
							right        : right  + rightOffset,
							top          : productTop,
							middleTop    : productMiddleTop,
							middle       : productMiddle,
							middleBottom : productMiddleBottom,
							bottom       : productBottom,
						})
					}

					// creates an offset to account for the full bleed register book's white border
					if ( vm.product.name.includes('Register Book') && !vm.product.name.includes('Front Insert') && vm.layout.name.includes('Full Bleed') ) {

						// determine whether a RB page has been shifted to the right by 39.6px or not
						const RBshiftedRight = $('.focused .theme').css('right') === "39.6px"

						// sets the horizontal offsets
						const setRBOffsets = ( left, center, right ) => {
							leftOffset   = left
							centerOffset = center
							rightOffset  = right
						}

						// adds 39.6px to RB pages that have been shifted to the right
						RBshiftedRight
							? setRBOffsets( 0, -39.6 / 2, -39.6 ) 
							: setRBOffsets( 39.6, 39.6 / 2, 0 )

					} 

					// calculate the pageBreak for a product with no dividers
					!dividers.length && addSection( 1, productLeft, productCenter, productWidth )

					// calculate the pageBreak between the target and the dividers
					dividers.map((divider, index) => {

						const { position, whiteBorder } = divider
						const prevBorder   = dividers[index - 1] && dividers[index - 1].whiteBorder || 0
						const nextBorder   = dividers[index + 1] && dividers[index + 1].whiteBorder || 0
						const prevPosition = dividers[index - 1] && dividers[index - 1].position    || productLeft
						const nextPosition = dividers[index + 1] && dividers[index + 1].position    || productRight

						// measures the left-most section
						if ( index === 0 ) {
							const rightBorder  = whiteBorder
							const sectionWidth = position   / 2

							const left   = prevPosition
							const center = sectionWidth - ( rightBorder / 2 )
							const right  = position - rightBorder

							addSection( 1, left, center, right )
						}

						// measures a center section
						if ( index !== 0 && dividers.length > 1 ) {
							const leftBorder   = prevBorder
							const rightBorder  = whiteBorder
							const sectionWidth = (position - prevPosition) / 2

							const left   = prevPosition + leftBorder
							const center = position - sectionWidth + ( leftBorder / 2 ) - ( rightBorder / 2 )
							const right  = position - rightBorder

							addSection( index + 1, left, center, right )
						}
						
						// measures the right-most section
						if ( index === dividers.length - 1 ) {
							const leftBorder   = whiteBorder
							const sectionWidth = (productRight - position) / 2

							const left   = position + leftBorder
							const center = position + sectionWidth + ( leftBorder / 2 )
							const right  = nextPosition

							addSection( dividers.length + 1, left, center, right )
						}
						
					})

					vm.alignmentGrid = sections

				}

				function dragAlign(target) {
					domHelpers.dragAlign( target, alignItem, vm.snap )
				}

				// Alignment

				function alignItem(target) {

					/*--------------------------------------------------------------------

					alignItem determines which section of the product a selected element
					is in, and will return the grid alignment points of the given section

					---------------------------------------------------------------------*/

					let sectionIndex = 0

					// gathers the targets positions and measurements
					const targetPosition = target.offsetLeft + (target.offsetWidth / 2)
					const measurements   = vm.alignmentGrid
					const leftEdge       = measurements[0].left
					const rightEdge      = measurements[measurements.length - 1].right

					// loops through all the products sections, and determines which one the target is in
					measurements.map((section, index) => {
						targetPosition > section.left && targetPosition < section.right && (sectionIndex = index)
					})

					// accounts for the target being dragged off the page
					targetPosition < leftEdge  && (sectionIndex = 0)
					targetPosition > rightEdge && (sectionIndex = measurements.length - 1)

					// returns the grid points for the target's section
					return measurements[sectionIndex]

				}

				function alignObject(positionElement, disableMultiSelect) {

					const isMultiSelect = !vm.selected.element || $(vm.selected.element).hasClass('multi-select')
					if ( isMultiSelect && disableMultiSelect ) return

					isMultiSelect
						? $('.multi-select').each( function() { positionElement(this) })
						: positionElement(vm.selected.element)

          dom.positionDelete()
          dom.positionResizer()
          dom.positionRotator()
					setUndoState();
				}

        function leftAlignObject() {
					const leftAlign = element => `${alignItem(element).left}px`
					const align     = element => $(element).css({ left: leftAlign(element), right : 'auto' })
					alignObject(align)
        }

        function centerVerticalAlignObject() {
					const centerAlign = element => `${alignItem(element).middle - parseFloat($(element).css('height')) / 2}px` 
					const align       = element => $(element).css({ top: centerAlign(element) })
					alignObject(align, true)
        }

        function rightAlignObject() {
					const rightAlign = element => `${alignItem(element).right - element.offsetWidth}px`
					const align      = element => $(element).css({ left: rightAlign(element), right : 'auto' })
					alignObject(align)
        }

        function topAlignObject() {
					if (!vm.selected.element || $(vm.selected.element).hasClass('multi-select')) {
						let multiTop = $('.focused .outlines')[0].offsetHeight
						$('.multi-select').each(function(){
 						 if(this.offsetTop <= multiTop) {
 							 multiTop = this.offsetTop
 						 	}
 					 	})
						$('.multi-select').each(function() {
							$(this).css('top', this.offsetTop - multiTop + 'px')
						})
					} else {
						$(vm.selected.element).css('bottom', 'auto')
						$(vm.selected.element).css('top', '0px')
					}
					dom.positionResizer()
					dom.positionRotator()
					dom.positionDelete()
					setUndoState();
				}

        function centerHorizontalAlignObject() {
					const centerAlign = element => `${alignItem(element).center - (parseFloat($(element).css('width')) / 2)}px`
					const align       = element => $(element).css({ left: centerAlign(element) })
					alignObject(align)
        }

        function bottomAlignObject() {
          if (!vm.selected.element || $(vm.selected.element).hasClass('multi-select')) {
              let bottom = $('.focused .outlines')[0].offsetHeight
              let multiBottom = bottom
              $('.multi-select').each(function(){
                   if(bottom - (this.offsetTop + this.offsetHeight) <= multiBottom) {
                       multiBottom = bottom - (this.offsetTop + this.offsetHeight)
                   }
           })
              $('.multi-select').each(function() {
                  $(this).css('bottom', (bottom - (this.offsetTop + this.offsetHeight)) - multiBottom  + 'px')
                  $(this).css('top', 'auto')
              })
          } else {
              $(vm.selected.element).css('top', 'auto')
              $(vm.selected.element).css('bottom', '0px')
          }
           dom.positionResizer()
           dom.positionRotator()
           dom.positionDelete()
					 setUndoState();
        }

				// Shape
				
        function ovalShape() {
					if(vm.selected.selector.data('type') !== 'image' && !vm.selected.image) {
						$(vm.selected.element).css('border-radius', '50%')
					} else {
						let path = imageService.getPath(vm.selected)

						var imageParams = imageService.getImageParams(path)
						$(vm.selected.element).css('border-radius', '50%')
						delete imageParams.mask
						delete imageParams.pad

						if(!vm.selected.selector.hasClass('feathered')) {
							imageParams.mask = 'ellipse'
						}
						imageParams.fm = 'png'

						var filePath = imageParams.baseImage + '?'
						for (var key in imageParams) {
							if(key != 'baseImage') {
								filePath += key + '=' + imageParams[key] + '&'
							}
						}
						$(vm.selected.element).css('border-radius', '50%')
						if(!vm.selected.image) {
							$(vm.selected.element).css({
								background: 'url(' + filePath + ')', //+ '?' + path +
								'background-size': 'cover',
								'background-color': vm.selected.backgroundcolor
							})
						} else {
							$(vm.selected.selector).attr('src',  filePath)
						}
						$(vm.selected.element).addClass('oval')
						$(vm.selected.selector).attr('data-oval', 'true')
						if(!$(vm.selected.element).hasClass('edited')) $(vm.selected.element).addClass('edited')
						if(!$(vm.selected.selector).attr('data-edited')) $(vm.selected.selector).attr('data-edited', 'true')
						$(vm.selected.element).removeClass('square')
						$(vm.selected.selector).removeAttr('data-square')
						vm.showBorder.image = false
						vm.showBorder.object = false
					}

					if($(vm.selected.element).hasClass('feathered') || $(vm.selected.selector).attr('data-feathered') ){
						var resetFeather = () => {
							return new Promise((resolve, reject) => {
								toggleFeather()
								resolve()
							})
						}
						var setFeather = () => {
							return new Promise((resolve, reject) => {
								toggleFeather()
								resolve()
							})
						}
						resetFeather().then(() => {
							return setFeather()
						})
					}
					setUndoState();
        }

        function squareShape() {
					if(vm.selected.selector.data('type') !== 'image' && !vm.selected.image) {
						$(vm.selected.element).css('border-radius', '0%')
					} else {
						let path = imageService.getPath(vm.selected)

						var imageParams = imageService.getImageParams(path)
						$(vm.selected.element).css('border-radius', '0%')
						delete imageParams.mask
						delete imageParams.corners
						imageParams.fm = 'png'

						var filePath = imageParams.baseImage + '?'
						for (var key in imageParams) {
							if(key != 'baseImage') {
								filePath += key + '=' + imageParams[key] + '&'
							}
						}

						if(!vm.selected.image) {
							$(vm.selected.element).css({
								background: 'url(' + filePath + ')', //+ '?' + path +
								'background-size': 'cover',
								'border-radius': '0px',
								'background-color': vm.selected.backgroundcolor
							})
						} else {
							$(vm.selected.selector).attr('src', filePath)
						}
						$(vm.selected.element).addClass('square')
						$(vm.selected.selector).attr('data-square', 'true')
						if(!$(vm.selected.element).hasClass('edited')) $(vm.selected.element).addClass('edited')
						if(!$(vm.selected.selector).attr('data-edited')) $(vm.selected.selector).attr('data-edited', 'true')
						$(vm.selected.element).removeClass('oval')
						$(vm.selected.selector).removeAttr('data-oval')
						vm.showBorder.image = false
						vm.showBorder.object = false
					}

					if($(vm.selected.element).hasClass('feathered') || $(vm.selected.selector).attr('data-feathered') ){
						var resetFeather = () => {
							return new Promise((resolve, reject) => {
								toggleFeather()
								resolve()
							})
						}
						var setFeather = () => {
							return new Promise((resolve, reject) => {
								toggleFeather()
								resolve()
							})
						}
						resetFeather().then(() => {
							return setFeather()
						})
					}
					setUndoState();
        }

				function updateOverlay() {
					$('*[data-type="shape"]:not(".new-shape")').css('opacity', (vm.overlayOpacity/100))
					setUndoState();
				}

				// Background Functions

				function updatePageLocation() {
					$('#editor .product .printedarea').each(function(index) {
						if($(this).hasClass('focused')) {

							// reset the zoom
							vm.scale = 1
							$(this).css({
								left: '50%',
								transform: 'translateX(-50%) scale(1)'
							})

							// determine which page is active and if it is the first or last page
							if(index > 0) vm.firstPage = false
							if(index < totalPages()) vm.lastPage = false
							if(index == totalPages()) vm.lastPage = true
							if(index == 0) {
								vm.firstPage = true
								vm.lastPage = false
							}
						}
					})
				}

				function selectPage(page, pageTitle) {
					vm.pageTitle = pageTitle
					domHelpers.selectPage(page)
					updatePageLocation()
					getPageLocation()
					setUndoState()
					vm.showBackground && showEditBackground()
					getDividerElements()
				}

				function forwardPage() {
					let page
					$('#editor .product .printedarea').each(function(index) {
						if($(this).hasClass('focused')) {
							if(index <= $('#editor .product .printedarea').length - 1) {
								page = index + 1
							}
						}
					})
					if(page < $('#editor .product .printedarea').length ) {
						updatePageLocation()
						selectPage(page)
						getPageLocation()
					}
				}

				function backPage() {
					let page
					$.each($('#editor .product .printedarea'), function(index) {
						if($(this).hasClass('focused')) {
							if(index > 0) {
								 page = index - 1
								 updatePageLocation()
								 selectPage(page)
							   getPageLocation()
							} else if (index == 0){
								vm.firstPage = true
								vm.lastPage = false
							}
						}
					})
				}

				function getPageLocation() {
					vm.registerPageTitles = []
					vm.singlePage = totalPages() <= 0
					$.each($('#editor .product .printedarea'), function(index) {
						if($(this).hasClass('focused')) {
								$anchorScroll(index)
								$('#' + index + ' .sheet-title').addClass('select')
						} else {
							if($('#' + index + ' .sheet-title').hasClass('select')) {
								$('#' + index + ' .sheet-title').removeClass('select')
							}
						}
					})
					pageTitle()
				}

				function getCurrentPage() {
					let currentPage = 0
					$.each($('#editor .product .printedarea'), function(index) {
						if($(this).hasClass('focused')) {
							currentPage = index + 1
						}
					})
					return currentPage
				}

				function applyTheme() {
					if(!vm.layout.background_watermark_edited && !vm.product.name.includes('16 x 20 Collage')) {
	          let theme_width = parseFloat(vm.layout.theme_width) * 72
	          let theme_height = parseFloat(vm.layout.theme_height) * 72
	          let page_width = parseFloat(vm.layout.paper_width) * 72
	          let page_height = parseFloat(vm.layout.paper_height) * 72

						$('.silhouette').remove()
						$('.watermark').remove()
						if(vm.collection.paper_type != 'preprinted' ) {
							if (vm.theme_layout.replacement_image) {
								$('#editor .printedarea .theme').css({
									width: theme_width + 'px',
									height: theme_height + 'px',
									'background-image': `url(${helpers.imgixTheme}${vm.theme_layout.replacement_image})`,
									'background-size': vm.theme_layout.background_fill,
									'background-position': vm.theme_layout.background_left + ' ' + vm.theme_layout.background_top,
									'background-repeat': 'no-repeat',
								})
							} else {
								$('#editor .printedarea .theme').css({
									width: theme_width + 'px',
									height: theme_height + 'px',
									'background-image': `url(${helpers.imgixTheme}${vm.theme.image})`,
									'background-size': vm.theme_layout.background_fill,
									"background-position": `${vm.theme_layout.background_left} ${vm.theme_layout.background_top}`,
									'background-repeat': 'no-repeat',
								})
							}
						} else {
							if(!vm.theme_layout.replacement_image || vm.product.name.includes('16 x 20 Collage')) {
	              $("#editor .printedarea  .theme").css({
	                background: 'none',
	                overflow: "hidden"
	              });
	            } else {
	              $("#editor .printedarea  .theme").css({
	                "background-image": `url(${helpers.imgixTheme}${vm.theme_layout.replacement_image})`,
	                "background-size": vm.theme_layout.background_fill,
	                "background-position": `${vm.theme_layout.background_left} ${vm.theme_layout.background_top}`,
	                'overflow': "hidden",
	                'background-repeat': 'no-repeat'
	              });
	            }

						}

						$timeout(() => {
						 	if (vm.firstWatermark && vm.theme_layout.first_watermark) {
							 	let watermark = `<img src="${helpers.imgixTheme}${vm.firstWatermark.image}" class="watermark first-watermark" id="first-watermark" style="width:${vm.firstWatermark.width}px; position:absolute; top:${vm.firstWatermark.top}px; left:${vm.firstWatermark.left}px; opacity:${vm.firstWatermark.opacity};">`
							 	$('#editor .product .printedarea:first .theme').append(watermark)
						 	}
							if (vm.secondWatermark && vm.theme_layout.second_watermark) {
								 let watermark = `<img src="${helpers.imgixTheme}${vm.secondWatermark.image}" class="watermark first-watermark" id="first-watermark" style="width:${vm.secondWatermark.width}px; position:absolute; top:${vm.secondWatermark.top}px; left:${vm.secondWatermark.left}px; opacity:${vm.secondWatermark.opacity};">`
								 $('#editor .product .printedarea:first .theme').append(watermark)
						 	}
						}, 500)
						if((vm.product.name != 'Register Book' || vm.product.name != 'Deluxe Register Book') && vm.layout.name != 'Full Bleed') {
							$('#editor .printedarea .theme').css('top', '0px' )
							$('#editor .printedarea .theme').css('left', '0px')
						}
					// } else {


					// 	save()

					}
					$('.theme').css('background-repeat', 'no-repeat')
        }

				function makeImgDefault(filename) {
					vm.case.personal_images_to_remove = vm.case.personal_images.slice()
					vm.case.personal_images = _.remove(vm.case.personal_images, function(interval) {
						return interval !== filename
					})
					vm.case.personal_images_to_add = vm.case.personal_images
					vm.case.personal_images_to_add.unshift(filename)

					const id = vm.case.id
					vm.saving = true

					const casePayload = {
						name_of_deceased: vm.case.name_of_deceased,
						personal_images_to_add: vm.case.personal_images_to_add,
						personal_images_to_remove: vm.case.personal_images_to_remove
					}

					cases.update(id, casePayload).then(response => {
							vm.case = response.data
							$rootScope.$emit("caseUpdated", response.data);
							vm.saving = false
							vm.placeCaseImages(true)
							localStorage.setItem('defaultImgUpdated', 'true')
					})
				}

				const newTemplateEventListener = $rootScope.$on('newTemplate', function(event, data) {
					vm.tempSwitch = true
					$('.printedarea').remove()
					getOrder(data.template.id, data.template.home_template).then(() => {
						dom.setMargin()
						$timeout(function(){
							dom.adjustPageHeight()
							save()

						},500)
					})
				})

				scope.$on('$destroy', () => newTemplateEventListener())

				async function setInitialElementAttributes() {
					await setInitialParagraphAttributes()
					await setInitialElementData()
					// await setInitialDoubleColumnAttributes()
					await setInitialSingleColumnAttributes()
					vm.tempSwitch = false
				}

				function setInitialParagraphAttributes() {
					const ser = vm.case.services.filter(item => item.default)[0];
					const service = ser ? ser : vm.case.services[0]
					return new Promise((resolve, reject) => {
						$('#editor .product textarea, #editor .product  p').each(function() {
							if(!$(this).hasClass('ql')) {
								$(this).attr('contenteditable', 'false')
							}
							if($(this)[0].outerHTML.indexOf('elastic') > -1){
								var textarea = $(this).prop('outerHTML')
								var paragraph = textarea.replace(/elastic=""/g, "")
								paragraph = paragraph.replace(/height: 16px/g, "")
								$(this).replaceWith(paragraph)
							}
						})

						$('#editor .printedarea p').each(function() { 
							//if the layout is new/default
							if($(this).data('caseinfo')) {
								$(this).text('')
								const fieldName =  $(this).data('caseinfo').replace('.details', '')
								let fieldValue = vm.$eval(fieldName)
								let text = ''
								if(fieldName.includes('case.service_time')) {										
									fieldValue = (service && service.time) ? `${service.time}` : ''		
									service && $(this).attr('data-caseinfo', `case.services[${service.index}].time`)								
									service && $(this).attr('data-id', `case.services[${service.index}].time`)								
									service && $(this).attr('data-label', `case.services[${service.index}].time`)								
								} else if(fieldName.includes('case.service_location')) {

									fieldValue = (service && service.location) ? `${service.location}` : ''
									service && $(this).attr('data-caseinfo', `case.services[${service.index}].location`)								
									service && $(this).attr('data-id', `case.services[${service.index}].location`)								
									service && $(this).attr('data-label', `case.services[${service.index}].location`)	
								} else if (fieldName.includes('case.service_date')) {
									fieldValue = (service && service.date) ? `${service.date}` : ''
									service && $(this).attr('data-caseinfo', `case.services[${service.index}].date`)								
									service && $(this).attr('data-id', `case.services[${service.index}].date`)								
									service && $(this).attr('data-label', `case.services[${service.index}].date`)	
								} else if(fieldName.includes('case.clergy_name')) {
									fieldValue = (vm.case.clergy && vm.case.clergy.length > 0 && `${vm.case.clergy[0]}` != 'null')  ? `${vm.case.clergy[0]}` : ''
									$(this).attr('data-caseinfo', `case.clergy[0]`)								
									$(this).attr('data-id', `case.clergy[0]`)								
									$(this).attr('data-label', `case.clergy[0]`)	
								} else {
									fieldValue = vm.$eval(fieldName)
								}
								if(typeof fieldValue == 'object' && fieldValue != null && fieldValue.length > 1){
									fieldValue = `${fieldValue.reduce((a,b) => a.concat('<br>' + b))}`
								}
								const parent = $(this).parent()
								const fieldHTML = $(this).html(fieldValue)

								$(this).remove()
								$(parent).append(fieldHTML)
							}

							if($(this)[0].hasAttribute("data-casetitle") ) {
								var datafield = $(this).data('casetitle')
								var test1 = vm.$eval(datafield)
								var parent = $(this).parent()
								var par = $(this).text(test1)
							}
							//change the preset headers to the funeral home's presets.
							if ($(this)[0].hasAttribute("data-casetitle")) {
								let datafield = 'helpers.' + $(this).data("casetitle");
								let titleField = datafield.replace('.title', '.handlebar')
								let title = eval(titleField).replace('case.', '').replace(" | date: 'longDate'", '').replace(" | date: 'MMMM d, yyyy'", '')
								let test1 = eval(datafield);
								let parent = $(this).parent();
								let par = $(this).text(test1);
								$(this).remove()
								let newPar = $compile(par)(vm)[0]

								$(parent).append(newPar)
								for (let field in funeralHomeSettings.settings) {
									if (!funeralHomeSettings.settings.hasOwnProperty(field)) continue;
									if(field.indexOf('case') != -1) {
										if(field.indexOf(title) != -1) {
											let newTitle = funeralHomeSettings.settings[field]
											let newParent = $(this).parent()
											let par2 = $(this).text(newTitle)
											$(this).remove()
											let newPar2 = $compile(par2)(vm)[0]
											$(newParent).append(newPar2)
										}
									}
								}
							}
							if (!$(this).data('caseinfo')) {
								var textarea = $(this).prop('outerHTML')
								var paragraph = textarea.replace(/\r\n|\r|\n/g, "<br />")
								$(this).replaceWith(paragraph)
							}
						})
						resolve('Paragraph values set')
					})
				}

				function setInitialElementData() {
					
					return new Promise((resolve, reject) => {
						let ser = vm.case.services.filter(item => item.default)[0];
						const service = ser ? ser : vm.case.services[0]

						// Updated code for handling case-info
						$(`#editor .printedarea p.ql cite`).each(function() {
							//some discussion this is causing the dashes problem
							const citeElement = $(this)
							let text = '';
							if (citeElement.hasClass('ql-data-content')) {
								citeElement.text('')
								var caseinfo = citeElement.data('label').replace(" | date: 'MMMM d, yyyy'", "")
								if (caseinfo == 'undefined') {
									var caseinfo = citeElement.data('id')
								}
								if (caseinfo === "case.service_time") {
									text = (service && service.time) ? `${service.time}` : ''
									service && citeElement.attr('data-caseinfo', `case.services[${service.index}].time`)
									service && citeElement.attr('data-id', `case.services[${service.index}].time`)
									service && citeElement.attr('data-label', `case.services[${service.index}].time`)
								} else if (caseinfo === "case.service_location") {

									let parent, parentClone
									text = (service && service.location) ? `${service.location}]\n${service.city ? `[${service.city}], ` : ''}${service.state ? `[${service.state}` : ''}` : ''
									service && !service.state && service.city && (text = `${service.location}]\n${service.city ? `[${service.city}` : ''}`)
									service && !service.city && !service.state && (text = service.location)
									service && citeElement.attr('data-caseinfo', `case.services[${service.index}].location`)
									service && citeElement.attr('data-id', `case.services[${service.index}].location`)
									service && citeElement.attr('data-label', `case.services[${service.index}].location`)

									if (service && service.city || service && service.state) {
										parent = citeElement.parent().parent()
										parentClone = parent.clone(true)
										parentClone.children('span').children()[0].remove()
										parent.after(parentClone)
									}

									if (service && service.city) {
										const city = citeElement.clone()
										service && city.attr('data-caseinfo', `case.services[${service.index}].city`)
										service && city.attr('data-id', `case.services[${service.index}].city`)
										service && city.attr('data-label', `case.services[${service.index}].city`)
										parentClone.children('span').append(city)
									}

									if ( service && service.state) {
										const state = citeElement.clone()
										service && state.attr('data-caseinfo', `case.services[${service.index}].state`)
										service && state.attr('data-id', `case.services[${service.index}].state`)
										service && state.attr('data-label', `case.services[${service.index}].state`)
										parentClone.children('span').append(state)
									}

								} else if (caseinfo.includes("case.service_date")) {
									text = (service && service.date) ? service.date : ''
									text === 'Invalid date' && (text = '')
									service && citeElement.attr('data-caseinfo', `case.services[${service.index}].date`)
									service && citeElement.attr('data-id', `case.services[${service.index}].date`)
									service && citeElement.attr('data-label', `case.services[${service.index}].date`)
								} else if (caseinfo === "case.clergy_name") {
									text = (vm.case.clergy && vm.case.clergy.length > 0 && `${vm.case.clergy[0]}` != 'null') ? `${vm.case.clergy[0]}` : ''
									citeElement.attr('data-caseinfo', `case.clergy[0]`)
									citeElement.attr('data-id', `case.clergy[0]`)
									citeElement.attr('data-label', `case.clergy[0]`)
								} else {
									text = vm.$eval(caseinfo);
								}
								if (text == 'undefined' || text == undefined) {
									text = ''
								}
								citeElement.text('[' + text + ']')
								citeElement.attr('data-id').includes('city') && citeElement.text(`${citeElement.text()}, `)
							}
						})

						// Old code for handling case-titles 
						$('#editor .printedarea p.ql cite').each(function() {
							if($(this)[0].hasAttribute("data-casetitle") ) {
								if($(this).data('casetitle')) {
										let datafield = 'helpers.' + $(this).data("casetitle");
										let titleField = datafield.replace('.title', '.handlebar')
										let title = eval(titleField).replace('case.', '').replace(" | date: 'longDate'", '').replace(" | date: 'MMMM d, yyyy'", '')
										let test1 = eval(datafield);

										$(this).removeAttr('data-label')
										$(this).removeAttr('data-id')
										$(this).removeAttr('data-casetitle')
										$(this).removeAttr('data-casefield')
										$(this).removeAttr('data-caseinfo')
										$(this).removeClass('ql-data-content')
										$(this).parents('p').removeAttr('data-caseinfo')
										let parent = $(this).parent();
										let par = `<span>${test1}</span>`
										let newPar = $compile(par)(vm)[0]
										$(this).remove()
										$(parent).append(newPar)

										for (let field in funeralHomeSettings.settings) {
											if (!funeralHomeSettings.settings.hasOwnProperty(field)) continue;
											if(field.indexOf('case') != -1 && funeralHomeSettings.settings[field] != null) {
												if(field.indexOf(title) != -1) {
													let newTitle = funeralHomeSettings.settings[field]
													$(parent).html('')
													let par2 = `<span>${newTitle}</span>`
													let newPar2 = $compile(par2)(vm)[0]
													$(parent).append(newPar2)
												}
											}
										}

								}
								else if($(this).data('label')) {
									$(this).text('')
									let test =  $(this).data('label')
									if(test == 'undefined') {
										let test = $(this).data('id')
									}
									let test1 = vm.$eval(test)
									if(test1 == 'undefined' || test1 == undefined) {
										test1 = ''
									}
									// let parent = $(this).parent()
									let par = $(this).text('[' + test1 + ']')
									$(this).remove()
									let newPar = $compile(par)(vm)[0]
									$(parent).append(par)
								}
							}
							
						})
						
						resolve('Quill values set')
					})
				}

				function setInitialSingleColumnAttributes() {
					return new Promise((resolve, reject) => {
				////LEAVE in PLACE FOR FUTURE EVEN THOUGH THEY NO WANT
				// 		//update the quill casefields of array values
				// 		$('#productBuild .printedarea p.ql').each(function(index){
				// 			let parent, field, data
				// 				$(this).find('cite[data-multi="true"]').each(function(index) {
				// 				parent = $(this).parent()
				// 				const compare1 = data ? data.substring(0, data.indexOf('[')) : null
				// 				const compare2 = $(this).attr('data-caseinfo').substring(0, $(this).attr('data-caseinfo').indexOf('['))
				// 				if(data && compare1 === compare2) {
				// 					//do nothing -> continue to remove(); below
				// 				} else {
				// 					data = $(this).attr('data-caseinfo')

				// 					//get rid of 'data-caseinfo=' case.field and '[...

				// 					if(data) field = `${data.substring(5, data.indexOf('[')).toLowerCase()}`
								
				// 					const style = $(this).attr('data-columns') == 'true' ? "width: 50%; display: inline-block; margin: 0;" : "width: 100%; display:inline-block; margin:0;" 
				// 					const columnClass = $(this).attr('data-columns') == 'true' ? "columns" : "" 
				// 					const columns = $(this).attr('data-columns') == 'true' ? {data: 'data-columns', value: 'true'} : {};

				// 					if(field) {
				// 						for (let n in vm.case[field]) {
				// 							const caseField = dom.HtmlElement.create('cite')
				// 								.addClasses([
				// 									'ql-data-content',
				// 									columnClass
				// 								])
				// 								.addAttrs([
				// 									{data: 'data-label',value: `case.${field}[${n}]`},
				// 									{data: 'data-caseinfo',value: `case.${field}[${n}]`},
				// 									{data: 'data-id',value: `case.${field}[${n}]`},
				// 									{data: 'data-multi',value: 'true'},
				// 									columns,
				// 									{data: 'style',value: style},
				// 								])
				// 								.addTextContent(`[{{case.${field}[${n}]}}]`)
				// 								.appendTo(parent[0])
				// 						}
				// 					}
				// 				}
				// 				$(this).remove()
				// 				})
				// 		})
						resolve('column values set')
					})
				}

        async function loadProduct() {
					let saved = false
					saved = vm.layout.saved

					const updatedImage = localStorage.getItem('defaultImgUpdated')
 					if(!vm.case.personal_images || vm.case.personal_images.length == 0) {
 						localStorage.removeItem('defaultImgUpdated')
 					}
 					if(updatedImage && vm.case.personal_images) {
 						makeImgDefault(vm.case.personal_images[0])
 						save()
 					}

          $('#editor .product').html('')

					calculateAge()
					await sortAndCompilePages()
					setInitialElementAttributes()
					sortablePages()
					prepareParagraphElements(saved)
					placeLogo()
					placeCaseImages()
					setQuillOptions()
					setElementIcons()
					handleUniqueProductSpecs()
					setInitialQuillAttributes()
					setPageDimensions()
					getDividerElements()

          //Detect if background is hidden for state in sidebar
          if ($('.theme').css('display') == 'none') {
            vm.activeBackground = false
          }

          //Detect if background is hidden for state in sidebar
          if ($('.theme').css('display') == 'none') {
            vm.activeBackground = false
          }

          //Clearing any background set in the DB to minimize flash before applying theme background
					if(!vm.layout.background_watermark_edited) {
          	$('#editor .printedarea .theme').css('background-image', 'none')
					}

					/*
						If the product is Register Books: Extra Pages, there will not be any Quill
						textboxes on its initial load, meaning the function applyWhenElementExists
						will run the full default cycle (50ms intervals for 200 intervals) before
						returning the promise. For that reason, if the product is Extra pages
						we alter the default cycle to process more quickly, yet still trying to
						account for slower load times.
					*/
					if(vm.product.name.includes('Extra')) {
						await helpers.applyWhenElementExists($('#editor .product .printedarea .outlines p'), setInitialQuillAttributes, 50, 20);
						await helpers.applyWhenElementExists($('#editor .product .printedarea .outlines .ql-editor p'), addQlClass, 50, 5);
						await helpers.applyWhenElementExists($('#editor .product .printedarea'), setProductLabel, 50, 5);
					} else {
						await helpers.applyWhenElementExists($('#editor .product .printedarea .outlines p'), setInitialQuillAttributes);
						await helpers.applyWhenElementExists($('#editor .product .printedarea .outlines .ql-editor p'), addQlClass);
						await helpers.applyWhenElementExists($('#editor .product .printedarea'), setProductLabel);
					}

					findTheme()
					domHelpers.setInlineLineHeight()
					pageTitle()
					setProductZoom()
        }

				function setPageDimensions() {
					const paper_height = parseFloat(vm.layout.theme_height) * 72
          const paper_width = parseFloat(vm.layout.theme_width) * 72
					//Set dimensions of each page
					$('#editor .printedarea').css({
						width: paper_width  + 'px',
						height: paper_height + 'px'
					})

					const widthRatio = parseInt($('#editor .printedarea').css('width'))/ parseInt($('#editor .printedarea').css('height'))
					vm.pageDimensions.height = 115
					vm.pageDimensions.width = 115 * widthRatio

					vm.pageDimensions.scale = vm.pageDimensions.width / parseInt($('#editor .printedarea').css('width'))

					$('#editor .edit').css({
						width: paper_width + 'px'
					})
				}

				function sortablePages() {
					if(canAlterPages()) {
						$('#sortable').sortable({
							axis: 'x',
							update: function(event, ui) {
								var index = $(ui.item).data('page')
								var newIndex = $(ui.item).next().data('page')
								var element = $('.printedarea')[index]
								shufflePage(element, index, newIndex)

								vm.registerPageTitles = []
								scope.$apply()
								pageTitle()
								scope.$apply()
							}
						})
					}
				}

				function calculateAge(){
					const cleanDate = date => date.replace(/(\d+)(st|nd|rd|th)/, "$1");
					if(!vm.case.date_of_birth){
						vm.case.date_of_birth = null
					}
					if(!vm.case.date_of_death){
						vm.case.date_of_death = null
					}
					if(vm.case.date_of_birth && vm.case.date_of_death){
						var birth = moment.utc(cleanDate(vm.case.date_of_birth))
						var death = moment.utc(cleanDate(vm.case.date_of_death))

						var years = death.diff(birth, 'years')
						vm.case.age = death.diff(birth, 'years')
						vm.case.age_years = death.diff(birth, 'years')

						death = death.subtract(vm.case.age_years, 'years')
						vm.case.age_months = death.diff(birth, 'months')
						death = death.subtract(vm.case.age_months, 'months')
						vm.case.age_days = death.diff(birth, 'days')
					}
				}

				function setProductLabel() {
					const side = $compile('<h6 class="side-indicator" style="margin: 10px auto; width: auto; text-align: center; cursor: default" >{{pageTitle}}</h6>')(vm)[0]

					$('#editor .product .side-indicator').each(function(){
						$(this).remove()
					})
					$(side).attr('contenteditable', 'false')
					$(side).insertBefore('#editor .product .printedarea:nth-child(1)')
				}

				function sortAndCompilePages() {
					return new Promise((resolve, reject) => {
						vm.pages.sort((a,b) => {
							return (a.page_number > b.page_number) ? 1 : ((b.page_number > a.page_number ? -1 : 0))
						})

						for (var i in vm.pages) {
							//Add elastic directive for textareas to size correctly to minimize overlapping, and auto grow when they type
							vm.pages[i].template = vm.pages[i].template.replace(/<textarea/g, '<p').replace(/textarea>/g, 'p>') // REVIEW: Doesn't seem to affect things; elastic still getting through on <p> tags
							//Compile content and add it to .product
							var el = $compile(vm.pages[i].template)(vm)[0]

							$('#editor .product').append(el)
							$('#editor .product .printedarea').last().attr('data-page-id', vm.pages[i].id)
							$('#editor .product .printedarea').last().removeClass('floralPage')
							$('#editor .product .printedarea').last().removeClass('memorialPage')
							$('#editor .product .printedarea').last().removeClass('condolencePage')
							$('#editor .product .printedarea').last().removeClass('relativesPage')
						}
						resolve('Pages compiled')
					})
				}

				function prepareParagraphElements(saved) {
					if(!saved){
						$('#editor .product p').each(function() {
							if ($(this).hasClass('default-font') && vm.themeFont) {
								if($(this).parent().hasClass('ql-editor')) {
									$(this).addClass('ql-font-' + vm.themeFont.replace(/( )/g, ''))
									$(this).find('span').addClass('ql-font-' + vm.themeFont.replace(/( )/g, ''))
									$(this).find('cite').addClass('ql-font-' + vm.themeFont.replace(/( )/g, ''))
								} else {
									$(this).css('font-family', vm.themeFont)
								}
							} else if (vm.funeralHomeSettings) {
								if(vm.funeralHomeSettings.default_font) {
									if($(this).parent().hasClass('ql-editor')) {
										$(this).removeClass((index, className) => {
											return (className.match(/\bql-font-([^\s]+)/g) || []).join(' ');
										});
										$(this).addClass('ql-font-' + vm.funeralHomeSettings.default_font.replace(/( )/g, ''))
										$(this).find('span').removeClass((index, className) => {
											return (className.match(/\bql-font-([^\s]+)/g) || []).join(' ');
										});
										$(this).find('span').addClass('ql-font-' + vm.funeralHomeSettings.default_font.replace(/( )/g, ''))
										$(this).find('cite').removeClass((index, className) => {
											return (className.match(/\bql-font-([^\s]+)/g) || []).join(' ');
										});
										$(this).find('cite').addClass('ql-font-' + vm.funeralHomeSettings.default_font.replace(/( )/g, ''))
									}
									else {
										$(this).css('font-family', vm.funeralHomeSettings.default_font)
									}
								}
							}
							if (!$(this).data('caseinfo')) {
								var textarea = $(this).prop('outerHTML')
								var paragraph = textarea.replace(/\r\n|\r|\n/g, "<br />")
								$(this).replaceWith(paragraph)
							}
						})

						$('#editor .product textarea').each(function(){
							//Put in default font if none is defined
							if($(this).inlineStyle('font-family') == undefined){
								$(this).css('font-family','Century Gothic')
							}
						})
					}
				}

				function setElementIcons() {
					$('#editor .product .resizer, #editor .product .rotator, #editor .product .deletor').each(function() {
						$(this).remove()
					})

					//Reset Focused state
					$('*').removeClass('focused').removeClass('resizer-target').removeClass('rotator-target').removeClass('deletor-target').removeClass('selected')

					//Set focus on first page
					$('#editor .product .printedarea').first().addClass('focused')
					//Add rotator icon and functionality to each page
					var rotator = $compile('<i class="glyphicon glyphicon-repeat rotator"></i>')(vm)
					var resizer = $compile('<i class="glyphicon glyphicon-fullscreen resizer"></i>')(vm)
					var deletor = $compile('<i class="icon-delete-circle deletor" ng-click="deleteElement()"></i>')(vm)
					$('#editor .product .printedarea .outlines').append(rotator)
					$('#editor .product .printedarea .outlines').append(resizer)
					$('#editor .product .printedarea .outlines').append(deletor)
				}

				function handleUniqueProductSpecs() {
					if(vm.product.name == 'Thank You Cards' && vm.layout.name == 'White Border') {
						$('#editor .product .printedarea').children('div').each(function() {
							if(!$(this).hasClass('outlines') && !$(this).hasClass('theme')) {
								$(this).addClass('middle')
								$(this).css('z-index', '1')
							}
						})
					}

					if(vm.product.name === 'Register Book' || vm.product.name === "Deluxe Register Book") {
						if(!vm.layout.saved) {
							$('#editor .product .printedarea').each(function() {
								$('.printedarea .glyphicon-trash').each(function(){
									$(this).remove()
								})
								$('.glyphicon-arrow-up').each(function(){
									$(this).remove()
								})
								$('.glyphicon-arrow-down').each(function(){
									$(this).remove()
								})

							})
						}
					}
				}

				function setInitialQuillAttributes() {
					$('#editor .product .printedarea .outlines p').each(function() {
						if(!$(this).hasClass('draggable') && !$(this).hasClass('selectable') && !$(this).hasClass('ql')) {
							$(this).remove()
						} else if($(this).attr('contenteditable')) {
							//$(this).removeAttr('contenteditable')
						}
					})
					$compile($('.oldQuill'))(vm)

					$('#editor .product .outlines').find('*[data-type=text]').each( function(){
							$(this).attr('uib-tooltip', 'Double-Click to Edit')
							$(this).attr('tooltip-placement', 'top')
							$(this).attr('tooltip-trigger', 'outsideClick')
							$(this).attr('tooltip-enable', '{{topLayer}}')
							$compile($(this))(vm)
					})
					$compile($('.outlines'))(vm)
					//remove random empty/stuck divs that have been added to a users product by broken text boxes
					//looks for divs without class and style to determine a div with no purpose
					$('#editor .product .printedarea .outlines').find('div:not([class]) div:not([style])').each(function() {
						$(this).remove()
					})
					$('.ql-editor').css({'padding': '6px', 'box-sizing': 'border-box', 'font-family': ''} )
					$('.ql-container').css('font-size', '1em')
					$('.ql-editor').find('p').each(function(){
						var line = $(this)[0].style.cssText.indexOf('line-height')

						if(line == -1) {
							$(this).css('line-height', '1.2')
						}
					});

					$('.ql-editor').find('*[class*=ql-weight]').each(function(){
						let match = false
						let weight = $(this).css('font-weight')
						let weightName
						for (let font of helpers.fonts) {
							if (font.name == $(this).css('font-family').replace(/"/g, '')) {
								if(font.weights){
									for (let weights of font.weights) {
										if(weights.weight == $(this).css('font-weight')) {
											match = true
											break;
										}
									}
								}
							}
						}
						if (!match) {
							if(weight == 800) {
								weightName = 'ql-weight-Bold'
							} else if( weight == 700) {
								weightName = 'ql-weight-Bold-Italic'
							} else if( weight == 600) {
								weightName = 'ql-weight-Italic'
							}
							$(this).removeClass(weightName)
						}
					})
				}

				function addQlClass() {
					$('#editor .product .printedarea .outlines .ql-editor p').each(function() {
						if(!$(this).hasClass('ql')) {
							$(this).addClass('ql')
						}
					})
				}

				function pageTitle() {
					$.each($('#editor .product .printedarea'), function(index) {
						var printedPage = {}
						printedPage.page = $(this)[0]
						printedPage.html = $(this)[0].outerHTML
							if(index % 2 == 0) {
								printedPage.title = `Front | p. ${(Number(index) + 1)} of ${$('#editor .product .printedarea').length}`
							} else {
								printedPage.title = `Back | p. ${(Number(index) + 1)} of ${$('#editor .product .printedarea').length}`
							}
						vm.registerPageTitles.push(printedPage)
						if($(this).hasClass('focused')) vm.pageTitle = printedPage.title

					})
				}

				function setProductZoom() {
					if(vm.product.name.includes('Memorial Collage')) {
						for(let i = 0; i < 5; i++) {
							zoomOut()
						}
					}
				}

				function imageSizeAlertDismiss(size) {
					if(size === 'large') {
						localStorage.largeImageAlert = true
					}
					if(size === 'small') {
						localStorage.smallImageAlert = true
					}
				}

        function setEditorHeight() {
					dom.setEditorHeight()
          $(window).resize(function() {
            dom.setEditorHeight()
          })
        }

        function setSelectProducts() {
          $('.product').on('mousedown', '.element', function($event) {
            selectElement($event)
					})
        }

        function setCropperDrag() {
          $('#main').on('mousedown', '.crop-tool', function($event) {
            var startWidth, startHeight, initialMouseX, initialMouseY;
            if(vm.cropImage.modal === 'editImage') {
              var cropArea = $('.crop-area-edit')
            } else {
              cropArea = $('.crop-area')
            }
            startWidth = parseInt(cropArea.css('width'))
            startHeight = parseInt(cropArea.css('height'))

            initialMouseX = $event.clientX;
            initialMouseY = $event.clientY;

            var wrapper = $('.crop-wrapper')

            $document.bind('mousemove', mousemove);
            $document.bind('mouseup', mouseup);

            function mousemove($event) {
              var dx = $event.clientX - initialMouseX;
              var dy = $event.clientY - initialMouseY;
              var newWidth, newHeight
              var cropAreaWidth = (startWidth + dx)
              var cropAreaHeight = (startHeight + dy)
              var cropAreaWidthAndLeft = cropAreaWidth + parseInt(cropArea.css('left'))
              var cropAreaHeightAndTop = cropAreaHeight + parseInt(cropArea.css('top'))
              var wrapperWidth = parseInt(wrapper.css('width'))
              var wrapperHeight = parseInt(wrapper.css('height'))

              if (cropAreaWidthAndLeft > wrapperWidth) {
                newWidth = cropAreaWidth - (cropAreaWidthAndLeft - wrapperWidth)
              } else {
                newWidth = (startWidth + dx)
              }
              if (cropAreaHeightAndTop > wrapperHeight) {
                newHeight = cropAreaHeight - (cropAreaHeightAndTop - wrapperHeight)
              } else {
                newHeight = (startHeight + dy)
              }

              cropArea.css({
                width: newWidth + 'px',
                height: newHeight + 'px'
              });

              positionCroptool()

              return false;
            }

            function mouseup() {
              $document.unbind('mousemove', mousemove);
              $document.unbind('mouseup', mouseup);
            }
          })
        }

        function setResizerDrag() {
          $('.product').on('mousedown', '.focused .resizer', function($event) {
            var startWidth, startHeight, initialMouseX, initialMouseY;

            startWidth = parseInt($('.resizer-target').css('width'))
            startHeight = parseInt($('.resizer-target').css('height'))
            initialMouseX = $event.clientX;
            initialMouseY = $event.clientY;

            var hasResized = false;

            $document.bind('mousemove', mousemove);
            $document.bind('mouseup', mouseup);

            function mousemove($event) {
              // if (!hasResized) {
              //   setUndoState()
              //   hasResized = true;
              // }
              var dx = ($event.clientX - initialMouseX)/ vm.scale;
              var dy = ($event.clientY - initialMouseY)/ vm.scale;

              var ratio = startHeight / startWidth

              scope.$apply(function() {
                vm.selected.width = Math.round(startWidth + dx)
                vm.selected.height = Math.round(startHeight + (dx * ratio))
              })
              if ($('.resizer-target').data('type') == 'image') {
                $('.resizer-target').css({
                  width: startWidth + dx + 'px',
                  height: startHeight + (dx * ratio) + 'px'
                });
              } else if($('.resizer-target').hasClass('line')) {
								$('.resizer-target').css({
                  width: startWidth + dx + 'px',
                  // height: startHeight + dy + 'px'
                });

							} else {
                $('.resizer-target').css({
                  width: startWidth + dx + 'px',
                  height: startHeight + dy + 'px'
                });
              }
              dom.positionResizer()
              dom.positionRotator()
              dom.positionDelete()

              return false;
            }

            function mouseup() {
              $document.unbind('mousemove', mousemove);
              $document.unbind('mouseup', mouseup);
							setUndoState()
							sizeCheck()
            }

						function sizeCheck() {
							var img = new Image()
							img.src = $('.resizer-target').css('background-image').replace('url("', '').replace('")', '')
							$(img).load(function(){
								if(vm.selected.width >= (img.width + (img.width/2))) {
									$('#smallImage-modal').modal('show')
									// alert("Maximum image resolution as been reached, poor print quality may result if image is kept this size.")
								}
							})
						}
          })
        }

        function setRotatorDrag() {
          $('.product').on('mousedown', '.focused .rotator', function($event) {
            var startRotate, initialMouseX, initialMouseY;

            if ($('.rotator-target').css('transform') && $('.rotator-target').css('transform') !== 'none') {
              var values = $('.rotator-target').css('transform').split('(')[1].split(')')[0].split(',')
              var a = values[0];
              var b = values[1];
              var c = values[2];
              var d = values[3];
              var scale = Math.sqrt(a * a + b * b);
              var sin = b / scale;
              var angle = Math.round(Math.atan2(b, a) * (180 / Math.PI))
              startRotate = angle
            } else {
              startRotate = 0
            }

            initialMouseX = $event.clientX;
            initialMouseY = $event.clientY;

            var hasRotated = false;

            $document.bind('mousemove', mousemove);
            $document.bind('mouseup', mouseup);

            function mousemove($event) {
              // if (!hasRotated) {
              //   setUndoState()
              //   hasRotated = true;
              // }
              var dx = $event.clientX - initialMouseX;
              var dy = $event.clientY - initialMouseY;

              vm.selected.rotate = startRotate + (dy / 2)

              $('.rotator-target').css({
                '-webkit-transform': 'rotate(' + vm.selected.rotate + 'deg)',
                '-moz-transform': 'rotate(' + vm.selected.rotate + 'deg)',
                '-o-transform': 'rotate(' + vm.selected.rotate + 'deg)',
                '-ms-transform': 'rotate(' + vm.selected.rotate + 'deg)'
              })
              dom.positionRotator()

              return false;
            }

            function mouseup() {
              $document.unbind('mousemove', mousemove);
              $document.unbind('mouseup', mouseup);
							setUndoState()
            }
          })
        }

        function positionCroptool() {
          if(vm.cropImage.modal === 'editImage') {
            var target = $('.crop-area-edit')
          } else {
            target = $('.crop-area')
          }
					dom.positionCroptool(target)
        }

        function setDraggables() {
          $('.product').on('mousedown', '.draggable', function($event) {

            var startX, startY, initialMouseX, initialMouseY;

            var target = $event.target
            if (!$(target).hasClass('multi-select')) {
              if ($(target).hasClass('draggable') && !$(target).hasClass('double-clicked')) {
                $(target).css({
                  'position': 'absolute',
                  'cursor': 'pointer'
                });

                var hasMoved = false;

                startX = $(target).prop('offsetLeft');
                startY = $(target).prop('offsetTop');
                initialMouseX = $event.clientX;
                initialMouseY = $event.clientY;

                $document.bind('mousemove', mousemove);
                $document.bind('mouseup', mouseup);

                var targetLeftCenter = target.offsetLeft + (target.offsetWidth / 2)
                var targetHorizontal = target.offsetTop + (target.offsetHeight / 2)

                var pageBreak = alignItem(target).center

                function mousemove($event) {
                  if (!hasMoved) {
                    //setUndoState()
                    $('div.tooltip').remove()
                    hasMoved = true
                  }

                  var dx = ($event.clientX - initialMouseX) / vm.scale;
                  var dy = ($event.clientY - initialMouseY) / vm.scale;
                  dom.positionResizer()
                  dom.positionRotator()
                  dom.positionDelete()
                  $(target).css({
                    top: startY + dy + 'px',
                    left: startX + dx + 'px'
                  });

									targetLeftCenter = target.offsetLeft + (target.offsetWidth / 2)
                  targetHorizontal = target.offsetTop + (target.offsetHeight / 2)
                  dragAlign( target )
                  return false;
                }

                function mouseup() {
                  $document.unbind('mousemove', mousemove);
                  $document.unbind('mouseup', mouseup);
                  dom.removeAlightmentOutline()
									setUndoState()
                }
              } else {
                //For IE because pointer events doesn't work
                //replaceDivsInContenteditable()
              }
            }
          })

          $('#cropImageModal, #editImageModal').on('mousedown', '.draggable', function($event) {
            var startX, startY, initialMouseX, initialMouseY;
            var target = $event.target

            $(target).css({
              'position': 'absolute',
              'cursor': 'pointer'
            });

            startX = $(target).prop('offsetLeft');
            startY = $(target).prop('offsetTop');
            initialMouseX = $event.clientX;
            initialMouseY = $event.clientY;

            $document.bind('mousemove', mousemove);
            $document.bind('mouseup', mouseup);

            function mousemove($event) {
              var dx = ($event.clientX - initialMouseX) / vm.scale;
              var dy = ($event.clientY - initialMouseY) / vm.scale;
              var top
              var left

              if ((startY + dy) > 0) {
                top = startY + dy
              } else {
                top = 0
              }
              if ((startX + dx) > 0) {
                left = startX + dx
              } else {
                left = 0
              }
              if (((startX + dx) + parseInt($(target).css('width'))) > parseInt($('#crop_image').css('width'))) {
                left = parseInt($('#crop_image').css('width')) - parseInt($(target).css('width'))
              }
              if (((startY + dy) + parseInt($(target).css('height'))) > vm.cropImage.height) {
                top = vm.cropImage.height - parseInt($(target).css('height'))
              }
              // parseInt($('#crop_image').css('height'))
              // parseInt($('#crop_image').css('height'))
              $(target).css({
                top: top + 'px',
                left: left + 'px'
              })
              positionCroptool()
              return false;
            }

            function mouseup() {
              $document.unbind('mousemove', mousemove);
              $document.unbind('mouseup', mouseup);
            }
					})
        }

        function setMultiSelector() {
          $('.product').on('mousedown', function($event) {
            var initialMouseX, initialMouseY;

            var target = $event.target

            if (!$(target).is('.draggable, .rotator, .resizer, .side-indicator') && !$('.bgdraggable').length) {
							$('.product').find("*").removeClass("multi-select");
              $(target).css({
                'cursor': 'pointer'
              });

              var parentOffset = $(target).offset();


              initialMouseX = $event.clientX;
              initialMouseY = $event.clientY;

              var relX = Math.floor(initialMouseX - parentOffset.left)/ vm.scale;
              var relY = Math.floor(initialMouseY - parentOffset.top)/ vm.scale;

              $document.bind('mousemove', mousemove);
              $document.bind('mouseup', mouseup);

              var $focusDiv = $('<div>').addClass('focus');

              $focusDiv.appendTo(target);
              $focusDiv.css({
                'position': 'absolute',
                'top': relY + 'px',
                'left': relX + 'px',
                'width': 0,
                'height': 0
              })

              function mousemove($event) {
                var parentOffset = $(target).offset();
                var move_x = Math.floor($event.clientX - parentOffset.left)/ vm.scale;
                var move_y = Math.floor($event.clientY - parentOffset.top)/ vm.scale;
                var width = Math.abs(move_x - relX);
                var height = Math.abs(move_y - relY);
                var new_x, new_y;

                new_x = (move_x < relX) ? (relX - width) : relX;
                new_y = (move_y < relY) ? (relY - height) : relY;

                $focusDiv.css({
                  'width': width,
                  'height': height,
                  'top': new_y,
                  'left': new_x,
                  'border': '1px dashed red'
                })
                return false;

              }

              function mouseup() {
								dom.deselectElements()
                $document.unbind('mousemove', mousemove);
                $document.unbind('mouseup', mouseup);
                selectItems();
                $focusDiv.remove();

              }
            } else {
              //For IE because pointer events doesn't work
              //replaceDivsInContenteditable()
            }

            function selectItems() {

              var top = $focusDiv[0].offsetTop;
              var bottom = top + $focusDiv[0].offsetHeight

              var left = $focusDiv[0].offsetLeft;
              var right = left + $focusDiv[0].offsetWidth

              var dragItems = $('.focused').find('.draggable')

              for (var i = 0; i < dragItems.length; i++) {

                var itemTop = Math.floor($(dragItems[i])[0].offsetTop);

                var itemLeft = Math.floor($(dragItems[i])[0].offsetLeft);
                var itemTopMiddle = itemTop + (Math.floor($(dragItems[i])[0].offsetHeight) / 2)
                var itemLeftMiddle = itemLeft + (Math.floor($(dragItems[i])[0].offsetWidth) / 2)

                if ((itemTopMiddle >= top && itemTopMiddle <= bottom) && (itemLeftMiddle >= left && itemLeftMiddle <= right)) {
                  $(dragItems[i]).addClass('multi-select')
                  if ($(dragItems[i]).data("type") === "text") {
                    vm.action_type = "text"
                  }
                }
              }
            }
          })
        }

        function setMultiDraggables() {
          $('.product').on('mousedown', '.draggable', '.multi-select', function($event) {

            // var startX, startY;
            var initialMouseX, initialMouseY, startX, startY;

            var target = $event.target;

            if ($(target).hasClass('multi-select')) {
              if ($(target).hasClass('draggable')) {
                $(target).css({
                  'position': 'absolute',
                  'cursor': 'pointer'
                });
                dom.deselectElements()
                startX = $(target).prop('offsetLeft');
                startY = $(target).prop('offsetTop');
                initialMouseX = $event.clientX;
                initialMouseY = $event.clientY;
                var pageBreak = alignItem(target).center

                $('.multi-select').each(function() {
                  this.currentY = this.offsetTop;
                  this.currentX = this.offsetLeft;
                  this.targetLeftCenter = this.offsetLeft + (this.offsetWidth / 2)
                  this.targetHorizontalMiddle = this.offsetTop + (this.offsetHeight / 2)
                })

                $document.bind('mousemove', mousemove);
                $document.bind('mouseup', mouseup);

                function mousemove($event) {
                  $('.multi-select').each(function() {
                    var dx = ($event.clientX - initialMouseX) / vm.scale;
                    var dy = ($event.clientY - initialMouseY) / vm.scale;
                    $(this).css({
                      'top': this.currentY + dy + 'px',
                      'left': this.currentX + dx + 'px'
                    });
                    this.targetLeftCenter = this.offsetLeft + (this.offsetWidth / 2)
                    this.targetHorizontalMiddle = this.offsetTop + (this.offsetHeight / 2)

                    dragAlign( this )
                  })

                  $('.focus .resizer, .focus .rotator').css('display', 'none')
                  return false;
                }

                function mouseup() {
                  $document.unbind('mousemove', mousemove);
                  $document.unbind('mouseup', mouseup);
                  dom.removeAlightmentOutline()
									setUndoState()

                }
              } else {
                //For IE because pointer events doesn't work
                //replaceDivsInContenteditable()
              }
            }
          })

        }

        function setUndoState() {
					if(!vm.startUndo && vm.undoIndex < vm.undoStates.length - 1 ) {
						vm.undoStates.splice(vm.undoIndex + 1)
						vm.redoState = false
						vm.startUndo = true
					}
          var changedState = $('.product').html();
          vm.undoStates.push(changedState)
					getUndoable()
        }

				function getUndoable() {
					if(vm.undoStates.length >= 2) {
						if(vm.undoIndex > 0 || vm.startUndo) {
							vm.undoAble = true
						} else {
							vm.undoAble = false
						}
						if(vm.undoIndex < vm.undoStates.length - 1) {
							vm.redoAble = true
						} else {
							vm.redoAble = false
						}
					}
				}

        function shouldDoubleBreak(string) {
          var cursorPosition = getCharacterOffsetWithin(window.getSelection().getRangeAt(0), vm.selected.element)
          //Get Cursor Location
          function getCharacterOffsetWithin(range, node) {
            var treeWalker = document.createTreeWalker(
              node,
              NodeFilter.SHOW_TEXT,
              function(node) {
                var nodeRange = document.createRange();
                nodeRange.selectNode(node);
                return nodeRange.compareBoundaryPoints(Range.END_TO_END, range) < 1 ?
                  NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
              },
              false
            );

            var charCount = 0;
            while (treeWalker.nextNode()) {
              charCount += treeWalker.currentNode.length;
            }
            if (range.startContainer.nodeType == 3) {
              charCount += range.startOffset;
            }
            return charCount
          }

          var lines = string.split('<br>')
          var count = 0
          var limits = [0]
          for (var i in lines) {
            count += lines[i].length
            limits.push((count))
          }
          var isEdge = false
          for (var i in limits) {
            if (cursorPosition == limits[i]) {
              isEdge = true
            }
          }
          return isEdge
				}
				
				// Layers

				function disableTop() {
					domHelpers.disableTop()
					vm.topLayer = false
				}

				function disableWatermark() {
					domHelpers.disableWatermark()
					//recompile the elements to unbind the click
					$compile($('.watermark'))(vm)
				}

				function getWatermarkLayer() {
					disableTop()
					dom.disableBackground()
					setUndoState()
					domHelpers.getWatermarkLayer()
					$compile($('#first-watermark'))(vm)
					$compile($('#second-watermark'))(vm)
					//intialize the functions for watermark drag-drop and resize
					setWatermarkLayerDraggables()
					setWatermarkLayerResizerDrag()
					selectInitialWatermark()
					vm.layersAccessed = true
			  	vm.firstWatermarkExists = $('#first-watermark').length
			    vm.secondWatermarkExists = $('#second-watermark').length
				}

				function getTopLayer(saving) {
					disableWatermark()
					dom.disableBackground()
					setUndoState()
					vm.topLayer = true
					if(!saving && vm.autosave) {
						save()
						vm.saved = false
					}
					domHelpers.getTopLayer()
				}

				function getBackgroundLayer() {
					setUndoState()
					disableTop()
					disableWatermark()
					setUndoState()

					dom.changeOutlines('cyan')
					//change button highlights
    			$('.asset-layer').removeClass('active');
    			$('#background-layer').addClass('active');
					//add class to background that makes it draggable, and ensures that multiselector is off
					$('.printedarea').addClass('bgdraggable')
					//turn off background tile, so easy to see edges
					$('.theme').css({
						'background-repeat': 'no-repeat'
					})

					//positionResizer()
					$('.bgdraggable').unbind('mousedown')
					var src = $('.focused .theme').css('background-image').replace('url(', '').replace(')', '').replace(/"/g, '')
					$('.bgdraggable').css('cursor', 'pointer')
					var img = new Image()
					img.src = helpers.imgixBase + src
					img.onload = function () {
						//vm.bgImgRatio = this.width/this.height
						vm.bgImgHeight = this.height
						vm.bgImgWidth = this.width
					}

					//intialize background edit functions for image edits and drag
					showEditBackground()
					backgroundDrag()
					placeBGSlider()
					vm.layersAccessed = true
				}

				function setBackgroundLayer() {
					//intialize background edit functions for image edits and drag
					showEditBackground()
					backgroundDrag()
					// vm.layersAccessed = true
				}

				function getThemeEdits() {
					//save all the edits to the order product layout
					vm.themeEdits.replaceImg = $('.theme').css('background-image').replace('url(', '').replace(')', '').replace(helpers.imgixBase, '').replace(helpers.awsUploads, '').replace(/"/g, '')
					vm.themeEdits.firstWatermark = {}
					vm.themeEdits.secondWatermark = {}
					if(vm.firstWatermark){
						if(vm.firstWatermark.image && $('#first-watermark').length) {
							vm.themeEdits.firstWatermark.image = $('#first-watermark').attr('src').replace(helpers.imgixTheme, '').replace(helpers.awsUploads, '').replace(/"/g, '')
							vm.themeEdits.firstWatermark.top = parseInt($('#first-watermark').css('top'))
							vm.themeEdits.firstWatermark.left = parseInt($('#first-watermark').css('left'))
							vm.themeEdits.firstWatermark.width = parseInt($('#first-watermark').css('width'))
							vm.themeEdits.firstWatermark.opacity = parseInt($('#first-watermark').css('opacity') * 100)
						} else {
							vm.themeEdits.firstWatermark = {}
						}
					} else {
						vm.themeEdits.firstWatermark = {}
					}
					if(vm.secondWatermark) {
						if(vm.secondWatermark.image && $('#second-watermark').length) {
							vm.themeEdits.secondWatermark.image = $('#second-watermark').attr('src').replace(helpers.imgixTheme, '').replace(helpers.awsUploads, '').replace(/"/g, '')
							vm.themeEdits.secondWatermark.top = parseInt($('#second-watermark').css('top'))
							vm.themeEdits.secondWatermark.left = parseInt($('#second-watermark').css('left'))
							vm.themeEdits.secondWatermark.width = parseInt($('#second-watermark').css('width'))
							vm.themeEdits.secondWatermark.opacity = parseInt($('#second-watermark').css('opacity') * 100)
						} else {
							vm.themeEdits.secondWatermark = {}
						}
					} else {
						vm.themeEdits.secondWatermark = {}
					}
					vm.themeEdits.themeSizes = {};
					vm.themeEdits.themeSizes.size = $('.theme').css('background-size')
					//if($('.theme').css('background-position'))
					vm.themeEdits.themeSizes.position = $('.theme').css('background-position')
					vm.layout.background_watermark_edited = true
					vm.themeEdits.edited = true
				}

				function applyBackground() {
					//not currently using this, but will allow us to apply background changes to all products layouts
					if(vm.backgroundApply === true) {
						// indicate that all layouts should be edited
						vm.order.themeplain.allEdited = true
						//save the edits from the current background
						vm.order.themeplain.imageQuery = vm.backgroundProps.queries

					} else {
						//
					}
				}

				// Watermark Layer Functions

				function selectInitialWatermark() {
					//determine whether or not watermark resize and delete are already on the page, if not append them
					if(!$('.watermark-resizer').length && !$('.watermark-deletor').length) {
						$('.focused .theme').append(`<i id="watermarkResizor" class="watermark-resizer glyphicon glyphicon-fullscreen" style="visibility: hidden; z-index: 99"></i><i id="watermarkDeletor" class="watermark-deletor icon-delete-circle" style="visibility: hidden; z-index: 99" ng-click="deleteWatermark()"></i>`)
					}
					//bind the new elements to the scope
					$compile($('#watermarkDeletor'))(vm)
					//remove icon target classes from elements [clean up]
					$('*').removeClass('resizer-target deletor-target')
					//select first watermark first, otherwise select second watermark
					if(vm.firstWatermark) {
						$('.focused .first-watermark').addClass('resizer-target deletor-target watermarkDraggable')
					} else if (vm.secondWatermark) {
						$('.focused .second-watermark').addClass('resizer-target deletor-target watermarkDraggable')
					}
					//add outline to selected watermark
					$('.resizer-target').css({
						outline: '1px dashed limegreen'
					})
					//run positioning functions for resizer and deletor icons
					dom.positionWatermarkLayerResizer()
					dom.positionWatermarkLayerDelete()
				}

				function selectWatermark(element) {
					setUndoState()
					dom.selectWatermark(element)
				}

				function updatePositionLayerFields(){
					//update watermark positions on the scope
					if(vm.firstWatermark) {
						vm.firstWatermark.top = parseInt($('#first-watermark').css('top'))
						vm.firstWatermark.left = parseInt($('#first-watermark').css('left'))
					}
					if(vm.secondWatermark){
						vm.secondWatermark.top = parseInt($('#second-watermark').css('top'))
						vm.secondWatermark.left = parseInt($('#second-watermark').css('left'))
					}
				}

				function setWatermarkLayerDraggables() {
					//intialize drag for watermarks
					$('.focused').on('mousedown', '.watermarkDraggable', function($event){
						$event.preventDefault()
						let startX, startY, initialMouseX, initialMouseY;
						setUndoState()
						let target = $event.target
						//ensure the targeting classes are only on the current target
						$('.theme img').removeClass('resizer-target deletor-target')
						$(target).addClass('resizer-target')
						$(target).addClass('deletor-target')
						$(target).css({
							'position': 'absolute',
							'cursor': 'pointer'
						});
						//get initial location of top/left
						startX = $(target).prop('offsetLeft');
						startY = $(target).prop('offsetTop');
						//get initial location of mousedown
						initialMouseX = $event.clientX;
						initialMouseY = $event.clientY;
						//bind functions to mouseevents
						$document.bind('mousemove', mousemove);
						$document.bind('mouseup', mouseup);

						function mousemove($event) {
							//get difference between initial mouse position and current mouse position
							let dx = $event.clientX - initialMouseX;
							let dy = $event.clientY - initialMouseY;
							//update icon and model
              dom.positionWatermarkLayerResizer()
							dom.positionWatermarkLayerDelete()
							updatePositionLayerFields()
							//update taget position, initial location, plus pixels the mouse has moved
							$(target).css({
								top: startY + dy + 'px',
								left: startX + dx + 'px'
							});
							return false;
						}

						function mouseup() {
							//unbind mousedown and mouseup
							$document.unbind('mousemove', mousemove);
							$document.unbind('mouseup', mouseup);
							//get final positioning
							updateWatermarkLayerPosition()
						}
					})
				}

				function setWatermarkLayerResizerDrag() {
					//intialize resizer for watermarks
          $('.theme').on('mousedown', '.watermark-resizer', function($event){
            let startWidth, startHeight, initialMouseX, initialMouseY;
						setUndoState()
						//get width and height of watermark target
            startWidth = parseInt($('.resizer-target').css('width'))
            startHeight = parseInt($('.resizer-target').css('height'))
						//get initial mouse position
						initialMouseX = $event.clientX;
						initialMouseY = $event.clientY;
						//bind mousemove functions
            $document.bind('mousemove', mousemove);
						$document.bind('mouseup', mouseup);

            function mousemove($event) {
							//get difference between mouse start and mouse current positions
							let dx = $event.clientX - initialMouseX;
							let dy = $event.clientY - initialMouseY;
							//we will maintain aspect ratio
              let ratio = startHeight / startWidth
							//set watermark target new size to original width/height plus amount mouse has moved (by ratio for height)
            	$('.resizer-target').css({
								width: startWidth + dx + 'px',
              	height: startHeight + (dx * ratio) + 'px'
							});
							//resposition icons and update model as mouse moves
							updatePositionLayerFields()
              dom.positionWatermarkLayerResizer()
							dom.positionWatermarkLayerDelete()
							return false;
						}

						function mouseup() {
							//unbind and get final positioning
							$document.unbind('mousemove', mousemove);
							$document.unbind('mouseup', mouseup);
							updateWatermarkLayerPosition()
						}
          })
        }

				function updateWatermarkLayerPosition(){
					if($('.first-watermark').length) {
						$('.first-watermark').css({
								top: vm.firstWatermark.top,
								left: vm.firstWatermark.left,
								width: $('.first-watermark').css('width'),
								height: $('.first-watermark').css('height')
						})
					}
					if($('.second-watermark').length) {
						$('.second-watermark').css({
								top: vm.secondWatermark.top,
								left: vm.secondWatermark.left,
								width: $('.second-watermark').css('width'),
								height: $('.second-watermark').css('height')
						})
					}
					setUndoState()
				}

				function uploadWatermarkOne() {
					$timeout(() => document.getElementById('watermark_upload_one').click(), 10)
				}

				function uploadWatermarkTwo(){
					$timeout(() => document.getElementById('watermark_upload_two').click(), 10)
				}

				const firstWatermarkEventListener = $rootScope.$on('firstWatermarkUpload', (event, payload) => {
					if(!vm.firstWatermark){
						vm.firstWatermark = {}
					}
					vm.firstWatermark = payload
					vm.firstWatermark.opacity = 80

					// ADD WATERMARK IF IT DOESN'T EXIST
					if(!$('#first-watermark').length) {
						const watermark = `<img src="${helpers.imgixTheme}${vm.firstWatermark.image}" class="watermark first-watermark" id="first-watermark" ng-click="selectWatermark($event)" style="width:${vm.firstWatermark.width}px; position:absolute; top:${vm.firstWatermark.top}px; left:${vm.firstWatermark.left}px; opacity:${vm.firstWatermark.opacity};">`
						$('#editor .product > :nth-child(2) .theme').append(watermark)
					}

					// SET SIZE AND POSITION AND PLACE ON TOP
					$('.first-watermark').attr('src', `${helpers.imgixTheme}${vm.firstWatermark.image}`)
					$('.first-watermark').css({
						'height': '',
						'width': '50%',
						'z-index': '99'
					})
					const obj = {
						saved: true,
						background_watermark_edited: true
					}
					$compile($('.first-watermark'))(vm)
					orderLayouts.update(vm.layout.id, obj).then(response => {})
					document.getElementById("watermark_upload_one").value = ''
				})

				scope.$on('$destroy', () => firstWatermarkEventListener())

				const secondWatermarkEventListener = $rootScope.$on('secondWatermarkUpload', (event, payload) => {
					if(!vm.secondWatermark){
						vm.secondWatermark = {}
					}
					vm.secondWatermark = payload
					vm.secondWatermark.opacity = 80

					// ADD WATERMARK IF IT DOESN'T EXIST
					if(!$('#second-watermark').length) {
						const watermark = `<img src="${helpers.imgixTheme}${vm.secondWatermark.image}" class="watermark second-watermark" id="second-watermark" ng-click="selectWatermark($event)" style="width:${vm.secondWatermark.width}px; position:absolute; top:${vm.secondWatermark.top}px; left:${vm.secondWatermark.left}px; opacity:${vm.secondWatermark.opacity};">`
						$('#editor .product > :nth-child(2) .theme').append(watermark)
					}

					// SET SIZE AND POSITION AND PLACE ON TOP
					$('.second-watermark').attr('src', `${helpers.imgixTheme}${vm.secondWatermark.image}`)
					$('.second-watermark').css({
						'height': '',
						'width': '50%',
						'z-index': '99'
					})

					const obj = {
						saved: true,
						background_watermark_edited: true
					}

					$compile($('.second-watermark'))(vm)
					orderLayouts.update(vm.layout.id, obj).then(response => {})
					document.getElementById("watermark_upload_two").value = ''
				})

				scope.$on('$destroy', () => secondWatermarkEventListener())

				function deleteWatermark() {
					if($('.deletor-target').is('.first-watermark')) {

						vm.firstWatermark = null
						vm.firstWatermarkExists = false

						$('.first-watermark').css({
							top: '0px',
							left: '0px',
							width: '0px',
							position: 'absolute'
						})
						$('.first-watermark').removeClass('resizer-target deletor-target')
						$('#first-watermark').remove()
					} else if($('.deletor-target').is('.second-watermark')) {
						vm.secondWatermark = null
						vm.secondWatermarkExists = false

						$('.second-watermark').css({
							top: '0px',
							left: '0px',
							width: '0px',
							position: 'absolute'
						})
						$('.second-watermark').removeClass('resizer-target deletor-target')
						$('#second-watermark').remove()
					}
					dom.positionWatermarkLayerDelete()
					dom.positionWatermarkLayerResizer()
					setUndoState()
				}

				function changeWatermarkOpacity(){
					//opacity comes from the form, and set on the model, then updated here
					if(vm.firstWatermark) {
						$('.first-watermark').css({
							opacity: (vm.firstWatermark.opacity/100)
						})
					}
					if(vm.secondWatermark) {
						$('.second-watermark').css({
							opacity: (vm.secondWatermark.opacity/100)
						})
					}
					setUndoState()
				}

				// Background Move Functions

				function backgroundDrag(target) {
					$('.bgdraggable ').unbind('mousedown')
					!target && (target = '#editor .product .focused .theme')
					//set initial variables and change cursor
					let set, startX, startY, initialMouseX, initialMouseY;
					$('.bgdraggable').css('cursor','grab')
					//bind mousedown function to the product
					$('.bgdraggable ').bind('mousedown', function($event) {
						setUndoState()
						set = $('.focused')
						//make sure that the mousedown is on the bgdraggable element
						if(!$(event.target).hasClass('watermark') && set.length) {
							//get the initial position of the background
							startX = $(target).css('background-position').split(' ')[0];
							startY = $(target).css('background-position').split(' ')[1];
							initialMouseX = $event.clientX;
							initialMouseY = $event.clientY;
							$document.bind('mousemove', mousemove);
							$document.bind('mouseup', mouseup);
						}
					});
					function mousemove($event) {
						//track pixels the mouse moves
						let dx = $event.clientX - initialMouseX;
						let dy = $event.clientY - initialMouseY;
						let top = parseInt(startY) + dy
						let left = parseInt(startX) + dx
						//change the background position as mouse moves
						let position = left + 'px ' + top + 'px'
						$(target).css('background-position', position);
						$('.focused .theme').css('background-position', position);
						return false;
					}
					function mouseup() {
						$document.unbind('mousemove', mousemove);
						$document.unbind('mouseup', mouseup);
						setUndoState()
					}
				}

				function applyPageStyling(pages) {
					editBackgroundProps(pages)
					adjustBackgroundSize(pages)
					positionBackground(pages)
					getPageLocation()
				}

				function setEditBackgroundPages(pages) {
					switch (pages) {
						case 'all'  : return $('#editor .product .printedarea .theme');
						case 'even' : return $('#editor .product .printedarea .theme:odd');
						case 'odd'  : return $('#editor .product .printedarea .theme:even');
						default     : return $('#editor .product .focused .theme');
					}
				}

				function showEditBackground() {
					let obj = $('#editor .product .focused .theme')
					//get the posisition of the background
					vm.backgroundProps.position = obj.css('background-position')
					if(obj.css('background-size').split(' ')[0] != 'auto') {
						vm.backgroundProps.size = parseInt(obj.css('background-size').split(' ')[0])
					} else {
						vm.backgroundProps.size = parseInt(obj.css('background-size').split(' ')[1])
					}
					vm.backgroundProps.opacity = parseInt(obj.css('opacity') * 100)
					//get the source of the background image
					let src = obj.css('background-image').replace('url(', '').replace(')', '').replace(helpers.imgixBase, '').replace(helpers.awsUploads, '').replace(/"/g, '')
					//initial background image settings.
					vm.backgroundProps.queries = {
						vib: 0,
						hue: 0,
						bri: 0,
						con: 0,
						high: 0,
						sat: 0,
						shad: 0,
						sharp: 0,
						exp: 0,
						gam: 0,
						blur: 0,
						sepia: 0,
						blend: 0,
						mono: 0,
						htn: 0,
						or: 0,
						flip: 0
					}
					//get image settings from the image source and update the model
					for(let key in vm.backgroundProps.queries) {
						//for each key if it is in the image source url
						if(src.indexOf(key) != -1) {
							//if it is mono, we need to add the '#' for a hex value
							if(key === 'mono') {
								vm.backgroundProps.queries[key] = '#' + src.substr(src.indexOf(key) + (key.length + 1), 6)
							}
							if(key === 'blend') {
								//if the key is blend we need to determine if it is a hex value or an image and update
								let q = src.match(/(&blend).*&/g)[0]
								q = q.substring(q.indexOf('=')).split('&').shift()
								if(q.length === 7) {
									vm.backgroundProps.queries[key] = '#' + q.substr(1)
								} else {
									vm.backgroundProps.queries[key] =  q.substr(1)
								}
							} else if(key === 'bm') {
								//dtermines if there is a blend mode
								let q = src.match(/(&bm).*&/g)[0]
								q = q.substring(q.indexOf('=')).split('&').shift()
								vm.backgroundProps.queries[key] = q.substr(1)
							} else if(key === 'flip') {
								vm.backgroundProps.queries[key] = src.substr(src.indexOf(key) + (key.length + 1), 4)
							} else {
								//get the values of other keys
								vm.backgroundProps.queries[key] = parseInt(src.substr(src.indexOf(key) + (key.length + 1), 4))
							}
						}
					}
					//set the source on the model
					vm.backgroundProps.url = src
				}

				function adjustBackgroundSize(pages) {
					let obj = setEditBackgroundPages(pages)

					//determine which direction the background size auto-filled and set the other value to match the model
					if($('.focused .theme').css('background-size').split(' ')[0] != 'auto') {
						obj.css({
							'background-size': vm.backgroundProps.size + '% auto'
						})
					} else {
						obj.css({
							'background-size': 'auto ' + vm.backgroundProps.size + '%'
						})
					}
					setUndoState()
				}

				function editBackgroundProps(pages) {
					let obj = setEditBackgroundPages(pages)
					
					//get the base image file
					let imageFile = vm.backgroundProps.url.split('&')[0].split('/').pop()
					let query = ''
					//does the base file already have the query '?'
					if(imageFile.indexOf('?') === -1) query = '?'
					let path = imageFile + query

					// find each key that has a value not 0 and add it to the query string
					for (let key in vm.backgroundProps.queries) {
						if(vm.backgroundProps.queries[key] != 0) {
							if( key === 'mono') {
								if(vm.backgroundProps.queries.mono) {
									let keystring = "&" + key + "="+ vm.backgroundProps.queries.mono.substring(1) + '&'
									path += keystring
								}
							} else if(key === 'blend') {
								if(vm.backgroundProps.queries.blend) {
									if(vm.backgroundProps.queries.blend.indexOf('#') === 0){
										let keystring = "&blend="+ vm.backgroundProps.queries.blend.substring(1) + '&'
									} else if(vm.backgroundProps.queries.blend.indexOf('http') != -1){
										//this is in place, and will allow in the future for an image to be used on background blend - the same as with an image
										keystring = "&blend="+ vm.backgroundProps.queries.blend + "&bm="+vm.backgroundProps.queries.bm+"&balph="+vm.backgroundProps.queries.balph+"&bf=crop&bc=top,left&bw=" + vm.backgroundProps.queries.bw + "&bh=" +vm.backgroundProps.queries.bh
									}
									path += keystring
								}
							} else if(key != 'bw' && key != "bh" && key != 'bm' && key != 'balph'){
								let keystring = "&" + key + "="+ vm.backgroundProps.queries[key]
								path += keystring
							}
						}
					}
					obj.css('opacity', vm.backgroundProps.opacity / 100)
					//set the background image to the updated query
					vm.backgroundProps.url = path
					obj.css({
						'background-image': `url(${helpers.imgixTheme}${path})`
					})
				}

				function positionBackground(pages) {
					const obj = setEditBackgroundPages(pages)
					const currentPageBackgroundPosition = $('.focused .theme').css('background-position')
					obj.css({'background-position': currentPageBackgroundPosition})
					setUndoState()
				}

				function revertBackgroundImage() {
					//reset all query selectors and then run props
					for (let key in vm.backgroundProps.queries) {
						vm.backgroundProps.queries[key] = 0
					}
					editBackgroundProps()
					setUndoState()
				}

				function resetBackgroundImageColor(key) {
					// remove hex from color selector
					vm.backgroundProps.queries[key] = 0
					editBackgroundProps()
				}

				function setBackgroundImageRotation(value) {
					// get the value for the rotation quer
					vm.backgroundProps.queries.or = value;
					editBackgroundProps()
					setUndoState()
				}

				function setBackgroundImageFlip(value) {
					// get the value for the flip query
					vm.backgroundProps.queries.flip = value;
					editBackgroundProps()
					setUndoState()
				}

				function placeBGSlider() {
					if(!$('.bg-size').length){
						var slide = $compile(`<div class='bg-size' ng-show='showBackground'><label>Adjust Size &nbsp &nbsp</label><input type='range'  min='0' max='200' class='rangeSlide' ng-model='backgroundProps.size'  ng-change='adjustBackgroundSize()'></div>`)(vm)
						$('#editor .product').append(slide)
					}
				}

				// Linked Up

				function getFlowers() {
					return new Promise((resolve, reject) => {
						flowers.get(vm.order.case_id).then(response => {
							const flowerData = response.data
							vm.floralPix = []
							for (let pic of flowerData){
								let obj = {
									title: pic.name,
									images: []
								}
								pic.flowers_images.forEach(image => {
									obj.images.push(image)
								})
								pic.cards_images.forEach(image => {
									obj.images.push(image)
								})
								vm.floralPix.push(obj)
							}
						})
						
						resolve()
					})
				}

				function getMemorials() {
					cases.getCaseMemorialsForCase(vm.case.id).then(response => {
						vm.memorials = response.data
					})
				}

				async function getGuests() {
					const response = await guests.getGuests(vm.case.id)
					vm.guests = response.data
				}

      	function placeLogo() {
					if (vm.homeLogo) {
						$('.logoImage').each(function() {
							if (!$(this).hasClass("feathered") &&
								!$(this).hasClass("cropped") &&
								!$(this).hasClass("edited") ||
								vm.tempSwitch
							){
								$(this).css("background-image", `url(${helpers.imgixLogo}${vm.homeLogo}?h=150)`).css('background-size', 'cover').css('background-color', 'rgba(0,0,0,0)')
								$compile($(this))(vm)
							}
							$timeout(function() {
								$('.logoImage').each(function() {
									dom.sizePlaceholderImage($(this))
								})
							}, 200)
						})
					}
        }

				function placeCaseImages(update) {

					const caseImagesBefore  = []
					const caseImages        = sortCaseImages()
					const isMemorialCollage = vm.product.name.includes('Memorial Collage') && vm.collection.name.includes('Precious Memories')

					if (caseImages.length) {
						$('div.caseImage').each(function() {

							const data = {
								element            : $(this),
								caseImages         : caseImages,
								num                : $(this).data('caseimage'),
								isOval             : $(this).data("oval"),
								isEdited           : $(this).hasClass('edited'),
								isCropped          : $(this).hasClass('cropped'),
								isFeathered        : $(this).hasClass('feathered'),
								isDefaultCaseImage : $(this).data().caseimage === 0
							}

							const { element, num, isEdited, isCropped, isFeathered, isDefaultCaseImage } = data

							// store all case image background-images in case of edits
							caseImagesBefore.push({
								backgroundImage   : element.css('background-image'),
								caseImagePosition : num
							})

							// if the default image has been changed and it has been edited, cropped, or feathered, then replace the default image
							if (isDefaultCaseImage && update && (isEdited || isCropped || isFeathered)) {
								$(this).removeClass('edited')
								$(this).removeClass('cropped')
								$(this).removeClass('feathered')
								$(this).css({
									'background-image' : `url(${helpers.imgixCase}${caseImages[0]}?or=0)`,
									'background-size'  : 'cover'
								})
								dom.sizePlaceholderImage($(this))
							}

							!isMemorialCollage ? setCaseImages(data) : setMemorialCollageCaseImages(data)

						})

						$('div.caseImage').each(function() {

							setCaseImageHeight($(this))

							if (isMemorialCollage) {
								
								const currentBgImage = $(this).css('background-image')
								const currentBgUrl   = currentBgImage.split('?')[0].split(`${helpers.imgixCase}`)[1]
	
								caseImagesBefore.map(image => {
	
									// restore any case image edits
									const previousBgUrl = image.backgroundImage.split('?')[0].split(`${helpers.imgixCase}`)[1]
									currentBgUrl === previousBgUrl && $(this).css('background-image', image.backgroundImage)
	
									// change previous default image circle feathers to square feathers
									if (previousBgUrl === currentBgUrl && image.caseImagePosition === 0 && $(this).data('caseimage') !== 0) {
										$(this).css('background-image', image.backgroundImage.replace('circlefeather.png', 'squarefeatherbox.png'))
									}
	
								})
	
								// change new default image square feathers to circle feathers
								if ($(this).css('background-image').includes('squarefeatherbox.png') && $(this).data('caseimage') === 0) {
									$(this).css('background-image', currentBgImage.replace('squarefeatherbox.png', 'circlefeather.png'))
								}
							}

						})

						$('img.caseImage').each(function(){

							const num             = $(this).data('caseimage')
							const isEdited        = $(this).attr('data-edited')
							const isCropped       = $(this).attr('data-cropped')
							const isFeathered     = $(this).attr('data-feathered')
							const imageUntampered = (!isFeathered && !isCropped && !isEdited) || vm.tempSwitch

							if(!vm.layout.saved || vm.tempSwitch && imageUntampered) {
								$(this).attr('src', `url(${helpers.imgixCase}${caseImages[num]}?or=0)`)
								!vm.layout.saved && dom.sizePlaceholderImage($(this))
							}

						})
					}

				}

				function sortCaseImages() {

					let caseImages = []
					const totalCaseImages = vm.case.personal_images && vm.case.personal_images.length

					// if there are less than twenty case images, add the same case images over and over until the caseImages array has 20 images
					if(vm.case.personal_images && totalCaseImages < 20){
						let count = 0;
						while (count < 20) {
							const imagesString = vm.case.personal_images.toString();
							const imagesSplit = imagesString.split(",");
							count += imagesSplit.length;
							caseImages.push(imagesSplit);
						}
						caseImages = caseImages.reduce(function(a, b) {
							return a.concat(b);
						}, []);

					// if there is twenty or more images, simply add them to the caseImages array
					} else if(totalCaseImages >= 20){
						caseImages = vm.case.personal_images
					}

					return caseImages

				}

				function setCaseImages(data) {

					const { element, isEdited, isCropped, isFeathered, num, caseImages } = data

					const setImage = () => caseImages[num]
						? element.css({
								'background-image' : `url(${helpers.imgixCase}${caseImages[num]}?or=0)`,
								'background-size'  : 'cover'
							})
						: element.css({'background': 'rgb(221, 221, 221)'})

					// if the image is not edited, cropped, or feathered and the template has been changed, then replace the image
					if ((!isEdited && !isCropped && !isFeathered) || vm.tempSwitch ) {
						setImage()
						!vm.layout.saved && dom.sizePlaceholderImage(element) // NOTE: NOT SURE WHAT TO DO WITH THIS
					} else if (!vm.layout.saved || vm.tempSwitch) {
						setImage()
						dom.sizePlaceholderImage(element)
					}

				}

				function setMemorialCollageCaseImages(data) {

					const { element, num, isOval } = data
					const personalImage    = vm.case.personal_images[num]
					const maskType         = (num === 0 || isOval) ? 'circlefeather.png' : 'squarefeatherbox.png'
					const featherFlags     = `?&fm=png&border=0,000000&pad=0&fm=png&auto=compress&fit=crop&mask=${helpers.imgixBase}${maskType}`
					const caseImageFillers = {
						0  : `${helpers.imgixCase}case_images_440x655.png`,
						1  : `${helpers.imgixCase}case_images_345x505.png`,
						2  : `${helpers.imgixCase}case_images_345x450.png`,
						3  : `${helpers.imgixCase}case_images_345x515.png`,
						4  : `${helpers.imgixCase}case_images_340x490.png`,
						5  : `${helpers.imgixCase}case_images_345x575.png`,
						6  : `${helpers.imgixCase}case_images_340x515.png`,
						7  : `${helpers.imgixCase}case_images_615x405.png`,
						8  : `${helpers.imgixCase}case_images_345x430.png`,
						9  : `${helpers.imgixCase}case_images_465x410.png`,
						10 : `${helpers.imgixCase}case_images_370x430.png`
					}

					const replaceImage = url => {
						element.css({
							'background-image' : url,
							'background-size'  : 'cover'
						})
						dom.sizePlaceholderImage(element)
					}

					num === 0 && $(element).css('z-index', '50')

					personalImage
						? replaceImage(`url("${helpers.imgixCase}${personalImage}${featherFlags}")`)
						: replaceImage(`url("${caseImageFillers[num]}${featherFlags}")`)
				}

				function applyPageMaxRules() {
					if(vm.product.name.includes('Extra Pages') ) {
						vm.pageMax = 10
					} else if(vm.product.name.includes('Front Insert')) {
						vm.pageMax = 1
					} else if(vm.product.name.includes('Trifolds') || vm.product.name.includes('Church Bulletins') || (vm.layout.name.includes('Full Sheet') && vm.product.name.includes('Directory Signs'))) {
						vm.pageMax = 24
					} else if(vm.product.name.includes('Register Book') ) {
						vm.pageMax = 45
					}
				}

				function setEditorConstants(pageData, homeTemplate) {
					const dateFormat = vm.funeralHomeSettings.date_format ? vm.funeralHomeSettings.date_format : 'LL'
					return new Promise((resolve, reject) => {
						vm.pages = pageData.pages
						vm.layout = pageData.layout
						vm.product = pageData.product
						vm.page_set = pageData.page_set
						vm.theme = pageData.theme
						vm.theme_layout = pageData.theme_layout[0]
						vm.order = pageData.order
						vm.case = pageData.case

						// I don't know what these do, aside from break new layouts - leaving them here but commented incase they are required by something else
						homeTemplate === false && (vm.layout.background_watermark_edited = false)
						// homeTemplate === true && (vm.layout.background_watermark_edited = true)

						if(vm.case.services) {
							vm.case.services = vm.case.services.map((service, index) => {
								service.date = moment.utc(service.date).format(dateFormat)
								service.index = index
								service.type = service.type.charAt(0).toUpperCase() + service.type.slice(1)
								return service;
							})
							vm.case.visitations = vm.case.services.filter(item => item.type === 'Visitation')
							vm.case.justServices = vm.case.services.filter(item => item.type === 'Service')
						}
						if(vm.case.us_stations_where_served && vm.case.us_stations_where_served.length > 0) {
							vm.case.us_stations_where_served = vm.case.us_stations_where_served.map(station => {
								station = JSON.parse(station)
								station.departure_date = moment.utc(station.departure_date).format(dateFormat)
								station.return_date = moment.utc(station.return_date).format(dateFormat)
								return station
							})
						}
						if(vm.case.additional_family) {
							vm.case.other_family = vm.case.additional_family.filter(item => item.type === 'other_family')
							vm.case.preceded_by = vm.case.additional_family.filter(item => item.type === 'preceded_by')
							vm.case.family_groups = _.uniqBy(vm.case.additional_family, 'type').map(group => {
								if(group.type === 'other_family' || group.type === 'preceded_by') return;
								return {
									type: group.type,
									items: vm.case.additional_family.filter(item => item.type === group.type)
								}
							}).filter(group => group)
							vm.case.family_groups.map(group => {
								group.items_combined = group.items.map(item => {
									return item.relation ? `${item.name}, ${item.relation}` : item.name
								})
								return group
							})
							vm.case.other_family_combined = vm.case.other_family.map(item => {
								return item.relation ? `${item.name}, ${item.relation}` : item.name
							})
							vm.case.preceded_by_combined = vm.case.preceded_by.map(item => {
								return item.relation ? `${item.name}, ${item.relation}` : item.name
							})
							
						}
						resolve('Editor constants set')
					})
				}

				async function getOrder(newId, homeTemplate) {
					
					let id = newId ? newId : $routeParams.order_page_sets_id
					if(!funeralHomeSettings.settings) {
						const { status, data : settingsData } = await funeralHomeSettings.get()
						status === 200
							? vm.funeralHomeSettings = settingsData
							: vm.funeralHomeSettings = {}
					} else {
						vm.funeralHomeSettings = funeralHomeSettings.settings
					}

					const { data: pageData } = await pages.getEditorOrderPageDetails(id)
					await setEditorConstants(pageData, homeTemplate)

					//apply pagemax rules
					if(vm.product.name.includes('Extra Pages') ) {
						vm.pageMax = 10
					} else if(vm.product.name.includes('Front Insert')) {
						vm.pageMax = 1
					} else if(vm.product.name.includes('Service Records') || vm.product.name.includes('Church Bulletins') || (vm.layout.name.includes('Full Sheet') && vm.product.name.includes('Directory Signs'))) {
						vm.pageMax = 24
					} else if(vm.product.name.includes('Register Book') ) {
						vm.pageMax = 45
					}

					loadSocket()
					getMemorials()
					getGuests()

					const { data: collectionData} = await collections.get(vm.order.collection_id)
					vm.collection = collectionData

					const { data: logoData } = await funeralHomeLogo.getLogos()
					vm.homeLogos = logoData
					vm.homeLogo = logoData.small

					await getFlowers()

					const { data: dBCustomFields } = await cases.getAllCaseCustomFields(vm.order.case_id)
					vm.customFields = dBCustomFields

					vm.assetsLoading = false
					await loadProduct()
					applyPageMaxRules()
        }

				function findTheme() {

					/*
					|--------------------------------------------------------------------------
					| Default Fonts
					|--------------------------------------------------------------------------
					|	A default font and font-color can be set on the admin-app and a default
					| font by the user in the web-app. If both the admin and the user have set
					| these values, the admin takes precedence. Both defaults are overridden by
					| font changes made by the user in the editor. findTheme() targets elements
					| with the default-font- class to set font and color, and updateSelected()
					| simply removes that class.
					*/

					let deferred = $q.defer()
						// themes.getThemeById(vm.order.theme_id).then(function(response) {
						// 	vm.theme = response.data
							vm.themeImage = vm.theme.image
							vm.themeFontColor = vm.theme.font_color
							// themes.getThemeLayoutByLayout(vm.layout.layout_id).then(function(theme_layout){
								// vm.theme_layout = theme_layout.data[0]
							//get the current shape's opacity as long as it isn't 0
								$.each($('*[data-type="shape"]:not(".new-shape")'), function(){
									if($(this).css('opacity') > 0) {
										vm.overlayOpacity = $(this).css('opacity') * 100
									}
								})
								//are overlay's set to be hidden
								if (vm.theme.hideOverlay) {
									vm.hideOverlay = true
									$('*[data-type="shape"]:not(".new-shape")').css('display', 'none')
								} else {
									//if not display them - this ensures overlays get redisplayed if they were hidden by a different theme
									$('*[data-type="shape"]:not(".new-shape")').css('display', '')
								}
								$('#editor .printedarea .default-font').each(function() {
									if ($(this).inlineStyle('font-family') == undefined) {
										$(this).css('font-family', vm.theme.font)
									}
								})
								$('#editor .product p').each(function() {
									if($(this).inlineStyle('color') == undefined){
										if (vm.theme.color_scheme && !vm.defaultTemp) {
											if (vm.theme.color_scheme == 'light') {
												$(this).css('color', 'rgb(220,220,220)')
											} else if (vm.theme.color_scheme = 'dark') {
												$(this).css('color', 'rgb(0,0,0)')
											}
										} else if (vm.themeFontColor) {
											$('#editor .printedarea p').each(function() {
												if ($(this).hasClass('default-font-color')) {
													$(this).css('color', vm.themeFontColor)
												} else {
													$(this).css('color', 'rgb(0,0,0)')
												}
											})
										} else {
											$(this).css('color', 'rgb(0,0,0)')
										}
									}
								})

								/* THIS SERIES OF PROMISES ENSURES THE WATERMARKS ARE RETRIEVED
									BEFORE THE THEME IS APPLIED */
								checkForFirstWatermark().then(response => {
									vm.firstWatermark = response
									vm.firstWatermark.opacity = vm.firstWatermark.opacity * 100
									checkForSecondWatermark().then(response => {
										vm.secondWatermark = response
										vm.secondWatermark.opacity = vm.secondWatermark.opacity * 100
										applyTheme()
									}).catch(() => {
										vm.secondWatermark = null
										applyTheme()
									})
								}).catch(() => {
									vm.firstWatermark = null
									vm.secondWatermark = null
									applyTheme()
								})

								deferred.resolve(true)

						return deferred.promise
        }

				function checkForFirstWatermark(){
					return new Promise((resolve, reject) => {
						if(vm.theme_layout.first_watermark) {
							themes.getWatermarks(vm.theme_layout.first_watermark).then(response => {
								resolve(response.data)
							})
						} else {
							reject()
						}
					})
				}

				function checkForSecondWatermark(){
					return new Promise((resolve, reject) => {
						if(vm.theme_layout.second_watermark) {
							themes.getWatermarks(vm.theme_layout.second_watermark).then(response => {
								resolve(response.data)
							})
						} else {
							reject()
						}
					})
				}


				function getAssetCategories() {
					assets.getAssetCategories().then(response => {
						vm.assetCategories = response.data
					})
        }

        // Nav Actions

				const autosave = $interval(function() {
					if (vm.topLayer && vm.autosave && !vm.noPages) {
						save()
						vm.saved = false
						console.log('10 minutes!')
					}
				}, 600000)

				$rootScope.$on('$locationChangeStart', function() {
					$interval.cancel(autosave)
				})

				async function save() {
					vm.saving = true
					vm.saveSuccess.message = 'Product Saved'
					vm.saveSuccess.color = '#9dba8c'

					if(!vm.noPages) preventNav(false)
					getTopLayer(true)

					if(vm.quillActive) await domHelpers.saveDOMReset(vm.quillActive)
					if(vm.quillActive) await helpers.applyWhenElementExists($('.quill'), disableQuill, 50, 40)
					if(vm.layersAccessed) {
						getThemeEdits()
						vm.layersAccessed = false
					}
					$compile($('.outlines'))(vm)

					if (canAlterPages()) {
						$.each($('.product .printedarea'), function(index, value) {
							$.each($(this).find('textarea'), function() {
								$(this).html($(this).val())
							})
							let changeLeft = false
							if($(this).css('left') == '0px') {
								changeLeft =  true
								$(this).css('left', '50%')
							}
							vm.pages[index].template = $(this).prop('outerHTML').replace(/transform:.*scale\((?=.{0,10}\)).+?\)/g, '').replace(/left: '0px'/g, 'left: "50%"')
							vm.pages[index].page_number = parseInt(index) + 1
							let payload = Object.assign({}, vm.pages[index])
							let id = payload.id
							delete payload.id
							delete payload.archived
							pages.updateOrderPage(id, payload).then(response => {
								if(response.status != 200) {
									vm.saveSuccess.message = 'Save Failed'
									vm.saveSuccess.color = '#d97d6e'
								}
							})
							changeLeft ? $(this).css('left', '0px') : $(this).css('left', '50%')

						})
					}
					else {
						$.each($('.product .printedarea'), function(index, value) {
							$.each($(this).find('textarea'), function() {
								$(this).html($(this).val())
							})
							let changeLeft = false
							if($(this).css('left') == '0px') {
								changeLeft =  true
								$(this).css('left', '50%')
							}
							vm.pages[index].template = $(this).prop('outerHTML').replace(/transform:.*scale\((?=.{0,10}\)).+?\)/g, '').replace(/left: '0px'/g, 'left: "50%"')
							var payload = Object.assign({}, vm.pages[index])
							let id = payload.id
							delete payload.id
							delete payload.archived
							pages.updateOrderPage(id, payload).then(response => {
								if(response.status != 200) {
									vm.saveSuccess.message = 'Save Failed'
									vm.saveSuccess.color = '#d97d6e'
								}
							})
							changeLeft ? $(this).css('left', '0px') : $(this).css('left', '50%')
						})
					}

					vm.layout.saved = true
					let layoutPayload = Object.assign({}, vm.layout)
					delete layoutPayload.id
					delete layoutPayload.layout_id
					delete layoutPayload.product_id
					delete layoutPayload.funeral_home_id
					delete layoutPayload.order_product_details_id
					delete layoutPayload.archived
					orderLayouts.update(vm.layout.id, layoutPayload).then(response => {
						vm.saving = false
						vm.saved = true
						if(response.status != 200) {
							vm.saveSuccess.message = 'Save Failed'
							vm.saveSuccess.color = '#d97d6e'
						}
						vm.changeMade = false
						$timeout(() => {
							vm.saved = false
						}, 3000)
						$('.ql-tooltip').css('display', '')
						$('.ql-clipboard').css('display', '')
					})
				}

				function navLock() {
					// prevent the browser from navigating if there are unsaved changes
					const navCheck = $rootScope.$on("$locationChangeStart", function (event) {
							if (vm.changeMade && window.location.hostname == 'localhost') {
								clearUnload()
								return
							} else if (vm.changeMade) {
								if(confirm("Are you sure you want to go back? Unsaved changes will be lost")) {
									clearUnload()
									return
								} else {
									vm.changeMade = false;
									if (!vm.changeMade) setTimeout(() => vm.changeMade = true, 1000)
									event.preventDefault()
								}
							} else {
								return
							}
					});
					$rootScope.$on("$destroy", () => navCheck())
				}

				function noPageNavLock() {
					// prevent the browser from navigating if there are no pages
					const pageCheck = $rootScope.$on("$locationChangeStart", function (event) {
						if (vm.noPages) {
							noPageAlert()
							if (!vm.changeMade) setTimeout(() => vm.changeMade = true, 1000)
							event.preventDefault()
							return
						} else {
							return
						}
					});
					$rootScope.$on("$destroy", () => pageCheck())
				}

				function preventNav (prevent) {
					if (vm.changeMade && window.location.hostname == 'localhost') {
						clearUnload()
					} else {
						if (prevent) {
							window.onbeforeunload = function() {
								return ""
							}
						} else {
							window.onbeforeunload = null
							window.onunload = null
						}
					}
				}

				function clearUnload () {
					vm.changeMade = false
					window.onbeforeunload = null
					window.onunload = null
				}

        function undoChanges() {
					if($(vm.selected.element).hasClass('quill')) {
						vm.quill.history.undo()
					} else if (vm.undoStates.length && vm.undoIndex >= 0 && vm.undoIndex < vm.undoStates.length) {

						if(vm.startUndo) {
							vm.undoIndex = vm.undoStates.length - 2
						} else if(vm.undoIndex >=1 ){
							vm.undoIndex -= 1
						}
            var html = $compile(vm.undoStates[vm.undoIndex])(vm)
            if (html) {
              $('.product').html('')
              $('.product').append(html)
              $('.focused .resizer, .focused .rotator, .focused .deletor').css('display', 'none')
              if ($('.theme').css('display', 'none')) {
                $('.theme').css('display', 'block')
                vm.activeBackground = true
              } else {
                $('.theme').css('display', 'none')
                vm.activeBackground = false
              }
              dom.deselectElements()
							getUndoable()
							vm.startUndo = false
            }
          }
        }

				function redo() {
					if($(vm.selected.element).hasClass('quill')) {
						vm.quill.history.redo()
					} else if (vm.undoStates.length && vm.undoIndex >= 0 && vm.undoIndex < vm.undoStates.length -1) {
						vm.undoIndex += 1
            let html = $compile(vm.undoStates[vm.undoIndex])(vm)
            if (html) {
              $('.product').html('')
              $('.product').append(html)
              $('.focused .resizer, .focused .rotator, .focused .deletor').css('display', 'none')
              if ($('.theme').css('display', 'none')) {
                $('.theme').css('display', 'block')
                vm.activeBackground = true
              } else {
                $('.theme').css('display', 'none')
                vm.activeBackground = false
              }
							vm.redoState = true
              dom.deselectElements()
							getUndoable()
            }
          }
				}

        function promptExit() {
					if (!vm.changeMade && !vm.noPages) {
						$location.path(`order/${vm.order.id}/${vm.order.case_id}`)
					} else if (window.location.hostname == 'localhost' && vm.changeMade) {
						clearUnload()
						$location.path(`order/${vm.order.id}/${vm.order.case_id}`)
					} else {
						if (vm.noPages) {
							noPageAlert()
						} else {
							if(confirm("Are you sure you want to go back? Unsaved changes will be lost")) {
								clearUnload()
								$location.path(`order/${vm.order.id}/${vm.order.case_id}`)
							} else {
								return
							}
						}
					}
				}
				
				function noPageAlert() {
					alert("Exiting with no pages could prevent this print package from loading in the future")
				}

        function backToOrder() {
          $('#exit-modal').modal('hide')
					$location.path(`order/${vm.orderId}`)
        }

        function videoRedirect() {
					$location.path('support')
        }

				function openTemplateModal() {
					if(!vm.noPages) {
						disableQuill()
						getTopLayer()
						$('#template-modal').modal('show')
						$rootScope.$broadcast('template')
					} else {
						alert('Please add a page before switching or saving layouts')
					}
				}

				// Quill

				function regStyle() {
					vm.regApply = true
					var length = vm.quill.getLength()

					vm.quill.setSelection(0, length)
					let reg_class = '.' + vm.regClass
					const format = vm.quill.getFormat()

					$(reg_class).each(function(){
						if($(this).hasClass('oldQuill')) {
							$(this).find('p, span, cite').each(function(index, item){
								if(format.font) {
									$(item).removeClass((index, className) => {
    								return (className.match(/\bql-font-([^\s]+)/g) || []).join(' ');
									});
									$(item).addClass(`ql-font-${format.font}`)
								}
								if(format.color) {
									$(item).removeClass((index, className) => {
    								return (className.match(/\bql-color-([^\s]+)/g) || []).join(' ');
									});
									$(item).addClass(`ql-color-${format.color}`)
								}
								if(format.size) {
									$(item).css('font-size', format.size)
								}
								if(format.line) {
									$(item).css('line-height', format.line)
								}
								if(format.weight) {
									$(item).removeClass((index, className) => {
    								return (className.match(/\bql-weight-([^\s]+)/g) || []).join(' ');
									});
									$(item).addClass(`ql-weight-${format.weight}`)
								}
								if(format.align) {
									$(item).css('text-align', format.align)
								} else {
									$(item).css('text-align', '')
								}
							})
						} else {
							if(format.font) {
								let font = format.font.replace(/([A-Z])/g, ' $1').replace('F G', 'FG').replace(/^./, function(str){ return str.toUpperCase(); })
								$(this).css('font-family', font)
							}
							if(format.color) {
								$(this).css('color', `#${format.color}`)
							}
							if(format.size) {
								$(this).css('font-size', format.size)
							}
							if(format.line) {
								$(this).css('line-height', format.line)
							}
							if(format.align) {
								$(this).css('text-align', format.align)
							} else {
								$(this).css('text-align', '')
							}
							if(format.weight) {
								if (format.weight == 'Normal') $(this).css('font-weight', '500')
								if (format.weight == 'Bold') $(this).css('font-weight', '800')
								if (format.weight == 'Italic') $(this).css('font-weight', '600')
								if (format.weight == 'BoldItalic') $(this).css('font-weight', '700')
							}
						}
					})
				}

				function setQuillOptions() {
					let fontNames = []
					let spacedFontNames = []
					for (let font in helpers.fonts) {
						fontNames.push(helpers.fonts[font].name.replace(/[' ']/g, ''))
						spacedFontNames.push(helpers.fonts[font])
					}
					const fontSize = domHelpers.fontSizes
					const linestyle = domHelpers.lineStyles
					const weightStyle = ['Normal', 'Bold', 'BoldItalic', 'Italic']
					const colors = vm.coloroptions.palette.join().replace(/#/g, '').split(',')
					const Parchment = window.Quill.import('parchment')

					let lineHeightStyle = new Parchment.Attributor.Style('line', 'line-height', {
  					scope: Parchment.Scope.BLOCK,
  					whitelist: domHelpers.lineStyles
					});

					let widthStyle = new Parchment.Attributor.Style('width-style', 'width', {
  					scope: Parchment.Scope.INLINE,
  					whitelist: ['100%', '50%']
					});

					let configW = {
						scope: Parchment.Scope.INLINE,
 						whitelist: ['Normal', 'Bold', 'BoldItalic', 'Italic']
					}
					let fontWeightStyle = new Parchment.Attributor.Class('weight', 'ql-weight', configW)

					let BlockEmbed = Quill.import('blots/block/embed');

					class ImageBlot extends BlockEmbed {
					  static create(value) {
					    let node = super.create();
					    node.setAttribute('alt', value.alt);
					    node.setAttribute('src', value.url);
					    return node;
					  }

					  static value(node) {
					    return {
					      alt: node.getAttribute('alt'),
					      url: node.getAttribute('src')
					    };
					  }
					}
					ImageBlot.blotName = 'image';
					ImageBlot.tagName = 'img';

					let BaseImageFormat = Quill.import('formats/image');
					const ImageFormatAttributesList = [
					    'alt',
					    'height',
					    'width',
					    'style',
							'data-caseimage',
							'data-edited',
							'data-feathered',
							'data-cropped',
							'data-oval',
							'data-square'
					];

					class ImageFormat extends ImageBlot {
					  static formats(domNode) {
					    return ImageFormatAttributesList.reduce(function(formats, attribute) {
					      if (domNode.hasAttribute(attribute)) {
					        formats[attribute] = domNode.getAttribute(attribute);
					      }
					      return formats;
					    }, {});
					  }
					  format(name, value) {
					    if (ImageFormatAttributesList.indexOf(name) > -1) {
					      if (value) {
					        this.domNode.setAttribute(name, value);
					      } else {
					        this.domNode.removeAttribute(name);
					      }
					    } else {
					      super.format(name, value);
					    }
					  }
					}
					ImageFormat.className = 'caseImage';

					const Font = Quill.import('attributors/class/font');
					const SizeStyle = Quill.import('attributors/style/size');
					const alignStyle = Quill.import('attributors/style/align');
					const color = Quill.import('attributors/class/color')
					const bgcolor = Quill.import('attributors/class/background')

					Font.whitelist = fontNames
					SizeStyle.whitelist = fontSize
					color.whitelist = colors
					colors.push('false')
					bgcolor.whitelist = colors
					lineHeightStyle.whitelist = linestyle
					fontWeightStyle.whitelist = weightStyle

					Quill.register(ImageBlot, true);
					Quill.register(ImageFormat, true);
					Quill.register(fontWeightStyle, true)
					Quill.register(SizeStyle, true);
					Quill.register(Font, true);
					Quill.register(lineHeightStyle, true);
					Quill.register(widthStyle, true);
					Quill.register(alignStyle, true)
					Quill.register(color, true)
					Quill.register(bgcolor, true)
					Quill.register('modules/placeholder', PlaceholderModule.default(Quill))

					let placeholders = []
					let placeFields = []
					for(let field in vm.case) {
						if (
							(vm.case[field] == null || 
								vm.case[field] == 'undefined' || 
								vm.case[field] == []  || 
								field == 'services' || 
								field == 'additional_family' || 
								field == 'personal_images' || 
								field == 'editable_case_id' || 
								field == 'id' || 
								field == 'archived' || 
								vm.case[field] == false || 
								vm.case[field] == true) && 
								field != 'age_months' && 
								field != 'age_days' && 
								field != 'age_years') {
							continue
						} else if (typeof vm.case[field] === 'string' || typeof vm.case[field] === 'number') {
							placeholders.push(`case.${field}`)

							var obj = {
								label: `case.${field}`,
								id: `case.${field}`,
								casefield: `case.${field}`
							}
							if(field.indexOf('date') != -1) {
								obj.label = `case.${field}`
							}
							placeFields.push(obj)
						} else if(!field.includes('justServices') && !field.includes('visitations') && !field.includes('other_family') && !field.includes('preceded_by') && !field.includes('family_groups') && !field.includes('us_stations')) {
							placeholders.push(`case.${field}`)
							let fieldArray = vm.case[field].map((item, index) => {
								return `case.${field}[${index}]`
							})
							var obj = {
								id: `case.${field}`,
								caseinfo: `case.${field}`,
								multiField: fieldArray,
								multi: true
							}
							placeFields.push(obj)
							
							placeholders.push(`${field}_columns`)
							var obj = {
								id: `${field}_columns`,
								caseinfo: 'case.' + field + '[0]',
								multiField: fieldArray,
								columns: true,
								multi: true
							}
							placeFields.push(obj)

						} else if(field.includes('justServices') || field.includes('visitations')) {
							vm.case[field].map((service, index) => {
								placeholders.push(`case.${field}[${index}]`)

								let arr = [[`case.${field}[${index}].location`, `case.${field}[${index}].city`, `case.${field}[${index}].state`, `case.${field}[${index}].date`, `case.${field}[${index}].time`]]
								let obj = {
									id: `case.${field}[${index}]`,
									caseinfo: `case.${field}[${index}]`,
									serviceField: arr,
									multi: 'object'
								}
								document.styleSheets[0].addRule(`.ql-picker .ql-picker-label[data-value='${obj.id}']::before,  .ql-picker .ql-picker-item[data-value='${obj.id}']::before`,`content: "${field.includes('Services') ? `Service ${vm.case[field][index].date}` : `Visitation ${vm.case[field][index].date}`}" !important;`);
								placeFields.push(obj)
								return true;
							})
							
						} else if (field.includes('other_family') || field.includes('preceded_by')) {
							if(!field.includes('combined')) {

								// placeholders.push(`case.${field}`)

								// let objectArray = vm.case[field].map((service, index) => {
								// 	return [`case.${field}[${index}].name`,`case.${field}[${index}].relation`]
								// })
								
								// var obj = {
								// 	id: `case.${field}`,
								// 	caseinfo: `case.${field}`,
								// 	serviceField: objectArray.reverse(),
								// 	multi: true,
								// }
								// placeFields.push(obj)

								// placeholders.push(`${field}_columns`)
								// var obj = {
								// 	id: `${field}_columns`,
								// 	caseinfo: `case.${field}`,
								// 	serviceField: objectArray,
								// 	multi: true,
								// 	columns: true
								// }
								// placeFields.push(obj)
							} else {
								placeholders.push(`case.${field}`)
								let fieldArray = vm.case[field].map((item, index) => {
									return `case.${field}[${index}]`
								})
								var obj = {
									id: `case.${field}`,
									caseinfo: `case.${field}`,
									multiField: fieldArray,
									multi: true
								}
								placeFields.push(obj)
								
								placeholders.push(`${field}_columns`)
								var obj = {
									id: `${field}_columns`,
									caseinfo: 'case.' + field + '[0]',
									multiField: fieldArray,
									columns: true,
									multi: true
								}
								placeFields.push(obj)
							}
						} else if(field.includes('family_groups')) {
							vm.case.family_groups.map((group, index) => {
								const group_index = index

								placeholders.push(`case.${field}[${group_index}].items_combined`)

								let fieldArray = vm.case.family_groups[group_index].items_combined.map((item, index) => {
									const item_index = index
									return `case.family_groups[${group_index}].items_combined[${item_index}]`
								})
								
								const obj1 = {
									id: `case.${field}[${group_index}].items_combined`,
									caseinfo: `case.${field}`,
									multiField: fieldArray,
									multi: true
								}
								placeFields.push(obj1)

								document.styleSheets[0].addRule(`.ql-picker .ql-picker-label[data-value='${obj1.id}']::before,  .ql-picker .ql-picker-item[data-value='${obj1.id}']::before`,`content: "${vm.case[field][group_index].type}" !important;`);
								
								placeholders.push(`case.${field}[${group_index}].items_combined_columns`)
								const obj2 = {
									id: `case.${field}[${group_index}].items_combined_columns`,
									caseinfo: 'case.' + field + '[0]',
									multiField: fieldArray,
									columns: true,
									multi: true
								}
								placeFields.push(obj2)

								document.styleSheets[0].addRule(`.ql-picker .ql-picker-label[data-value='${obj2.id}']::before,  .ql-picker .ql-picker-item[data-value='${obj2.id}']::before`, `content: "${vm.case[field][group_index].type} Columns" !important;`);
							})
						} else if(field.includes('us_stations')) {
							vm.case[field].map((station, index) => {
								placeholders.push(`case.${field}[${index}]`)
								let arr = [`case.${field}[${index}].station_name`,`case.${field}[${index}].departure_date`, `case.${field}[${index}].departure_place`, `case.${field}[${index}].return_date`, `case.${field}[${index}].return_place` ]
								let obj = {
									id: `case.${field}[${index}]`,
									caseinfo: `case.${field}[${index}]`,
									station: true,
									multiField: arr,
									multi: true
								}
								document.styleSheets[0].addRule(`.ql-picker .ql-picker-label[data-value='${obj.id}']::before,  .ql-picker .ql-picker-item[data-value='${obj.id}']::before`,`content: "Station: ${vm.case[field][index].station_name}" !important;`);
								placeFields.push(obj)
								return true;
							})
							
						}

						//end of vm.case for loop:
					}
					for (let i in vm.customFields) {
						placeholders.push(`customFields[${i}].field_value`)

						var obj = {
							label: `customFields[${i}].field_value`,
							id: `customFields[${i}].field_value`,
							casefield: `customFields[${i}].field_value`
						}

						document.styleSheets[0].addRule(`.ql-picker .ql-picker-label[data-value='${obj.label}']::before,  .ql-picker .ql-picker-item[data-value='${obj.label}']::before`,`content: "${vm.customFields[i].field_title}" !important;`);

						placeFields.push(obj)
					}

					/* The following three map functions generate the displayed values
							in the quill dropdown */

					spacedFontNames.map(font => {
						document.styleSheets[0].addRule(`.ql-picker.ql-font .ql-picker-label[data-value='${font.name.replace(/[' ']/g, '')}']::before,  .ql-picker.ql-font .ql-picker-item[data-value='${font.name.replace(/[' ']/g, '')}']::before`,
								`content: ${font.language ? `'${font.name} (${font.language})'` : `'${font.name}'`} !important;
								font-family: ${font.name};`),
						document.styleSheets[0].addRule(`.ql-font-${font.name.replace(/[' ']/g, '')}`,
								`font-family: ${font.name} !important;`)
					})

					fontSize.map(num => {
						document.styleSheets[0].addRule(`.ql-picker.ql-size .ql-picker-label[data-value='${num}']::before,  .ql-picker.ql-size .ql-picker-item[data-value='${num}']::before`,
							`content: '${num}' !important;`)
					})

					linestyle.map(num => {
						document.styleSheets[0].addRule(`.ql-picker.ql-line .ql-picker-label[data-value='${num}']::before,  .ql-picker.ql-line .ql-picker-item[data-value='${num}']::before`,
						  	`content: '${num}' !important;`)
					})

					linestyle.map(num => {
						const dashNum = num.toString().replace('.', '-')
						document.styleSheets[0].addRule(`.ql-line-height-${dashNum}em`, `line-height: ${num} !important`)
					})


					PlaceholderModule.whitelist = placeholders

					vm.quillToolBar = [
						[{'weight': weightStyle}, 'underline', 'strike'],
						[{ 'size': fontSize }],
						[{ 'font': fontNames }],
						[{'line': linestyle}],
						[{ 'color': colors }],
						[{ align: '' }, { align: 'right' }, { align: 'center' }, { align: 'justify' }],
						[{'placeholder': placeholders}],
						['image'],
						['undo'],
						['redo'],
						['clean'],
					];

					vm.quillOptions = {
						modules: {
							toolbar: {
								container: vm.quillToolBar,
								handlers: {
									'undo': function () {
										let range = vm.quill.getSelection();
			  							if (range) {
												if(vm.quill.history.stack.undo.length <= 1) {
													//vm.quill.history.undo()
												} else if(vm.quill.history.stack.undo.length >= 2) {
			    								vm.quill.history.undo()
												}
			  							}
									},
									'redo': function() {
										let range = vm.quill.getSelection();
			  							if (range) {
			    							vm.quill.history.redo()
			  							}
									},
									'image': imageHandler,
								}
							},
							placeholder: {
								delimiters: ['[{{', '}}]'],
								className: 'ql-data-content',
								placeholders: placeFields
							},
							imageResize: {
								modules: ['Resize', 'Toolbar']
							},
						},
						theme: 'snow',
						imageHandler: imageHandler,
						bounds: '.quill'
					}



					function imageHandler() {
						$rootScope.$broadcast('deceasedIMG')
					}

				}

				async function insertToEditor(url, index) {
					let range = vm.quill.getSelection(true);
					vm.quill.insertText(range.index, '\n', Quill.sources.USER);
					vm.quill.insertEmbed(range.index + 1, 'image', url)

					/* Add data-caseimage to element so the printing functions in the
					    order are able to discern them as images. */
					const elem = $('#editor .product .ql-editor .caseImage')
					const addAttribute = () => {
						elem.attr('data-caseimage', `${index}`)
						if(elem.attr("src") === url.url){
							elem.attr('data-caseimage', `${index}`);
						}
					}
					await helpers.applyWhenElementExists(elem, addAttribute, 50, 40)
				}

				function newQuill(para) {
					vm.quillActive = true
					$('div.tooltip').remove()
					let parent = $(para).parent()
					if(!$(parent).hasClass('custom-verse-content')) {
						vm.$apply()
					}
					setQuillOptions()

					$('#editor .printedarea').css('overflow', 'visible')
					$('#editor .outlines').css('overflow', 'visible')
					$('#editor .product').css('margin-bottom', '90px')
					$('#editor .product').css('height', '90%')

		      $('#editor .product .ql-editor p').each(function(){
		        $(this).removeAttr('elastic')
		        $(this).css('height', 'auto')
					})


	        let style = $(para).attr('style')
	        let left = $(para).css('left')
	        let top = $(para).css('top')
	        let width = $(para).css('width')
	        let height = $(para).css('height')
	        let font = $(para).css('font-family')
					let color = $(para).css('color')
					let align = $(para).css('text-align')
	        let fontSize =  $(para).css('font-size')
	        let fontWeight =  $(para).css('font-weight')
					let backC = $(para).css('background-color')
					let line = $(para).css('line-height')

					vm.regClass = null

					if($(para).hasClass('large-header')) {
						vm.regClass = 'large-header'
					} else if($(para).hasClass('medium-header')) {
						vm.regClass = 'medium-header'
					} else if($(para).hasClass('small-header')) {
							vm.regClass = 'small-header'
					} else if($(para).hasClass('verse-body')) {
							vm.regClass = 'verse-body'
					} else if($(para).hasClass('casefield-body')) {
							vm.regClass = 'casefield-body'
					}

	        let par = $compile('<div class="quill element" data-type="text" ></div>')(vm)[0]

					if($(parent).hasClass('custom-verse-content')) {
						$(par).insertBefore('.custom-verse-reference')
						$(".quill").addClass('custom-verse-text')
						$(".quill").removeClass('double-clicked')
						if(font == 'Helvetica' || font == 'Lato') font = 'Century Gothic'
					} else {
						if(vm.regClass) $(par).addClass(vm.regClass)
						$(parent).append(par)
					}

	        vm.quill = new Quill(".quill", vm.quillOptions)

					$('.ql-undo').append('<i class="glyphicon glyphicon-share-alt reverse">')
					$('.ql-redo').append('<i class="glyphicon glyphicon-share-alt ">')

					let headerButton = $compile('<span class="ql-formats"><button type="button"  class="ql-regStyle" ng-click="regStyle(); regApply = !regApply"><i ng-click="regStyle()"  class="glyphicon glyphicon-share "></i></button></span>')(vm)

					if($('.quill').hasClass(vm.regClass)) {
		        $('.ql-toolbar').append(headerButton)
						vm.$apply()
		      }

					$('.quill').removeAttr('uib-tooltip', 'Double-Click to Edit')
					$('.quill').removeAttr('tooltip-placement', 'top')
					$('.quill').removeAttr('tooltip-trigger', 'outsideClick')

					quillService.bubbleTooltips().then(
						$compile($('.ql-toolbar'))(vm)
					)

					if($('.quill').hasClass('custom-verse-text')) {
						$('.quill').css('position', 'relative !important')
						$('.quill').css('margin', '0px auto !important')
						$('.quill').css('font-family', font)
					} else {
						$(vm.quill.container).css({
		          'z-index': 10,
		          'width': width,
		          //'height': 'auto',
		          'position': 'absolute',
		          'left': left,
		          'top': top,
		          'font-family': font,
							'color': color,
							'font-size': '1em',
							'padding': '0px 0px !important',
		        })
					}
					if(!$(parent).hasClass('custom-verse-content')) {
						$(vm.quill.container).css({
							'height': 'auto'
						})
					}
	        $('.quill p').remove()
					let parAr = $(para).html().split('<br>')
					$('.quill .ql-editor').css({
						'font-family': font,
						'font-Size': fontSize,
						'color': color,
						'background-color': backC,
						'padding': '0px 0px !important',
					})
					let zoomIn = vm.scale > 1 ? (Math.round(vm.scale*2)/2).toFixed(1) : (Math.round(vm.scale*5)/5).toFixed(1)
					top = parseInt($('.quill')[0].offsetTop)
					left = parseInt($('.quill')[0].offsetLeft)
					let offsetTop = 110
					let offsetLeft

					let topModifier = {
						'0.4' : -80,
						'0.6' : -55,
						'0.8' : -25,
						'1.0' : 0,
						'1.5' : 15,
						'2.0' : 25,
						'2.5' : 30,
						'3.0' : 35,
						'3.5' : 37,
						'4.0' : 40
					}

					let leftModifier = {
						'0.4' : 0,
						'0.6' : 0,
						'0.8' : 0,
						'1.0' : 0,
						'1.5' : -60,
						'2.0' : -100,
						'2.5' : -120,
						'3.0' : -140,
						'3.5' : -140,
						'4.0' : -140
					}

					left = left + leftModifier[zoomIn]
					top  = top  + topModifier[zoomIn]

					if(left < 50) {
						 offsetLeft = vm.scale == 1 ? 50 : 75
					 } else if(left > 500) {
						 offsetLeft = vm.scale == 1 ? 275 : 275
					 } else {
						 offsetLeft = 75
					 }
					$('.ql-toolbar').css({
						'background-color': 'white',
						'z-index': 15,
						'transform': `scale(${1/vm.scale})`,
						top: top - offsetTop + 'px',
						left: left - offsetLeft + 'px',
					})
					$('.ql-snow .ql-font .ql-picker-label').attr('data-value', font.replace(/(")/g, '').replace(/[' ']/g, ''))

					vm.quillWeights = quillService.fontWeightSet(helpers.fonts, true)

					$compile($('.ql-snow .ql-weight')[0])(vm)

					$.fn.toEm = function(settings){
						settings = jQuery.extend({
							scope: 'body'
						}, settings);
						var that = parseInt(this[0],10),
							scopeTest = jQuery(`<div style="display: none; font-size: ${fontSize}; margin: 0; padding:0; height: auto; line-height: 1; border:0;">&nbsp;</div>`).appendTo(settings.scope),
							scopeVal = scopeTest.height();
						scopeTest.remove();
						return (that / scopeVal).toFixed(1);
					};

					for( let p in parAr) {
						var newpara = $compile(`<p><span style="font-size: ${fontSize};" class="ql-font-${font.replace(/(")/g, '').replace(/[' ']/g, '')} ql-weight-Normal">` + parAr[p] + `</span></p>`)(vm)

						$('.quill .ql-editor').append(newpara)

						$(newpara).css({
		          left: '',
		          'z-index': 12,
		          top: '',
		          height: 'auto !important',
		          position: '',
		          'line-height': $(parseInt(line)).toEm(),
							'font-family': 'inherit',
							'font-Size': 'inherit',
							'color': 'inherit',
							'text-align': align,
						})
						$(newpara).addClass('ql')
						quillService.presetOptions()
						if(fontWeight == 800) {
							$(newpara).children().addClass("ql-weight-Bold")
						} else if(fontWeight == 500) {
							$(newpara).children().addClass("ql-weight-Normal")
						} else if(fontWeight == 700) {
							$(newpara).children().addClass("ql-weight-Bold-Italic")
						} else if(fontWeight == 600) {
							$(newpara).children().addClass("ql-weight-Italic")
						}
					}

					$(para).remove()
					$compile($('.quill'))(vm)
					$('.quill .ql-editor p').selectText()
					$(document).bind('mousedown')
					$(document).bind('mousemove')
					vm.selected.element = $('.quill')
					quillChange()
				}

				$('#editor').on('click','.ql-font .ql-picker-options .ql-picker-item' , function() {
					vm.quillWeights = quillService.fontWeightSet(helpers.fonts)
					$compile($('.ql-snoq .ql-weight')[0])(vm)
					if(!vm.quillWeights.weight) vm.quill.format('font-weight', '500')
				})

				$('#editor').on('click','.ql-placeholder .ql-picker-options .ql-picker-item[data-value="case.date_of_death"]' , function() {
					$('.quill').find('.ql-data-content[data-id="case.date_of_death"]').each(function() {
						$(this).data('id', "case.date_of_death | date: 'longDate'")
						$(this).data('label', "case.date_of_death | date: 'longDate'")
					})
					vm.$apply()
				})

				$('#verse-modal').on('click','.ql-font .ql-picker-options .ql-picker-item' , function() {
					vm.quillWeights = quillService.fontWeightSet(helpers.fonts)
					$compile($('.ql-snow .ql-weight')[0])(vm)
					if(!vm.quillWeights.weight) vm.quill.format('font-weight', '500')
				})

				const setTemplateListener = $rootScope.$on('setTemplate', function(event) {
					// $('.oldQuill').each(function() {
					// 	enableQuill($(this), true)
					// 	disableQuill(true)
					// })
				})

				scope.$on('$destroy', () => setTemplateListener())

				function enableQuill(quill, template) {
					console.log(`%c quill enabled`, "color: gray; font-weight: bold; font-style: italic");
					vm.quillActive = true
					let paragraphFontSizes = []
					$('div.tooltip').remove()

					setQuillOptions()
					let orgQuill = quill

					$(quill).removeClass('oldQuill')
					$(quill).addClass('quill')

					let font = $('.quill .ql-editor').css('font-family')
					let color = $('.quill .ql-editor').css('color')
					let align = $('.quill .ql-editor').css('text-align')
					let fontSize =  $('.quill .ql-editor').css('font-size')
					let backC = $('.quill .ql-editor').css('background-color')

					vm.regClass = null

					if($('.quill').hasClass('large-header')) {
						vm.regClass = 'large-header'
					} else if($('.quill').hasClass('medium-header')) {
						vm.regClass = 'medium-header'
					} else if($('.quill').hasClass('small-header')) {
							vm.regClass = 'small-header'
					} else if($('.quill').hasClass('verse-body')) {
							vm.regClass = 'verse-body'
					} else if($('.quill').hasClass('casefield-body')) {
							vm.regClass = 'casefield-body'
					}

					$('#editor .printedarea').css('overflow', 'visible')
					$('#editor .outlines').css('overflow', 'visible')
					$('#editor .product').css('margin-bottom', '90px')
					$('#editor .product').css('height', '90%')

					if($('.quill').parents('.product').length > 0) {
						$('.quill').removeClass('custom-verse-text')
						$('.quill').removeClass('custom-verse-preview')
					}
					
					$('.quill .ql-editor p').each(function(index){
						paragraphFontSizes.push($(this).css('font-size'))
					})
					vm.quill = new Quill(".quill", vm.quillOptions)
					 
					$('.quill').removeAttr('uib-tooltip', 'Double-Click to Edit')
					$('.quill').removeAttr('tooltip-placement', 'top')
					$('.quill').removeAttr('tooltip-trigger', 'outsideClick')

					quillService.bubbleTooltips().then(
						$compile($('.ql-toolbar'))(vm)
					)

					$('.quill .ql-editor').find('p').each(function(){
						let line = $(this)[0].style.cssText.indexOf('line-height')

						if(line == -1) {
							$(this).css('line-height', '1.2')
						}
					});

					vm.quill.enable(true)

					$(vm.quill.container).css({
						'z-index': 10,
						// 'height': 'auto',
						'font-size': '1em',
						'font-family': font
					})

					if(!$(vm.quill.container).parent().hasClass('custom-verse-content')) {
						$(vm.quill.container).css({
							'height': 'auto',
						})
					}
					if (font == 'Lato, sans-serif' ) {
						font = 'Century Gothic'
						$(vm.quill.container).css({
							'font-family': font
						})
					}

					let zoomIn = vm.scale > 1 ? (Math.round(vm.scale*2)/2).toFixed(1) : (Math.round(vm.scale*5)/5).toFixed(1)
					let top = parseInt($('.quill')[0].offsetTop)
					let left = parseInt($('.quill')[0].offsetLeft)
					let offsetTop = 110
					let offsetLeft

					let topModifier = {
						'0.4' : -80,
						'0.6' : -55,
						'0.8' : -25,
						'1.0' : 0,
						'1.5' : 15,
						'2.0' : 25,
						'2.5' : 30,
						'3.0' : 35,
						'3.5' : 37,
						'4.0' : 40
					}

					let leftModifier = {
						'0.4' : 0,
						'0.6' : 0,
						'0.8' : 0,
						'1.0' : 0,
						'1.5' : -60,
						'2.0' : -100,
						'2.5' : -120,
						'3.0' : -140,
						'3.5' : -140,
						'4.0' : -140
					}

					left = left + leftModifier[zoomIn]
					top  = top  + topModifier[zoomIn]

					if(left < 50) {
						 offsetLeft = vm.scale == 1 ? 50 : 75
					 } else if(left > 500) {
						 offsetLeft = vm.scale == 1 ? 275 : 275
					 } else {
						 offsetLeft = 75
					 }

					$('.ql-toolbar').css({
						'background-color': 'white',
						'z-index': 15,
						'transform': `scale(${1/vm.scale})`,
						top: top - offsetTop + 'px',
						left: left - offsetLeft + 'px',
					})

					$('.ql-snow .ql-font .ql-picker-label').attr('data-value', font.replace(/(")/g, '').replace(/[' ']/g, ''))

					vm.quillWeights = quillService.fontWeightSet(helpers.fonts, true)
					$compile($('.ql-snow .ql-weight')[0])(vm)

					$('.ql-snow .ql-undo').append('<i class="glyphicon glyphicon-share-alt reverse">')
					$('.ql-snow .ql-redo').append('<i class="glyphicon glyphicon-share-alt ">')

					let headerButton = $compile('<span class="ql-formats"><button type="button"  class="ql-regStyle" ng-click="regStyle(); regApply = !regApply"><i ng-click="regStyle()"  class="glyphicon glyphicon-share "></i></button></span>')(vm)

					if($('.quill').hasClass(vm.regClass)) {
						$('.ql-toolbar').append(headerButton)
						//this apply isn't necessary to place the button on the page and causes a logjam on the template saves. leave in commented out until 6-6-2019 incase we get more problems
						// vm.$apply()
		      }

					$('.quill .ql-editor').css({
						'color': color,
						'background-color': backC
					})

					$('.quill .ql-editor p').each(function(index) {
						const element = $(this)
						formatQuillText({ font, fontSize, paragraphFontSizes, index, element })
					})

					formatQuillCites()

					$('.ql-editor p').find('cite[data-multi=true]').each(function(){
						if($(this).data('columns') == true) {
							$(this).css({'width': '50%', 'display': 'inline-block', 'margin': '0px'})
						} else {
							$(this).css('display', 'block')
							$(this).css('width', '100%')
						}
					})

					// if(!template) $compile($('.quill'))(vm)

					$('.quill .ql-editor p').selectText()
					$(document).bind('mousedown')
					$(document).bind('mousemove')
					vm.selected.element = $('.quill')
					let len = vm.quill.getLength()
					$(document).bind('mousedown')
					$(document).bind('mousemove')
					quillChange()
				}

				function formatQuillText(context) {

					const { font, fontSize, paragraphFontSizes, index, element } = context

					if(!element.children().is('span') && !element.children().is('u') && !element.children().is('s')) {
						element.wrapInner(`<span class="ql-font-${font.replace(/(")/g, '').replace(/[' ']/g, '')} ql-weight-Normal" style="font-size: ${fontSize};"></span>`)
						if (element.children().children().prop('outerHTML') == "<br>") {
							element.children().css('font-size', paragraphFontSizes[index])
						}
					} else {

						// checks to see if span has font-size, if not, add it
						const spanHTML = element.children().prop('outerHTML')
						if(!spanHTML.includes('font-size')) {
							element.children().css('font-size', fontSize)
						}

						// checks to see if span has font, if not, add it
						if(!Array.from(element.children()[0].classList).some(c => c.startsWith('ql-font'))) {
							element.children().addClass(`ql-font-${font.replace(/(")/g, '').replace(/[' ']/g, '')}`)
						}

						// checks to see if span has font-weight, if not, add it
						if(!Array.from(element.children()[0].classList).some(c => c.startsWith('ql-weight'))) {
							element.children().addClass(`ql-weight-Normal`)
						}
					}

					element.css({
						'color': 'inherit',
						'font-family': 'inherit',
						'font-size': paragraphFontSizes[index]
					})

					if(!element.hasClass('ql')) element.addClass('ql')
				}

				function formatQuillCites() {

					/* ================================================================================================
					What does formatQuillCites do?
					===================================================================================================

					// case fields with multiple cites will lose their formatting if they are placed next to each other
					// in the same wrapper.

					// the purpose of formatQuillCites is to preserve the structure of multiline cites by giving each
					// cite its own wrapper.
					
					// example of before formatQuillCites:
						// <p>
						// <span>
						// 	<cite></cite>
						// 	<cite></cite>
						// 	<cite></cite>
						// </span>
						// </p>

					// example of after formatQuillCites:
						// 	<p>
						// 		<span>
						// 			<cite></cite>
						// 		</span>
						// 	</p>
						// 	<p>
						// 		<span>
						// 			<cite></cite>
						// 		</span>
						// 	</p>
						// 	<p>
						// 		<span>
						// 			<cite></cite>
						// 		</span>
						// 	</p>
					
					================================================================================================ */

					const cleanCite = cite => {
						let citeWrapper = cite.clone(true).empty()
						let citeText = cite.children().children().text()
						return citeWrapper.text(citeText)
					}

					$('.quill .ql-editor p').find('cite').each(function(){

						const caseinfo = $(this).attr('data-caseinfo')

						if(caseinfo.includes('visitations') || caseinfo.includes('justServices')) {
							let cites     = [],
									newCite   = $('<p></p>'),
									citeFound = true
	
							// checks if the cite has siblings in the same paragraph tag
							if ($(this).siblings().length > 0) {
	
								$(this).siblings().each(function() {
									// if the sibling is not a cite, then move on
									if (!$(this).is('cite')) {
										citeFound = false
									// if the sibling is a cite, then add it to the cite array
									} else {
										cites.push(cleanCite($(this)))
									}
								})
	
							// if not siblings at all are found, move on
							} else {
								citeFound = false
							}
	
							// if multiple cites were found in the same paragraph tag
							if(citeFound) {

								const unwrapElements = element => $compile($(element).children().siblings().unwrap().end().remove())(vm)
								const paragraph = $(this).parent().parent()
								const span = $(this).parent()
	
								// add the current cite to the array that contains the cite's siblings
								cites.unshift(cleanCite($(this)))
	
								// extract the parent wrappers of the cite
								const paragraphWrapper = paragraph.clone(true).empty()
								const spanWrapper = span.clone(true).empty()

								// wrap each cite individually in the wrapper parents, therefore giving each cite its own line
								cites.map((cite, index) => {
									if (cite.attr('data-id').includes('.city') || cite.attr('data-id').includes('.state')) {

										const nextCite = cites[index + 1]

										if(nextCite && nextCite.attr('data-id').includes('.state')) {
											const completeCite = cite.wrap(spanWrapper).parent().wrap(paragraphWrapper).parent()
											cite.after(nextCite)
											newCite.append(completeCite)
										}

									} else {
										const completeCite = cite.wrap(spanWrapper).parent().wrap(paragraphWrapper).parent()
										newCite.append(completeCite)
									}
								})
	
								// replace the existing quill text with the refined text
								paragraph.replaceWith(unwrapElements(newCite))
							}
						}

					})
				}

				// $('#editor, #verse-modal').on('mousedown', '.ql-toolbar', function(e) {
				// 	e.preventDefault()
				// })

				function disableQuill() {
					console.log(`%c quill disabled`, "color: gray; font-weight: bold; font-style: italic");
					const quillEl = $('.quill')
					vm.quillActive = false
					vm.quill && vm.quill.enable(false)
					domHelpers.disableQuillDOM(quillEl)
					setDraggables()
					setMultiSelector()
					setMultiDraggables()
					setCropperDrag()
					setSelectProducts()
					setResizerDrag()
					setRotatorDrag()
					$compile($('.oldQuill'))(vm)
				}

				function quillChange() {
					vm.quill.on('editor-change', function() {
						$('.quill .ql-editor').find('*[class*=ql-weight]').each(function(){
							let match = false
							let weight = $(this).css('font-weight')
							let weightName
							for (let font of helpers.fonts) {
								if (font.name == $(this).css('font-family').replace(/"/g, '')) {
									if(font.weights){
										for (let weights of font.weights) {
											if(weights.weight == $(this).css('font-weight')) {
												match = true
												break;
											}
										}
									}
								}
							}
							if (!match) {
								if(weight == 800) {
									weightName = 'ql-weight-Bold'
								} else if( weight == 700) {
									weightName = 'ql-weight-Bold-Italic'
								} else if( weight == 600) {
									weightName = 'ql-weight-Italic'
								}
								$(this).removeClass(weightName)
							}
						})
						$compile($('.quill'))(vm)
					})
				}

				$('#editor').on('click','.ql-font .ql-picker-options .ql-picker-item' , function() {
					vm.quillWeights = quillService.fontWeightSet(helpers.fonts)
					$compile($('.quill .ql-weight')[0])(vm)
					if(!vm.quillWeights.weight) vm.quill.format('font-weight', '500')
				})

				$('#verse-modal').on('click','.ql-font .ql-picker-options .ql-picker-item' , function() {
					vm.quillWeights = quillService.fontWeightSet(helpers.fonts)
					$compile($('.quill .ql-weight')[0])(vm)
					if(!vm.quillWeights.weight) vm.quill.format('font-weight', '500')
				})

				$('#editor').on('click', '.quill div.imgOverlay, .quill .ql-editor p img', function(e) {
					const obj = e.target
					const selected = $(obj)
					vm.selected = {}
					vm.selected.image = true
					vm.selected.element = obj
					vm.selected.selector = selected
					vm.action_type = 'image'
				})

				$('#editor, #verse-modal').on('mousedown', '.ql-toolbar', function(e) {
					e.preventDefault()
				})

				$('#editor, #verse-modal').on('mouseover', '.ql-container', function(e) {
					repositionToolTip(e)
				})

				$('#editor, #verse-modal').on('mouseover', 'p', function(e) {
					repositionToolTip(e)
				})

				function repositionToolTip(e) {
					// resets the tooltip position to always be above the quill textbox, even when zooming
					setTimeout(function() {
						let quillTop = parseInt($(e.currentTarget).css('top'))
						let quillLeft = parseInt($(e.currentTarget).css('left'))
						let quillWidth = parseInt($(e.currentTarget).css('width'))
						let toolbarHeight = 33
						let toolbarWidth = 124

						$('.tooltip').css({
							'top': `${quillTop - toolbarHeight}px`,
							'left': `${quillLeft + (quillWidth / 2) - (toolbarWidth / 2)}px`,
						})
					}, 10);
				}

				// Asset Bar Actions

				function getPageWidth() {
					dom.getPageWidth()
				}

				scroll.setScrollWidth()
				scroll.pagesScrollLeft()
				scroll.pagesScrollRight()
				scroll.stopPagesScrollLeft()
				scroll.stopPagesScrollRight()
			
        $(document).on('paste', function($event) {
          let text = $clipboard.getText($event)
					text = text.replace(/\r\n|\r|\n/g, "<br/>")

					if (document.queryCommandSupported('insertHTML')) {
						document.execCommand('insertHTML', false, text);
					} else {
						document.execCommand('paste', false, text);
					}
        })

        $('#editor').on('keydown', '.draggable', function(e) {
          if (!$(vm.selected.selector).hasClass('quill') && (e.keyCode === 46 || e.keyCode === 8)) {
            deleteElement()
            $('.focused .resizer, .focused .rotator, .focused .deletor').css('display', 'none')
          }
          return true
        });

        $('#editor').on('keydown', 'p[contenteditable]', function(e) {
					// trap the return key being pressed
          setUndoState()
          //Check width
          let left = parseInt($(vm.selected.element).css('left'))
          let width = parseInt($(vm.selected.element).css('width'))
          let parentWidth = parseInt($(vm.selected.element).parent().css('width'))
          if ((left + width) >= parentWidth) {
            $(vm.selected.element).css('width', (parentWidth - left) + 'px')
          }
        })

				// DEPRECATED?
        function isInternetExplorer() {
          let ua = window.navigator.userAgent;

          let msie = ua.indexOf('MSIE ');
          if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
          }

          let trident = ua.indexOf('Trident/');
          if (trident > 0) {
            // IE 11 => return version number
            let rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
          }

          let edge = ua.indexOf('Edge/');
          if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
          }

          // other browser
          return false;
        }
				// DEPRECATED?
        function addBreakTagsForIE(double) {
          let docFragment = document.createDocumentFragment();
          //add a new line
          let newEle = document.createTextNode('\n');
          docFragment.appendChild(newEle);
          //add the br, or p, or something else
          newEle = document.createElement('br');
          docFragment.appendChild(newEle);
          if (double) {
            docFragment.appendChild(newEle);
          }
          if (double) {
            docFragment.appendChild(newEle);
          }
          //make the br replace selection
          let range = window.getSelection().getRangeAt(0);
          range.deleteContents();
          range.insertNode(docFragment);
          //create a new range
          range = document.createRange();
          range.setStartAfter(newEle);
          range.collapse(true);
          //make the cursor there
          let sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          return false;
        }

        $('#editor, #verse-modal').on('dblclick', 'p[contenteditable]', function(e) {
          if (!$(this).hasClass('double-clicked')) {
						if($(this).hasClass('custom-verse-text') || $(this).hasClass('custom-verse-preview')) {
							newQuill($(this))
						} else if ($(this).hasClass('element') && !$(this).parent().hasClass('ql-editor')) {
							newQuill($(this))
							$('.quill').addClass('double-clicked')
							$(this).addClass('double-clicked')
						}
						$(this).removeClass('draggable')
						$('.product').unbind('mousedown')
						$('.product').unbind('mousemove')
						$('.focused .resizer, .focused .rotator, .focused .deletor').css('display', 'none')
          }
        })

				$('#editor, #verse-modal').on('dblclick', '.oldQuill', function(e) {
					vm.quillActive = true
          if (!$(this).hasClass('double-clicked')) {
						$('.product').unbind('mousedown')
						$('.product').unbind('mousemove')
						if($(this).hasClass('custom-verse-text')) {
							enableQuill($(this))
						} else {
							$(this).addClass('double-clicked')
							$(this).removeClass('draggable')
							$('.product').unbind('mousedown')
							$('.product').unbind('mousemove')
							enableQuill($(this))
							$('.quill').addClass('double-clicked')
						}
            $('.focused .resizer, .focused .rotator, .focused .deletor').css('display', 'none')
          }
        })

				$('#editor').on('dblclick', 'div[data-type="image"]', function(e) {
					vm.undoImageEditStates = []
          showEditImageModal(true)
        })

				$('#editor').on('dblclick', 'img', function(e) {
          vm.undoImageEditStates = []
					const obj = e.target
					const selected = $(obj)
					vm.selected = {}
					vm.selected.image = true
					vm.selected.element = obj
					vm.selected.selector = selected
					vm.action_type = 'image'
          showEditImageModal(true)
        })

				$('#editor').on('click', '.ql-editor img', function(e) {
          vm.undoImageEditStates = []
					const obj = e.target
					const selected = $(obj)
					vm.selected = {}
					vm.selected.image = true
					vm.selected.element = obj
					vm.selected.selector = selected
					vm.action_type = 'image'
        })

        $('#editor').on("click", function($event) {
          if (!$($event.target).hasClass('double-clicked')) {
            $('#editor p, #editor .quill').removeClass('double-clicked')
          }
        })

				$('#editor').on('mousedown', function(e){
					vm.changeMade = true
					navLock()
					preventNav(true)
					if($(e.target).parents('.ql-toolbar').length || $(e.target).parents('.quill').length) {
					} else if(!$(e.target).is('input', ) ){
						if($('.quill').length) {
							disableQuill()
						}
					}
				})

        $(document).on('keydown', function(e) {
          if (e.which === 90 && (e.metaKey || e.ctrlKey)) {
						e.preventDefault();
            undoChanges();
            //not sure the below apply is the best way - but it makes sure the undo button applies the ng-hide as needed.
            vm.$apply();
          }
        })

				$.fn.selectText = function(){
					setUndoState()
					var doc = document
					var element = this[0]
					if(doc.body.createTextRange) {
						var range = document.body.createTextRange()
						range.moveToElementText(element)
						range.select()
					} else if (window.getSelection) {
						var selection = window.getSelection()
						var range = document.createRange()
						range.selectNodeContents(element)
						selection.removeAllRanges()
						selection.addRange(range)
					}

				}

				const socketSaveListener = $rootScope.$on('socketSavePages', (event, payload) => {
					save()
					vm.saved = false
					$('#case-check-modal').modal('show')
				})

				scope.$on('$destroy', () => socketSaveListener())

				function refreshSocket(refresh) {
					if(refresh) {
						getSocket(vm.case.id).then(data => {
							if(data.success) {
								$('#case-check-modal').modal('hide')
								init()
							} else {
								$('#case-check-modal').modal('hide')
								vm.lockedCase = data.message

								$timeout(function(){
									$('#case-locked-modal').modal('show')
								}, 200)
							}
						})
					} else {
						$('#case-check-modal').modal('hide')
						$timeout(function(){
							$location.path('/dashboard')
						}, 200)
					}
				}

				function getSocket() {
					var deferred = $q.defer();
					if(socket.connectedSocket && socket.connectedSocket.connected) {
						socket.emit('check_case_connection', socket.data)
						socket.on('case_connection', function(data){
								deferred.resolve(data)
						})
						return deferred.promise
					}
					else {
						socket.disconnect()
						user.get().then(response => {
							socket.connect()
								vm.socketData = {
									user_id : user.user.id,
									case_id : vm.case.id
								}
								socket.emit('check_case_connection', vm.socketData)
								socket.on('case_connection', function(data){
										deferred.resolve(data)
								})
						})
						return deferred.promise
					}
				}

				function loadSocket() {
					getSocket().then(data => {
						if(data.success) {
							//do NOTHING

						} else {
							$('#case-locked-modal').modal('show')
							vm.lockedCase = data.message
						}
					})
				}

				function lockedConfirm() {
					$('#case-locked-modal').modal('hide')

					$timeout(function(){
						$location.path('/dashboard')
					}, 200)
				}

				$(document).mousedown(() => {
					if(socket.connectedSocket.connected) {
						socket.socketTimer = socket.time
						socket.timeOutConnection()
					}
				})

				function zoomIn() {
					//tyler allen made this centering possible.
					const matrixRegex = /matrix\((-?\d*\.?\d+),\s*0,\s*0,\s*(-?\d*\.?\d+),\s*(-?\d*\.?\d+),\s*0\)/;
					const matches = $('.product .focused').css('transform').match(matrixRegex)
					let zoomWidth = parseInt($('.product .focused').css('width'))
					if(!matches) {
							$('.product .focused').css('transform', 'translateX(-50%) scale(1.1)')
					} else {
						const matches2 = $('.product .focused').css('transform').match(matrixRegex)
						if(parseFloat(matches[1]) < 4) {
							vm.scale = parseFloat(matches2[1]) + 0.1
							zoomWidth = zoomWidth * vm.scale
							let zoom = `translateX(-50%) scale(${vm.scale})`
							if(zoomWidth > parseInt($('.product').css('width'))) {
								$('.product .focused').css('transform-origin', '0 0')
								zoom = `scale(${vm.scale})`
								$('.product .focused').css('left', '0px')
							} else {
								$('.product .focused').css('transform-origin', '')
								$('.product .focused').css('left', '50%')
							}
							$('.product .focused').css('transform', zoom)
							$('#page-shuffler .sheet-content .printedarea').css('transform', 'none')
						}
					}
					getPageLocation()
				}

				function zoomOut() {
					const matrixRegex = /matrix\((-?\d*\.?\d+),\s*0,\s*0,\s*(-?\d*\.?\d+),\s*(-?\d*\.?\d+),\s*0\)/;
					const matches = $('#editor .product .focused').css('transform').match(matrixRegex)
					let zoomWidth = parseInt($('#editor .product .focused').css('width'))
					if(!matches) {
							$('#editor .product .focused').css('transform', 'translateX(-50%) scale(1)')
					} else {
						const matches2 = $('#editor .product .focused').css('transform').match(matrixRegex)
						if(parseFloat(matches[1]) > 0.2) {
							vm.scale = parseFloat(matches[1]) - 0.1
							zoomWidth = zoomWidth * vm.scale
							let zoom = `translateX(-50%) scale(${vm.scale})`
							if(zoomWidth > parseInt($('#editor .product').css('width'))) {
								$('#editor .product .focused').css('transform-origin', '0 0')
								zoom = `scale(${vm.scale})`
								$('#editor .product .focused').css('left', '0px')
							} else {
								$('#editor .product .focused').css('transform-origin', '')
								$('#editor .product .focused').css('left', '50%')
							}
							$('#editor .product .focused').css('transform', zoom)
							$('#page-shuffler .sheet-content .printedarea').css('transform', 'none')
						}
					}
					getPageLocation()
				}

				//******** end *********//
      }

    }
  }

})();
